export const translation ={
    "Footer_Copyright": "由迅维公司提供技术支持",
    "Table_RowsPerPage": "每页行数:",
    "MainMenu_Language": "语言",
    "MainMenu_CandidateLogin": "候选人登录",
    "MainMenu_RecruiterLogin": "雇主登录",
    "Recruiter_Menu_Dashboard": "候选人",
    "Recruiter_Menu_Statistics": "统计",
    "Recruiter_Menu_Settings": "职位及评核",
    "Recruiter_Menu_Settings_old": "职位和视频面试",
    "Recruiter_Menu_Review": "审核面试",
    "Recruiter_Menu_Greeting": "你好, {name}",
    "Recruiter_Menu_Logout": "登出账户",
    "Recruiter_Menu_AccountSetting": "账户设置",
    "Recruiter_Menu_LogoutInProgress": "登出中...",
    "Recruiter_Menu_Greeting_Acting": "你好, {name} (代理)",
    "Recruiter_Menu_Interview_Monitor": "面试监测",
    "Login_HiEmployer": "雇主，您好",
    "Login_HiCandidate": "候选人，您好",
    "Login_welcomeMessage": "欢迎来到 AIA Elite Academy 的视像面試",
    "Login_WelcomeBack": "欢迎使用我们的视频面试及评核系统",
    "Login_EnterYourDetailsBelow": "请输入你的登录信息",
    "Login_EnterYourDetailsBelow_AutoLogin": "在下面输入您的详细信息以注册",
    "Login_EnterYourDetailsBelow_AutoLogin_Message": "请确保您的电子邮件地址正确输入以接收面试报告。",
    "Login_CandidateName": "全名",
    "Login_Email": "电子邮件",
    "Login_ID": "使用者 ID",
    "Login_Enter_OTP": "输入验证码：",
    "Login_OTP_API_Error": "生成 OTP 时出错。请刷新页面并在一段时间后重试。",
    "Login_OTP_Error": "一次性密码不正确。请重新检查",
    "Login_Password": "密码",
    "Login_AccessCode": "登录密码",
    "Login_ForgotPassword": "忘记密码？",
    "Login_RememberMe": "记住我",
    "Login_Login": "登录",
    "Login_Verification_Captcha": "注册",
    "Login_Verification_Email": "在电子邮件中接收验证码",
    "Login_Terms_Prefix": "点击'登录'，即表示你同意接受我们的 ",
    "Login_Terms_Prefix_With_Input": "点击 '{input}'，您同意接受我们的 ",
    "Button_Value_Submit": "注册",
    "Login_Register_Password_Is_Required": "密码是必需的",
    "Login_Register_Password_Min_Length_With_Input": "密码长度必须至少为 {input} 个字符",
    "Login_Terms_Suffix": ".",
    "Login_Terms_Conditions": "条款和条件",
    "Login_Terms_Conditions_Close": "关闭",
    "Login_Terms_Conditions_Content": [
        "<h2>迅维服务条款</h2>",
        "<h3>1. 条款</h3>",
        "<p>通过访问网站 <a href='http://www.neufast.com'>http://www.neufast.com</a>, 你同意受这些服务条款，所有适用法律和法规的约束，并同意你有责任遵守任何适用的当地法律。如果你不同意其中任何一项条款，你将被禁止适用或访问该网站。本网站所含材料受适用的版权法和商标法保护。</p>",
        "<h3>2. 使用许可证</h3>",
        "<ol type='a'>",
        "<li>允许在迅维网站上临时下载一份材料（信息或软件）供个人使用，仅限非商业性临时观看。这是许可证的授予，不是所有权的转移，在这个许可下你不能:",
        "<ol type='i'>",
        "<li>修改或复制材料;</li>",
        "<li>将材料用于任何商业目的或任何公开展示（商业或非商业；</li>",
        "<li>尝试对迅维网站上包含的任何软件进行发编译或反向工程；</li>",
        "<li>删除材料中的任何版权或其他专有标记；或</li>",
        "<li>将材料转移给其他人或\"镜像\"任何其他服务器上的材料。</li>",
        "</ol>",
        "</li>",
        "<li>如果你违反上述任何限制，本许可证将自动终止，迅维可随时终止此许可证。一旦终止查看这些材料或本许可证终止时，你必需销毁所有电子或印刷材料的已下载资料。</li>",
        "</ol>",
        "<h3>3. 免责声明</h3>",
        "<ol type='a'>",
        "<li>迅维网站上的资料按\"原样\"提供。迅维不做任何明示或暗示的保证，并在此否认其他所有保证，包括但不限于对某个特殊目的的适用性或不可侵犯知识产权或其他侵犯权利行为的保证或适用条件。</li>",
        "<li>此外，迅维不保证或就其在互联网网站上使用这些材料的准确性，可能的结果或可靠性或与此类材料或与本网站链接的任何网站有关的任何陈述。</li>",
        "</ol>",
        "<h3>4. 限制</h3>",
        "<p>在任何情况下，迅维或其他供应商将不会因在迅维网站上使用或无法使用这些材料产生任何损害（包括但不限于，因数据或利润损失或由于业务中断造成的损害），即使迅维已经口头或书面通知会发生此类损害。由于某些司法管辖区不允许限制默示担保或对间接损失或附带损失的责任限制，以上排除条款可能不适用于你。</p>",
        "<h3>5. 材料准确性</h3>",
        "<p>出现在迅维网站上的材料可能包括技术，字型设计或照片错误。迅维不保证网站上任何材料的准确性，完整度或更新状态。迅维可随时更改网站上的资料，恕不另行通知。但是，迅维不承诺更新材料。</p>",
        "<h3>6. 连接</h3>",
        "<p>迅维尚未审查与其互联网网站链接的所有网站，并且不对任何连结网站的内容负责。包含该连结并不表示迅维对该网站的认可。使用任何此类连结的风险由用户自行承担。</p>",
        "<h3>7. 修订</h3>",
        "<p>迅维可能会随时修订网站上的服务条款，恕不另行通知。使用本网站即表示你同意遵守当前版本的服务条款。</p>",
        "<h3>8. 适用法律</h3>",
        "<p>这些使用条款和条件受香港法律管辖并依据香港法律进行解释。你将不可撤销地服从该地区法院的专属管辖权。</p>",
        "<h3>9. 一般</h3>",
        "<p>尽管我们一直在尝试执行严格的隐私政策和控制，但此网站尚未经过审核并确认我们完全遵守欧盟的《通用数据保护条例》（GDPR）。欧洲公民和居民的用户在使用我们的服务之前，应了解并同意这一点。</p>",
        "<h3>10. 删除个人资料</h3>",
        "<p>在你关闭用户帐户三个月后，你账户内的姓名，电子邮件地址和登录信息将从我们的系统中删除。非个人信息：例如浏览信息，工作信息，面试问题，视频，分数和评论，将被汇总并存储在我们的系统中，以提高评核和服务质量。</p>",
        "<h3>11. 无权利限制</h3>",
        "<p>本声明中的任何内容均不会限制根据《个人数据（隐私）条例》（PDPO）对数据主体的任何权利</p>"
    ],
    "Login_Privacy_Policy": "私隐政策声明",
    "Login_Privacy_Policy_Close": "关闭",
    "Login_Privacy_Policy_Content": [
        "<h2>私隐政策声明 （PPS）</h2>",
        "<p>Neufast Limited （「本公司」）致力尊重及保障使用者的个人资料，并承诺遵守个人资料私隐专员公署（私隐专员公署）发出的《个人资料（私隐）条例》（「条例」）的保障资料原则及所有相关条文。数据由公司的网站服务 Neufast.com（\"网站\"）收集。本公司的缴费灵是关于与其处理的个人数据有关的隐私政策和惯例的一般声明.</p>",
        "<h3>1。实践声明</h3>",
        "<ol type='a'>",
        "<li>收集以下个人数据：",
        "<ol type='i'>",
        "<li>人事记录，包括用户的姓名、电子邮件、电话号码和简历</li>",
        "<li>评估记录，包括用户的表现，包括文本、音频和视频格式的视频和答案</li>",
        "<li>操作参数，包括IP地址，设备类型，浏览器，操作系统，国家，操作记录和日志.</li>",
        "</ol>",
        "</li>",
        "<li>在使用本网站的过程中，用户可能会披露或被要求提供个人信息和/或数据。为了享受本网站提供的各种服务，用户可能需要向公司提供其个人信息和/或数据。虽然用户没有义务按照网站上的要求提供信息和/或数据，但如果用户未能提供某些服务，公司将无法在网站上提供某些服务</li>",
        "<li>用户特此同意，用户向公司提供的任何信息都是自愿的，并且是准确，真实，最新和完整的。如果不是这种情况或公司有合理的理由怀疑,公司有权取消和/或拒绝向用户提供服务。</li>",
        "</ol>",
        "<h3>2。收集目的</h3>",
        "<ol>",
        "<li>",
        "本公司收集和使用本网站上的信息和数据的目的包括但不限于以下内容：",
        "<ul>",
        "<li>用于向用户提供服务的日常运营;</li>",
        "<li>协助雇主评估候选人是否适合各种工作和行业的职位空缺;</li>",
        "<li>帮助用户提升面试技巧</li>",
        "<li>处理和跟进用户的查询、要求和投诉;</li>",
        "<li>就与用户使用本网站有关的行政通知和通信与用户联系，并回应用户的 询问或请求;</li>",
        "<li>协助公司为未来的营销和推广目的或其他内部目的进行开发;</li>",
        "<li>为方便本公司及/或关联公司将用户的 个人资料用于与提供本公司提供的服务有关的目的;</li>",
        "<li>获取有关用户的统计数据，以分析本网站的使用情况，以帮助其进一步发展以供内部使用;和</li>",
        "<li>帮助改进网站为所述相关目的提供的服务.</li>",
        "</ul>",
        "</li>",
        "<li>如果用户未满18岁，公司强烈建议他/她事先征得对他/她负有父母责任的人的同意，例如父母或监护人，他们可以联系负责的客户支持主管，其联系方式列在标题为\"查询\"的部分，以将用户注册为网站会员.</li>",
        "<li>本公司努力只收集与上述目的有关的必要和充分但不过度的个人数据.</li>",
        "<li>如果公司要求将您的个人数据用于上述目的以外的目的，我们将征求您的指定同意。如果您是未成年人，则应由您的父母或监护人给予规定的同意.</li>",
        "</ol>",
        "<h3>3。数据保护原则</h3>",
        "所有个人数据的处理均应根据以下数据保护原则进行：",
        "<ul>",
        "<li>个人数据必须合法、公平和透明地处理</li>",
        "<li>个人数据只能用于特定、明确和合法的目的</li>",
        "<li>个人数据必须相关且仅限于处理所需的内容</li>",
        "<li>个人数据必须准确并保持最新状态，尽一切努力删除或更正.</li>",
        "<li>个人数据必须以以下形式保存：只有在处理需要时才可以识别数据主体</li>",
        "<li>个人数据的处理方式必须确保适当的安全性</li>",
        "</ul>",
        "<h3>4。数据清单</h3>",
        "<ol>",
        "<li>",
        "我们还保留了数据清单和数据流流程，以确定我们数据处理的各个方面，包括：",
        "<ul>",
        "<li>使用个人数据的业务流程.</li>",
        "<li>收集和/或使用个人数据的目的.</li>",
        "<li>个人数据来源.</li>",
        "<li>处理活动.</li>",
        "<li>任何数据传输，以及向谁传输</li>",
        "<li>任何数据访问、更正或选择退出请求。这种数据清单将促进.</li>",
        "</ul>",
        "</li>",
        "<li>Neufast Limited跟踪其数据和相关处理活动，并使我们能够更好地遵守相关隐私和其他法律法规.</li>",
        "</ol>",
        "<h3>5。安全性</h3>",
        "<p>用户个人信息和数据的安全性对Neufast Limited非常重要。我们将始终努力确保用户的个人信息和数据受到保护，防止未经授权的访问。我们已实施适当的电子和管理措施，以维护，保护和保护用户的个人信息和数据.</p>",
        "<p>用户提供的所有个人信息和数据只能由公司的授权人员或其授权的第三方访问，并且应指示此类人员在访问此类个人信息和数据时遵守本隐私声明的条款。用户可以放心，他们的个人信息和数据只会在实现收集目的所需的时间内保留。注册用户应通过保密来保护他/她的唯一用户名和密码，切勿与任何人分享这些详细信息.</p>",
        "<p>公司使用第三方服务提供商来促进网站上的电子支付交易.</p>",
        "<p>公司遵循普遍接受的行业标准来保护用户在传输过程中和收到后提交给本网站的个人信息和数据。但是，没有任何一种互联网传输方法或电子存储方法是100%安全的。因此，虽然我们努力保护用户的个人信息 和数据免受未经授权的访问，但公司不能保证其绝对安全。</p>",
        "<h3>6。数据处理的法律依据</h3>",
        "<p>我们确保我们处理个人数据有法律依据。此类法律依据包括：（i）Neufast Limited在处理个人数据方面的合法商业利益;（ii） 如果适用法律或法规要求，寻求您的明确同意以处理此类个人数据;和/或 （iii） 适用法律和法规下的任何其他相关依据.</p>",
        "<h4>合法权益</h4>",
        "<p>Neufast Limited根据\"合法利益\"法律依据处理个人数据，这意味着处理个人数据对于Neufast Limited追求的合法利益是必要的，除非这些利益被需要保护个人数据的数据主体的利益或基本权利和自由所覆盖。</p>",
        "<h4>合法利益评估</h4>",
        "<p>在每一种相关情况下，我们评估：（一） 这些合法利益是什么;（二） 这些合法利益是什么;（三） 这些合法利益是什么。（ii） 是否需要处理该等数据以达致目标;以及 （iii） 数据主体的相关权利;并在我们得出结论认为Neufast有限公司可以根据合法利益处理个人数据之前，平衡这些权利与我们的利益，并确保这些权利不会凌驾于Neufast有限公司的合法利益之上。</p>",
        "<h4>与数据主体沟通</h4>",
        "<p>所有数据主体都将被告知我们正在收集他们的个人数据、相关个人数据的类别和处理目的。这是为了确保数据主体清楚我们对个人数据的收集和处理，并且此类收集和处理在数据主体的 合理预期范围内。请注意，所有数据主体都可以随时反对我们收集和处理其个人数据，以及他们有权要求访问和/或更正我们拥有的个人数据.</p>",
        "<h4>数据安全机制</h4>",
        "<p>我们还实施了适当的机制、政策和程序来保护我们收集和处理的个人数据的机密性和安全性，因为我们尊重数据主体与此类个人数据相关的隐私和相关权利，降低处理的风险或潜在负面影响，包括但不限于数据最小化， 去标识化、加密、限制访问和所有其他技术安全方法和保护个人数据的努力。对数据主体的隐私和相关权利的这种保护将使Neufast Limited能够在合法利益法律基础上处理个人数据。在彻底进行上述评估后，Neufast Limited得出结论，其正在根据以下合法利益收集和处理个人数据：< / p>",
        "<ol type='a'>",
        "<li>",
        "<p>满足客户和运营需求 处理个人数据类别的主要目的已在上文</p>",
        "<p>Neufast Limited有合法利益处理相同的内容，因为所有这些目的对于Neufast Limited作为公司和技术组织为其客户提供服务及其运营需求至关重要</p>",
        "<p>像Neufast Limited这样的公司需要员工为其业务（以及人事记录）和服务提供商工作，以保持其运行（因此需要其他运营记录）。</p>",
        "<p>像Neufast这样的技术组织需要开发技术，以进一步增强服务所需的技术，以服务于人力资源和教育领域的客户.</p>",
        "</li>",
        "<li>",
        "<p>通知公众</p>",
        "<p>作为一个招聘组织，Neufast Limited尊重公众了解我们社区和世界正在发生的事情的权利。Neufast Limited根据法律和新闻道德都有责任告知公众此类事件（\"告知义务\"）。</p>",
        "<p>这些建议并不禁止或限制任何人查看他们可以随时访问的此类网站上的所有其他文章或内容.</p>",
        "</li>",
        "<li>",
        "<p>同意</p>",
        "<p>如果适用的法律要求要求在处理个人数据（包括进行直接营销）之前必须获得特定同意，我们将确保获得以下特定同意：</p>",
        "<ol type='a'>",
        "<li>同意必须清楚、明确和具体;</li>",
        "<li>数据主体完全了解我们打算使用的个人数据类型;以及该等使用的目的（例如改善我们对资料当事人的服务或直接促销）;和</li>",
        "<li>受让人的姓名/身份（如果我们打算转移您的数据）以及受让人应如何使用您的个人数据.</li>",
        "</ol>",
        "</li>",
        "</ol>",
        "<h3>7。数据主体的权利</h3>",
        "<p>Neufast Limited尊重数据主体对数据处理以及记录的有关他们的数据拥有以下权利：</p>",
        "<ol>",
        "<li>请求查阅所持有资料的性质和向谁披露资料</li>",
        "<li>防止可能造成损害或痛苦的处理</li>",
        "<li>防止为直接营销目的进行处理.</li>",
        "<li>了解将对它们产生重大影响的自动化决策过程（如果有的话）的机制</li>",
        "<li>不让影响他们的重大决定完全通过自动化流程</li>",
        "<li>采取行动纠正、阻止和删除，包括被遗忘或销毁不准确数据的权利.</li>",
        "<li>请求监督机构（例如隐私专员或数据保护官），以评估是否违反了相关隐私和其他法律的任何规定.</li>",
        "<li>以结构化、常用和机器可读的格式向他们提供个人数据，并有权将此类数据传输给另一个数据控制者</li>",
        "<li>反对正在发生的任何自动分析</li>",
        "</ol>",
        "<h3>8。个人数据的传输</h3>",
        "<p>我们将对我们持有的个人数据保密，这些数据可能会出于上述目的转移给以下各方.</p>",
        "<ol>",
        "<li>云服务提供商、承包商或第三方，他们/他们为Neufast Limited的运营提供行政、技术或其他服务;</li>",
        "<li>向任何†主管执法机构、监管机构、政府机构、法院或其他第三方†如果我们认为有必要披露（i）作为适用法律或法规的问题，（ii）行使、建立或捍卫我们的合法权利，或（iii）保护您或任何其他人的切身利益;</li>",
        "<li>与我们业务任何部分的任何拟议购买、重组、合并或收购有关，前提是我们告知买方其必须仅将您的个人信息用于本隐私声明中披露的目的;</li>",
        "<li>Neufast Limited.的任何关联公司</li>",
        "</ol>",
        "<p>在发生此类转移的情况下，Neufast Limited应使用合同或其他方式确保数据传输的个人数据保密，并遵守所有相关的个人数据隐私法律法规</p>",
        "<p>如上所述，如果您是候选人、员工或实习生，并且我们通过服务收集您的个人信息，我们将根据我们与客户签订的协议代表客户收集这些信息。有关如何与第三方共享您的个人信息的更多信息，您应该联系相关潜在雇主或参考该潜在雇主的隐私政策/隐私声明.</p>",
        "<p>关于上文第（iv）分款所述情况 - 如果Neufast Limited关联公司之间的此类集团内部传输涉及跨境数据传输，Neufast Limited可能会采用具有约束力的公司规则来保护此类个人数据的安全;并确保所有相关关联公司均遵守相关隐私和其他法律.</p>",
        "<h3>9。个人数据的保留</h3>",
        "<p>一旦Neufast Limited获得用户的个人信息和/或数据，它将在公司系统中安全地维护，以实现\"实践声明\"一节中规定的收集数据的目的.注册后，用户可以通过联系数据控制者（即用户使用我们网站的雇主/培训师）从网站中删除其个人信息或终止他/她的网站会员资格。即使在用户关闭其帐户后，如果保留对于遵守我们的法律义务、满足监管要求、解决用户之间的争议、防止欺诈和滥用或执行本隐私声明和条款和条件是合理必要的，公司也可以保留用户的个人信息</p>",
        "<h3>10。本隐私声明的变更</h3>",
        "<p>公司保留在公司认为必要时随时更新、修订、修改或修订本隐私声明的权利，因此强烈建议用户经常查看本隐私声明。如果公司决定更新，修订，修改或修订本隐私声明，公司将把这些更改发布到网站和/或公司认为适当的其他地方，以便用户了解公司收集哪些信息，我们如何使用这些信息，以及在什么情况下（如果有的话），公司会披露这些信息</p>",
        "<p>如果公司对本隐私声明进行重大更改，我们将通过本网页、电子邮件或网站主页上的通知通知用户。对本隐私声明的此类更改应自公司在网站上发布时起适用。用户 继续使用本网站和本网站上的服务即表示接受本隐私声明的更改</p>",
        "<h3>11。Cookie的使用</h3>",
        "<p>Cookie是网站在网站上传输到个人硬盘的信息项，用于保存记录。Cookie 通过为您保存密码、购买和偏好等方式，使网上冲浪更加轻松。Cookie 的使用是行业标准，您可以在大多数主要网站上找到 Cookie.</p>",
        "<p>cookie本身不包含任何个人识别信息，尽管它可以使公司将用户对服务的使用与用户先前提交的个人识别信息（如果有）联系起来</p>",
        "<p>大多数浏览器最初都设置为接受cookie。如果您不希望披露上述信息，则应将您的信息设置为拒绝cookie。但是，如果您这样做，网站的大多数区域可能无法正常运行.</p>",
        "<h3>12。外包安排</h3>",
        "<p>公司一直在利用其内部资源来开发和维护其IT系统。当公司聘请第三方供应商提供与其IT系统相关的某些服务时，供应商在通常情况下无法访问存储在IT系统中的个人数据</p>",
        "<p>在此类供应商具有此类访问权限的特殊情况下，公司采取合理措施确保：（i）该供应商受合同约束对此类个人数据保密，并采取适当手段防止任何未经授权的访问，使用，丢失，保留，修改，转移或其他方式</p>",
        "<h3>13。查询、撤回同意、查阅资料要求及查阅资料更正</h3>",
        "<p>任何个人都有权撤回同意我们处理他们的数据，进行查询，要求访问和更正我们持有的他或她的个人数据。请联系雇主或培训师以访问和更正数据。</p>",
        "如阁下欲查询、查阅或更正我们所持有的阁下的个人资料，请将阁下的要求发送至：",
        "<p>数据隐私官</p>",
        "<p>Dr. Dennis Lee</p>",
        "<p>Neufast Limited</p>",
        "<p>地址：香港新界沙田科学园大道西2号2W大厦3楼2室</p>",
        "<p>电话： （+852）59876904</p>",
        "<p>电子邮件： customer-service@neufast.com</p>",
        "<h3>14。国际数据传输</h3>",
        "<p>用户的个人信息可能会被转移到用户居住国以外的国家/地区并在这些国家进行处理。这些国家/地区的数据保护法律可能与用户所在国家/地区的法律不同。具体而言，除非当地法律另有要求，否则我们的网站、系统和提供的第三方服务均在欧洲经济区、新加坡和香港特别行政区进行处理.</p>",
        "<p>但是，我们已采取适当的保护措施，要求用户的个人信息将根据本隐私声明和适用法律继续受到保护。如果用户来自欧洲经济区或英国，这些措施包括实施欧盟委员会的标准合同条款，以便在我们的集团公司之间以及与我们的第三方服务提供商和合作伙伴之间传输个人信息。标准合同条款要求非欧洲经济区公司根据欧洲经济区数据保护法保护其处理的欧洲经济区和英国个人信息</p>",
        "<h3>15。删除个人数据</h3>",
        "<p>雇主或培训师充当数据控制者，控制系统上的个人数据。姓名、电子邮件、电话号码、简历、图像、原始视频、音频等个人数据可由雇主或培训师在平台上删除。如果您是提供您的数据的用户，请联系您使用我们平台的公司以删除您的个人信息。此外，用户的个人信息将在您的用户帐户关闭三个月后从我们的系统中删除。非个人信息，如工作信息、面试问题、编辑视频、分数和答案，将汇总并存储在我们的系统中，仅用于提高评估和服务质量。根据我们的同意，当雇主/培训师通过电子邮件通知我们时，也可以删除编辑的视频和其他信息 customer-service@neufast.com.</p>"
    ],
    "And": "和",
    "Login_SSO_Generic_Error": "警告 ！！",
    "Login_SSO_Error_Generic": "请联系您的领导者",
    "Login_SSO_Error_Verify_Hash": "令牌验证失败",
    "Login_SSO_Error_Verify_Hash_Code_1": "该链接已过期...",
    "Login_SSO_Error_Verify_Hash_Code_2": "该链接已被篡改/修改...",
    "Login_SSO_Error_Verify_Hash_Code_3": "请致电回调URL端点以生成新的链接",
    "Login_SSO_Error_Verify_Hash_Code_4": "请致电回调URL端点",
    "Login_SSO_Error_Verify_Hash_Code_5": "上一次会话处于活动状态时检测到重复的尝试",
    "Login_SSO_Error_Sign_On": "单个签名失败",
    "Login_SSO_Error_Sign_On_Code_1": "找不到帐户",
    "Login_SSO_Error_Sign_On_Code_2": "找不到帐户",
    "Login_SSO_Error_Sign_On_Code_3": "您的帐户已关闭/过期，请联系您的介绍人以进行进一步查询。",
    "Login_SSO_Error_Sign_On_Code_4": "您的帐户已关闭/过期，请联系您的介绍人以进行进一步查询。",
    "Login_SSO_Error_Sign_On_Code_5": "报告还没有准备好被视为候选人尚未登录",
    "Login_SSO_Error_Sign_On_Code_51": "SSO数据错误。请联系技术支持",
    "Login_SSO_Error_Sign_On_Code_6": "您的面试截止日期已经过去。",
    "Login_SSO_Error_Sign_On_Code_7": "访谈系列尚未开始。请在电子邮件中读取面试时间。",
    "Login_SSO_Error_Sign_On_Code_8": "您的面试完成并进行了审查。",
    "Login_SSO_Error_Sign_On_Code_9": "未知错误",
    "Login_SSO_Error_Sign_On_Code_10": "面试目前还没有准备好。请重试。",
    "Forget_Password_Title": "忘记密码",
    "Forget_Password_Subtitle": "请输入你的登录的电子邮件信箱，系统将于数分钟内寄出重设密码的电邮。",
    "Forget_Password_Success_Message": "重设密码的电邮已寄到 {email}. 请检查你的电子邮件信箱并按照电邮的指示重设密码",
    "Forget_Password_Email_Not_Found_Message": "你输入的电子邮件地址尚未注册。请确保输入的资料正确",
    "Reset_Password_Title": "重設密碼",
    "Reset_Password_Sutitle": "为了保护你的帐户，请确保新的密码：",
    "Reset_Password_Sutitle_List": [
        "多于 7 个字符。",
        "与你的电子邮件地址并不相近。"
    ],
    "Reset_Password_Success_Message": "成功重设密码。",
    "Reset_Password_Failed_Message_Token_expired": "重设密码失败。",
    "Reset_Password_Invalid_Character_Error_Message": "密码格式无效。密码只能包含以下特殊字符：!#$%*+,-=?@^_|~\n",
    "Reset_Password_Failed_Message_Weak_Password": "密码不够强。\n",
    "Reset_Password_Weak_Password_Message_Passlen": "密码长度应至少为 ",
    "Reset_Password_Weak_Password_Message_Upper_Letter": "密码应该至少包含一个大写字母\n",
    "Reset_Password_Weak_Password_Message_Lower_Letter": "密码应至少包含一个小写字母\n",
    "Reset_Password_Weak_Password_Message_Number": "密码应至少包含一个数字\n",
    "Reset_Password_Weak_Password_Message_Special_Character": "密码应至少包含一个特殊字符 !#$%*+,-=?@^_|~",
    "Reset_Password_Failed_Message_Reused_Password": "密码不应与之前的密码相同。",
    "Reset_Password_Weak_Password_Breached_Password_Message": "之前在数据泄露中泄露的易受攻击的密码。请选择更安全的密码。\n",
    "Reset_Password_Failed_Message": "重设密码失败。",
    "Reset_Password_Back_Button": "返回主页",
    "InterviewLanguage_en": "英语",
    "InterviewLanguage_tc": "粤语",
    "InterviewLanguage_sc": "中文",
    "InterviewLanguage_th": "泰文",
    "InterviewLanguage_ja": "日语",
    "InterviewLanguage_id": "印尼语",
    "InterviewLanguage_ms": "马来语",
    "InterviewLanguage_vi": "越南语",
    "InterviewLanguage_km": "高棉语",
    "InterviewLanguage_kr": "韩语",
    "InterviewLanguage_bu": "缅甸语",
    "InterviewLanguage_ta": "菲律宾语",
    "InterviewLanguage_hi": "印地语",
    "InterviewLanguage_de": "德语",
    "InterviewLanguage_fr": "法语",
    "InterviewLanguageConfirm_en": "英语",
    "InterviewLanguageConfirm_ms": "马来语",
    "InterviewLanguageConfirm_sc": "中文",
    "LayoutSettings_QuestionSubType_TaskPerformance": "处事表现",
    "LayoutSettings_QuestionSubType_InterpersonalRelationshipCommunication": "人际关系与沟通",
    "LayoutSettings_QuestionSubType_Adaptability": "适应能力",
    "Recruiter_Layout_Title": "面试界面布局",
    "Recruiter_Layout_Title_old": "视频面试介面布局",
    "Recruiter_Layout_Instruction": "请设定求职者的面试界面布局并按 '{action}'",
    "Recruiter_Layout_Instruction_old": "请设定求职者的视频面试介面布局并按 '{action}'",
    "Recruiter_Layout_CompanyName": "公司名称",
    "Recruiter_Layout_CompanyMessage": "面试完结信息",
    "Recruiter_Layout_CV_Upload_Enable": "Enable Candidate to upload CV",
    "Recruiter_Layout_CV_Upload_Enable_Message": "If you enable this function, candidate can upload their cv from their side.",
    "Recruiter_Layout_Timezone": "时区",
    "Recruiter_Layout_InterviewLanguage": "评核语言",
    "Recruiter_Layout_InterviewLanguage_old": "视频面试语言",
    "Recruiter_Layout_InterviewStart": "面试开始於",
    "Recruiter_Layout_InterviewStartDate": "日期",
    "Recruiter_Layout_InterviewStartTime": "时间",
    "Recruiter_Layout_InterviewEnd": "面试结束於",
    "Recruiter_Layout_InterviewEndDate": "日期",
    "Recruiter_Layout_InterviewEndTime": "时间",
    "Recruiter_Layout_ShowAvatar": "在面试中使用虚拟面试官:",
    "Recruiter_Layout_CompanyVideo": "公司简介视频",
    "Recruiter_Layout_CompanyVideo_Instruction": "将视频放到此处或点击以选择文件",
    "Recruiter_Layout_CompanyVideo_Format": "视频大小 < 200MB, 视频文件格式: AVI, MP4, Mov",
    "Recruiter_Layout_CompanyLogo": "公司徽标",
    "Recruiter_Layout_CompanyWebsite": "公司网页",
    "Recruiter_Layout_CompanyLogo_Instruction": "将图片放到此处或点击以选择文件",
    "Recruiter_Layout_CompanyLogo_Format": "推荐大小 300px x 300px",
    "Recruiter_Layout_ColorScheme": "介面主色",
    "Recruiter_Layout_Question": "问题设置",
    "Recruiter_Layout_QuestionSet": "问题组合 {no}",
    "Recruiter_Layout_QuestionType": "问题类型",
    "Recruiter_Layout_QuestionSubType": "问题子类型",
    "Recruiter_Layout_PleaseSelect": "请选择",
    "Recruiter_Layout_PleaseSelectQuestion": "问题",
    "Recruiter_Layout_Answer": "答案",
    "Recruiter_Layout_QuestionRemove": "移除",
    "Recruiter_Layout_AddQuestion": "增加问题",
    "Recruiter_Layout_UploadVideo": "上传影片",
    "Recruiter_Layout_uploading": "正在上传...",
    "Recruiter_Layout_AddQuestionSet": "增加问题组合",
    "Recruiter_Layout_Action_Save": "保存",
    "Recruiter_Layout_Action_Confirm": "确定",
    "Recruiter_Layout_Action_Save_MsgSuccess": "保存成功",
    "Recruiter_Layout_Action_Save_MsgFailed": "保存失败",
    "Recruiter_Layout_Goback": "上一页",
    "Recruiter_Layout_Next": "继续",
    "Recruiter_Layout_Submit": "提交",
    "Recruiter_Layout_Save": "保存",
    "Recruiter_Layout_QuestionLength": "每题的回答时间",
    "Recruiter_Layout_Attempt_Number_Question": "每个问题的尝试次数",
    "Recruiter_Layout_Minutes": "分钟",
    "Recruiter_Layout_Action_Finish": "完成",
    "Recruiter_Layout_Action_Finish_MsgSuccess": "面试设置完成",
    "Recruiter_Layout_Step": "第 {step} 步 - ",
    "Recruiter_Layout_No_Preparation_Time": "没有准备时间",
    "Recruiter_Layout_Attempt_Number_Question_Tooltip": "这是每个问题的尝试次数",
    "Recruiter_Layout_CompanyName_Tooltip": "这公司名字在面试界面中显示",
    "Recruiter_Layout_CompanyWebsite_Tooltip": "这是候选人介面中显示的公司网页",
    "Recruiter_Layout_InterviewLanguage_Tooltip": "这是评核介面的显示语言",
    "Recruiter_Layout_InterviewLanguage_Tooltip_old": "这是面试介面的显示语言",
    "Recruiter_Layout_Timezone_Tooltip": "这时区用于设定面试开始于结束时间",
    "Recruiter_Layout_ShowAvatarIdentity": "加入虚拟面试官的身份",
    "Recruiter_Layout_AvatarIdentity": "虚拟面试官身份",
    "Recruiter_Layout_FirstName": "名字",
    "Recruiter_Layout_LastName": "姓氏",
    "Recruiter_Layout_JobTitle": "职位名称",
    "Recruiter_Layout_AvatarIdentity_Tooltip": "这是显示给候选人知道的虚拟面试官身份",
    "Recruiter_Layout_ShowAvatar_Tooltip": "这按钮开动虚拟面试官影像，用以发问面试题目",
    "Recruiter_Layout_ShowAvatarIdentity_Tooltip": "这按钮加入虚拟面试官身份并在面试介面中开动介绍页面",
    "Recruiter_Layout_CompanyVideo_Tooltip": "这介绍视频在面试开始前显示，帮助吸引候选人加入你的工作职位",
    "Recruiter_Layout_VideoReduction": "在处理公司视频中。请继续设置...",
    "Recruiter_Layout_CompanyLogo_Tooltip": "这是面试介面显示的徽标",
    "Recruiter_Layout_ColorScheme_Tooltip": "这是面试介面的主色调",
    "Recruiter_Layout_PreparationTime": "每条题目准备时间",
    "Recruiter_Layout_Totaltime": "本次测试的总答题时间",
    "Recruiter_Layout_PreparationLength_Tooltip": "这是每条面试题目的准备时间",
    "Recruiter_Layout_QuestionLength_Tooltip": "这是每条面试题目的答题时间",
    "Recruiter_Layout_CompanyMessage_Tooltip": "这讯息是在面试结束时给候选人的资讯或提示",
    "Recruiter_Layout_AdvancedSetting": "进阶设置",
    "Recruiter_Layout_QR_Code_OTP_Tooltip": "开启以通过电子邮件启用验证",
    "Recruiter_Layout_ScreenLayout": "面试官/求职者屏幕布置",
    "Recruiter_Layout_Arrangement_Tooltip": "这是面试画面排版的方式，适合用于不同形式的面试",
    "Recruiter_Layout_TwoScreens": "两个大小一样的屏幕",
    "Recruiter_Layout_BigSmallScreen": "一大一小屏幕",
    "Recruiter_Layout_AddQuestionSet_Tooltip": "系统会把其中一组面试问题发给候选人以增加问题的随机度",
    "Recruiter_Layout_Pronunciation": "口音",
    "Recruiter_Layout_Pronunciation_None": "没有",
    "Recruiter_Layout_Pronunciation_Philipplines": "菲律宾",
    "Recruiter_Question_Title": "评核问题设定",
    "Recruiter_Test_Setting_Title": "评核设定",
    "Recruiter_Question_Title_old": "视频面试问题设定",
    "Recruiter_Settings_Test_Settings_Video_Interview": "视频面试",
    "Recruiter_Settings_Test_Settings_Multiple_Choices": "多项选择题",
    "Recruiter_Settings_Test_Settings_Short_Questions": "短答题",
    "Recruiter_Settings_Test_Settings_Test_Name": "测试名称 (非必需)",
    "Recruiter_Settings_Test_Settings_Add_Choice": "添加选择",
    "Recruiter_Settings_Test_Settings_Choice": "选择 {number}",
    "Recruiter_Settings_Test_Settings_Single_Answer": "单一答案",
    "Recruiter_Settings_Test_Settings_Multiple_Answers": "多项答案",
    "Recruiter_Settings_Test_Settings_Required_Field": "必填项目",
    "Recruiter_Settings_Test_Settings_Test_Duaration": "测试时间",
    "Recruiter_Settings_Test_Settings_Copy": "复制",
    "Recruiter_Settings_Test_Settings_Delete": "删除",
    "Recruiter_Layout_QuestionLanguage": "语言",
    "Recruiter_Question_Instruction": "请在评核中添加问题并按 '{action}'。可以通过按\"添加问题\"添加额外的问题，以便随机呈现其中一个问题集给求职者。",
    "Recruiter_Question_Instruction_old": "请在视频面试中添加问题并按 '{action}'. 可以通过按\"添加问题\"添加额外的问题 ，以便随机呈现其中一个问题集给求职者。",
    "Recruiter_Multiple_Choices_Question_Instruction": "请在多项选择题中添加问题。你可以单击选项旁边的圆圈将其设定为标准答案。可以设定多于一个选项作为多项选择题的标准答案。",
    "Recruiter_Short_Question_Instruction": "请在短答题中添加问题。",
    "Recruiter_Question_CustomizeVirtualInterviewer": "定制虚拟面试官 (影片/图片):",
    "Recruiter_Question_VirtualInterviewer_Tips": "若没有提供虚拟面试官，系统会自动提供预设面试官",
    "Recruiter_Question_File_Format": "文件大小 < 20MB, 文件格式: AVI, MP4, Mov, JPG, PNG",
    "Recruiter_Question_Voice_Tooltip": "开/关面试题目朗读声音",
    "Recruiter_Question_Contain": "这问题包含:",
    "Recruiter_Email_Title": "给求职者的电子邮件和短信",
    "Recruiter_Email_CompanyLogo": "公司徽标",
    "Recruiter_Email_DropFile_Title": "将图片放到此处或点击以选择文件e",
    "Recruiter_Email_DropFile_Message": "推荐大小e 300px x 300px",
    "Recruiter_Email_EmailDomain": "邮件域名",
    "Recruiter_Email_Invitation": "邀请",
    "Recruiter_Email_Invitation_Title": "评核邀请",
    "Recruiter_Email_HighScoreContent_Title": "评核邀请",
    "Recruiter_Email_MediumScoreContent_Title": "评核邀请",
    "Recruiter_Email_LowScoreContent_Title": "评核邀请",
    "Recruiter_Email_Invitation_Title_old": "邀请进行视频面试",
    "Recruiter_Email_Reminder": "提醒",
    "Recruiter_Email_Reminder_Title": "评核提醒",
    "Recruiter_Email_Reminder_Title_old": "提醒进行视频面试",
    "Recruiter_Email_Extension": "更改截止日",
    "Recruiter_Email_Extension_Title": "修改评核截止日期",
    "Recruiter_Email_Extension_Title_old": "更改视频面试的截止日期",
    "Recruiter_Email_Confirmation": "确认",
    "Recruiter_Email_Confirmation_Title": "评核完成",
    "Recruiter_Email_Confirmation_Title_old": "完成视频面试",
    "Recruiter_Email_AdvancedSettings": "进阶设定",
    "Recruiter_Email_Section_Title": "标题",
    "Recruiter_Email_Section_Message": "信息",
    "Recruiter_Email_Section_Add_Attachment_Title": "添加附件",
    "Recruiter_Email_Section_Add_Attachment_Message": "在此处按或拖动文件以附加（仅一个文件<20MB）",
    "Recruiter_Email_Section_AddCompanyLogo": "增加公司徽标",
    "Recruiter_Email_High_Score_Heading": "高总分（7-10）的求职者报告",
    "Recruiter_Email_Medium_Score_Heading": "中总分（4-6）的求职者报告",
    "Recruiter_Email_Low_Score_Heading": "低总分（0-3）的求职者报告",
    "Recruiter_Email_Section_AddSMS": "使用短讯",
    "Recruiter_Email_Section_AddComment": "添加评论",
    "Recruiter_Email_Save": "保存",
    "Recruiter_Email_Intoduction": "点击以下按钮以开动电邮和短讯传送功能，让后按‘{action}’。",
    "Recruiter_Email_Invitation_Tips": "邀请电邮要求求职者进行评核",
    "Recruiter_Email_Invitation_Tips_old": "邀请电邮要求求职者进行评核",
    "Recruiter_Email_Reminder_Tips": "提醒信息将在截止前24小时发出",
    "Recruiter_Email_Extension_Tips": "当评核的截止日期被修改时，这封电邮将发送给求职者",
    "Recruiter_Email_Extension_Tips_old": "当视频面试的截止日期被修改时，这封电邮将发送给求职者",
    "Recruiter_Email_Confirmation_Tips": "求职者完成评核后会自动发送确认信",
    "Recruiter_Email_Redo": "重做面试题目",
    "Recruiter_Email_Redo_Tips": "这电邮邀请候选人重做选定的面试题目",
    "Recruiter_Email_Report_Tips": "此电邮会将报告发送给求职者",
    "Recruiter_Email_Redo_Title": "重做面试题目",
    "Recruiter_Email_Report_Title": "视频面试发展报告",
    "Recruiter_Email_Report_Section_Title": "给求职者报告",
    "Recruiter_Scoring_Title": "评分权重设置",
    "Recruiter_Scoring_ImpressionScore": "印象分数",
    "Recruiter_Scoring_PerformanceScore": "表现分数",
    "Recruiter_Scoring_Weighting": "权重 (%)",
    "Recruiter_Scoring_Total": "总共:",
    "Recruiter_Scoring_Save": "储存",
    "Recruiter_Scoring_MsgNotSumTo100": "在上传前请使和为100",
    "Recruiter_Scoring_MsgNotSumTo0": "请为至少一项分数设置成「重要」、「需要」或「可有」",
    "Recruiter_Scoring_Save_MsgSuccess": "保存成功",
    "Recruiter_Scoring_Save_MsgFailed": "保存失败",
    "Recruiter_Scoring_Critical": "重要",
    "Recruiter_Scoring_Required": "需要",
    "Recruiter_Scoring_Bonus": "可有",
    "Recruiter_Scoring_Irrelevant": "无关",
    "Recruiter_Scoring_Introduction": "请选择对这项工作重要的能力的比重。面试分数是根据这些能力的比重从答案中计算出来的。",
    "Recruiter_Scoring_Impression": "印象分数",
    "Recruiter_Scoring_TaskPerformance": "处事表现分数",
    "Recruiter_Scoring_PotentialWorkPerformance": "潜在工作表现评分",
    "Recruiter_AIRating_PotentialWorkPerformance": "潜在工作表现评分",
    "Recruiter_Scoring_ContextualPerformance": "关系表现分数",
    "Recruiter_Scoring_AdaptivePerformance": "适应性表现分数",
    "Recruiter_Scoring_Leadership_Definition": "在领导和影响他人时表现出自信，在驱动自我和他人成功方面充满动力和活力，并激励他人表现",
    "Recruiter_Scoring_DevelopingPeople_Definition": "以能力为本的用人方式，认为每个人都有潜力在个人和专业方面成长。并通过提供反馈和指导，发展机会和经验分享等方式支持",
    "Recruiter_Scoring_GoalAndAchievementStriving_Definition": "勤奋地追求目标，组织计划和管理资源及项目进度，以确保有效执行和实现目标",
    "Recruiter_Scoring_Responsibility_Definition": "承担个人责任专注于完成任务，并利用自己的能力独立满足工作要求",
    "Recruiter_Scoring_ManagingExecution_Definition": "按照指导和程序，对需要利用资源的任务和活动进行有组织和协调的计划，以确保按执行时间表和目标顺利完成任务或项目",
    "Recruiter_Scoring_AnalyticalAndLogicalThinking_Definition": "好奇地探索问题，研究，收集和综合信息和思想，从对事情的观察和资料作批判性的分析和评核以得出结论",
    "Recruiter_Scoring_ComplexProblemSolving_Definition": "能够复核大量资讯并弄清问题的本质，能够灵活地思考以识别行动，并评核各备选方案的利弊以确定最能实现目标的选项",
    "Recruiter_Scoring_Communication_Definition": "自信地进行对话交流，并以流畅，清晰，简洁，有条理和有说服力的方式表达思想和信息",
    "Recruiter_Scoring_CaringAndEmpathy_Definition": "表现出对他人的关心和关怀，对他人需求敏感。并能够通过积极倾听和表现出同理心以个人方式与其他人互动",
    "Recruiter_Scoring_EnglishOralCommunication_Definition": "具有以流利英语清晰表达的能力",
    "Recruiter_Scoring_CantoneseOralCommunication_Definition": "具有以流利广东话清晰表达的能力",
    "Recruiter_Scoring_MandarinOralCommunication_Definition": "具有以流利普通话清晰表达的能力",
    "Recruiter_Scoring_InterpersonalRelationship_Definition": "在团队合作和协作中有效互动并与他人建立并维持联系，在部门和/或组织内部和之间建立积极的关系",
    "Recruiter_Scoring_TeamCollaborationAndInclusion_Definition": "与来自不同背景，文化和组织的人一起工作时，能相互合作并乐于助人。通过表现出尊重和对文化的敏感性，可以轻松地与他人建立信任",
    "Recruiter_Scoring_BuildingRelationshipsAndNetwork_Definition": "具有人际交往，与广泛的人互动的能力，可以在部门，职能和/或组织内部和之间建立积极的关系和网络",
    "Recruiter_Scoring_FlexibilityAndAdaptability_Definition": "根据新情况适应行为，能够在含糊不清的情况下有效地工作，并在与他人互动时灵活运用自己的方法以实现目标",
    "Recruiter_Scoring_LearningAgility_Definition": "具有好奇心和反思能力，具有持续的学习态度和敏捷性以获取新知识",
    "Recruiter_Scoring_CreativityAndInnovation_Definition": "富有想像力，能产生新想法并推进新发明/方法以解决问题，或提高服务或产品质量",
    "Recruiter_Scoring_EmotionalIntelligence_Definition": "保持情绪控制和乐观，坚持不懈，在遇到困难或逆境时保持韧性",
    "Recruiter_Scoring_Enthusiasm_Definition": "对生活中的人与事表现出热情，乐观和充满活力的兴趣",
    "Recruiter_Scoring_Composure_Definition": "保持镇定，没有或几乎没有紧张感，在压力下不感到担心或沮丧",
    "Recruiter_Scoring_SelfConfidence_Definition": "不论在任何情况下，都能表现出自信和处理问题和实现目标的能力",
    "Recruiter_Scoring_VisionAndEntrepreneurialMindset_Definition": "能够发现问题，创建愿景并以企业家的思维方式实施。发现商机并创造未来远景，然后在评核风险后系统地，持续地执行，以创新和发明新方式以解决问题",
    "Recruiter_Scoring_TechnologyExpertiseAndBusinessSense_Definition": "能够运用技术专长来满足从香港到中国大陆以及世界其他地区的市场需求。拥有技术方面的技能和知识，紧跟最新技术，能够将这些知识与对关键业务问题的理解相结合来满足市场需求",
    "Recruiter_Scoring_EffectiveCommunicationAndTeambuilding_Definition": "能够清楚表达想法，建立并引领一个成功的团队。以流畅，简洁和有说服力的方式进行沟通，并能够通过制定共同的目标，分享知识，经验和成功并尊重个体差异来影响他人，从而促进更好的团队合作",
    "Recruiter_Scoring_GritAndPassion_Definition": "能够坚持不懈，从失败中恢复过来，并专注于激情和纪律。尽管在此过程中面临挑战或逆境，但我们有勇气和决心取得成功，有纪律严明的努力加上真诚的兴趣和热情，实现了长期目标",
    "Recruiter_Scoring_TaskPerformance_Definition": "计划、组织、管理日常工作和履行工作职责的能力",
    "Recruiter_Scoring_InterpersonalRelationshipCommunication_Definition": "在团队合作和协作中有效地与人互动和联系的能力，在部门和/或组织内部和跨部门建立积极的关系",
    "Recruiter_Scoring_MotivatingGoals_Definition": "能够设定明确的、以客户为中心的职业和销售目标，这些目标基于财务规划原则。展示出自我激励和纪律性，执行活动计划，跟踪关键绩效指标（例如，预约、转化、ANP、持续率），在拒绝中坚持，并使行动与AIA帮助客户过上更健康、更长寿、更美好生活的使命保持一致。",
    "Recruiter_Scoring_NetworkingAbility_Definition": "展示了主动建立、扩展和培育高质量网络的能力，包括个人、专业和社区渠道，以产生潜在客户并维持保险和财务规划的长期客户关系。以道德的方式参与，积极倾听，提供个性化价值，持续跟进，并利用推荐和社交平台来增强信任和业务。",
    "Recruiter_Scoring_InterpersonalSkills_Definition": "展示了与多样化的潜在客户和客户建立信任和融洽关系的能力，积极倾听，清晰地沟通复杂的保险/金融概念，带着同理心和专业精神处理异议和冲突，与同事和利益相关者（例如，承保、索赔、合规）有效合作，并维护长期以客户为中心的关系，尊重伦理和监管标准。",
    "Recruiter_Scoring_WorkingExperience_Definition": "展示了利用过去的销售和顾问经验来实现保险销售目标并提供适当的财务规划建议的能力。包括潜在客户开发和管道管理、需求分析和风险评估、解决方案定制和道德适宜性、合规（KYC/AML/监管）、高效的工作流程、使用CRM/分析、异议处理/成交、推荐和保留策略、月末回收规划，以及对基于佣金角色的明确职业动机。",
    "Recruiter_Scoring_EntrepreneurMindset_Definition": "展示了在建立合规和以客户为中心的保险和财务规划实践中的责任感和成长心态：设定明确的销售计划和KPI，主动生成和筛选潜在客户，通过系统和实验提高效率，保持严格的合规性和适宜性标准，管理健康的销售管道，并在不影响道德或客户结果的情况下适应月底压力。",
    "Recruiter_Scoring_Adaptability_Definition": "根据新情况调整行为的敏捷性，能够在模棱两可的情况下有效地工作，并在与他人的互动中灵活运用自己的方法以实现目标",
    "Recruiter_Scoring_WillingnessToBeTrained_Definition": "在受监管的咨询销售环境中，表现出强烈的可教性和学习敏捷性。主动寻求、接受并应用反馈；获取并更新有关保险产品、财务规划和合规性的知识；根据培训、数据和客户需求调整销售方法；并在销售质量和结果（例如，转化率、持续性、适合性、投诉减少）上显示出可衡量的改善。",
    "Recruiter_Scoring_IndependenceAndSelfReliance_Definition": "能够在整个销售和咨询周期中自主工作——寻找潜在客户、优先处理任务、管理管道、跟进和解决问题——同时在压力和拒绝下保持冷静，在最小监督下做出明智决策，并遵守合规性、文档和道德标准。",
    "Recruiter_Scoring_Resilience_Definition": "在压力下保持专业和道德标准；快速从挫折和拒绝中恢复；根据反馈和数据调整方法；持续进行潜在客户开发、跟进和客户服务的节奏；并在动荡的市场和苛刻的合规环境中展现出始终如一的沉着和乐观。",
    "Recruiter_Evaluation_Title": "评核员计分准则设定",
    "Recruiter_Evaluation_Instruction": "请在下面修改评核员的评分准则。请注意，更改将应用​​于该职位的所有求职者。若删除准则，其已有的评分数据都将会删除。",
    "Recruiter_Evaluation_AddCategory": "+ 按此添加类别",
    "Recruiter_Evaluation_AddCriterion": "+ 按此添加准则",
    "Recruiter_Evaluation_AddCategoryButton": "+ 添加类别",
    "LayoutSettings_QuestionType_General": "一般人力资源与就业",
    "LayoutSettings_QuestionType_SoftSkills": "能力软技能",
    "LayoutSettings_QuestionSubType_Intro": "介绍",
    "LayoutSettings_QuestionSubType_Motivation": "动机及职业计划",
    "LayoutSettings_QuestionSubType_Strenth": "优势、成就和弱点",
    "LayoutSettings_QuestionSubType_Attitude": "态度、兴趣和价值",
    "LayoutSettings_QuestionSubType_Understanding": "角色/公司理解",
    "LayoutSettings_QuestionSubType_WorkPlan": "工作计划",
    "LayoutSettings_QuestionSubType_Salary": "薪水",
    "LayoutSettings_QuestionSubType_Others": "其他",
    "LayoutSettings_QuestionSubType_Leadership": "领导力",
    "LayoutSettings_QuestionSubType_Teamwork": "团队合作和服务意识",
    "LayoutSettings_QuestionSubType_Communication": "沟通和关系构建",
    "LayoutSettings_QuestionSubType_ProblemAnalysis": "理解能力和问题分析能力",
    "LayoutSettings_QuestionSubType_Strategy": "战略和创新",
    "LayoutSettings_QuestionSubType_Process": "管理流程和执行",
    "LayoutSettings_QuestionSubType_Change": "改变和适应能力",
    "LayoutSettings_QuestionSubType_Venturing": "创业和成就导向",
    "Recruiter_Settings_Title": "职位及评核设定",
    "Recruiter_Settings_Title)old": "视频面试设定职位及视频面试设定",
    "Recruiter_Settings_BulkAction": "批量操作",
    "Recruiter_Settings_AddJob": "新增职位",
    "Recruiter_Settings_Edit": "更新",
    "Recruiter_Settings_Action_Import": "输入",
    "Recruiter_Settings_Action_Export": "输出",
    "Recruiter_Settings_Action_Remove": "移除",
    "Recruiter_Settings_JobCount": "{count} 职位",
    "Recruiter_Settings_TableColumn_Department": "部门",
    "Recruiter_Settings_TableColumn_JobTitle": "职位名称",
    "Recruiter_Settings_TableColumn_Created_At": "创建于",
    "Recruiter_Settings_TableColumn_NoOfQuestion": "问题数量",
    "Recruiter_Settings_TableColumn_NoOfCandidates": "候选人数量",
    "Recruiter_Settings_TableColumn_Deadline": "截止时间",
    "Recruiter_Settings_TableColumn_CompletionRate": "完成率",
    "Recruiter_Settings_Import_Title": "选择文件以上传候选人信息",
    "Recruiter_Settings_Import_Title_CV": "请在此添加候选人简历",
    "Recruiter_Settings_Import_FileDropTitle": "将文件放到此处或点击以选择文件",
    "Recruiter_Settings_Import_FileDropFormat": "支持文件格式: .csv and .xls and .xlsx",
    "Recruiter_Settings_Import_FileDropFormat_CV": "支持的文件格式：.docx 和 .doc 和 .pdf 和 .txt 和 .html",
    "Recruiter_Settings_Import_UploadNote": "* 上传的文件必须包括候选人姓名(name)，电邮(email)【强制输入】和国家代码(country code)，电话(phone number)，毕业院校(university)及学历(degree)【非强制输入】。所有数据应以特定格式用英语标题列出（参考示范).",
    "Recruiter_Settings_Import_UploadNote_CV": "* 上传的文件必须包含候选人的姓名、电子邮件（必填字段），并可以包含国家代码、电话号码、大学和学位（非必填）。数据应按列列出。请下载示例：",
    "Recruiter_Settings_Import_UploadTemplate": "下載",
    "Recruiter_Settings_Export_TopPercentile": "最高百分比",
    "Recruiter_Settings_Export_Title": "导出资料",
    "Recruiter_Settings_Export_Description": "请从以下选择要导出的资料",
    "Recruiter_Settings_Export_ItemCount": "{count} 项",
    "Recruiter_Settings_Export_TickBox": "勾选框以选择",
    "Recruiter_Settings_Export_Select_All": "全选",
    "Recruiter_Settings_Export_Column_CandidateName": "候选人姓名",
    "Recruiter_Settings_Export_Column_University": "学校",
    "Recruiter_Settings_Export_Column_DegreeTitle": "学历",
    "Recruiter_Settings_Export_Column_TelephoneNumber": "电话号码",
    "Recruiter_Settings_Export_Column_EmailAddress": "电子邮件",
    "Recruiter_Settings_Export_Column_RecruiterProgram": "招聘计划",
    "Recruiter_Settings_Export_Column_OverallScore": "总共得分",
    "Recruiter_Settings_Export_Column_ImpressionScore": "印象分数",
    "Recruiter_Settings_Export_Column_PotentialWorkPerformanceScore": "潜在工作表现分数",
    "Recruiter_Settings_Export_Column_Personal_Information": "个人资料",
    "Recruiter_Settings_Export_Column_Interview_Information": "面试资料",
    "Recruiter_Settings_Export_Column_Interview_Result": "面试结果",
    "Recruiter_Settings_Export_Column_Programme_Statistics": "职位统计",
    "Recruiter_Settings_Export_Column_Programme_Setting": "职位设定",
    "Recruiter_Settings_Export_Column_Candidate_Answer": "候选人的答案",
    "Recruiter_Settings_Export_help_0": "这将导出候选人的全名、电子邮件、大学、学位和电话号码.",
    "Recruiter_Settings_Export_help_1": "这将导出每个求职者的招聘人员电子邮件、职位 ID、面试开始和结束日期、评核状态和密码。",
    "Recruiter_Settings_Export_help_2": "这将导出求职者在所选评核中的个人分数。",
    "Recruiter_Settings_Export_help_3": "这将导出所选评核中求职者的统计数据。",
    "Recruiter_Settings_Export_help_4": "这将导出所选评核的设置。",
    "Recruiter_Settings_Export_help_5": "这将导出候选人在所选评估中的答案.",
    "Recruiter_Settings_Action_Edit_ErrorInterviewInProgress": "面试正在进行中，不能更改此部分设定。",
    "Recruiter_Settings_Action_Export_ErrorNoCompletedCandidate": "输出失败！只有在至少一位候选人完成面试后才能输出候选人结果。",
    "Recruiter_Settings_Action_Export_MsgSuccess": "文件输出成功。",
    "Recruiter_Settings_Action_Export_MsgProcessing": "文件正在处理中。请检查“导出的文件”选项卡。",
    "Recruiter_Settings_Action_Export_ErrorExceedQuota": "导出失败！您已超过每次导出的候选人限制（10,000名候选人）。请选取更小的职位进行导出。",
    "Recruiter_Settings_Action_Export_ErrorNoCandidateSelected": "导出失败！请至少选择一个候选人的职位进行导出。",
    "Recruiter_Settings_Action_Import_MsgSuccess": "求职者成功导入。你可以邀请他们参加面试/评核。",
    "Recruiter_Settings_Action_Import_MsgSuccess_old": "求职者成功导入。你可以邀请他们参加视频面试。",
    "Recruiter_Settings_Action_Import_Error": "不支持上传的文件。",
    "Recruiter_Settings_Action_Import_Error_Column_Not_Match": "提交的 Excel/CSV 档案的标题不符合格式要求，请参考示范作更新。",
    "Recruiter_Settings_Action_Import_Error_Column_duplicate": "多个求职者拥有相同的电子邮件地址，请删除并重新上传",
    "Recruiter_Settings_Action_Import_Error_Miss_Information": "部分候选人的强制提供资料不齐全，请复核。",
    "Recruiter_Settings_Action_Delete_MsgSuccess": "职位删除成功！",
    "Recruiter_Settings_Action_Delete_Error": "职位删除失败",
    "Recruiter_Setting_Msg_Delete_title": "删除职位",
    "Recruiter_Setting_Msg_Delete_content": "即将删除选定的职位，并不能复原。你确认进行吗？",
    "Recruiter_Setting_Msg_VideoWithAudio_title": "储存面试问题",
    "Recruiter_Setting_Msg_VideoWithAudio_content": "注意！ 有部分面试题目的虚拟面试官和自动问题发音同时开动。这会导致两个声音重叠。你确认要这样的设定吗？",
    "Recruiter_Settings_Instruction_1": "你好! {user},",
    "Recruiter_Settings_Instruction_2": "此页面显示评核列表，",
    "Recruiter_Settings_Instruction_3": "请按右上方的【新增职位】按钮以开始设定面试。",
    "Recruiter_Groups_Instruction_2": "此页面显示组成员的列表，",
    "Recruiter_Groups_Instruction_3": "点击右上角的 [ +创建组 ] 按钮以开始。",
    "Recruiter_Groups_Add_Recruiter_Success": "成功添加现有招聘人员",
    "Recruiter_Groups_Add_Recruiter_Success_New_Recruiter": "成功添加新招聘人员",
    "Recruiter_Groups_Add_Recruiter_Failed_Candidate_Present": "保存失败，招聘者在组内已存在",
    "Recruiter_Groups_Add_Recruiter_Failed_Billing_Admin_Duplicate_Email": "电子邮件不能与账单管理员相同",
    "Recruiter_Groups_Add_Recruiter_Failed_Dialog_Title_Warning": "警告",
    "Recruiter_Groups_Add_Recruiter_Failed_ApiPermissionError": "组已创建，但某些候选人无法添加",
    "Recruiter_Groups_Add_Recruiter_Warning_DialogTitle": "警告",
    "Recruiter_Groups_Add_Recruiter_Warning_DialogMessage": "无法添加以下账户：",
    "Recruiter_Groups_Add_Recruiter_Warning_DialogTable_Header_Email": "电子邮件",
    "Recruiter_Groups_Add_Recruiter_Warning_DialogTable_Header_Reason": "原因",
    "Recruiter_Groups_Add_Recruiter_Warning_Error_GAM_1001": "由于不兼容的 AI 模型，无法添加账户。",
    "Recruiter_Groups_Add_Recruiter_Warning_Error_GAM_1002": "由于评估类型不同，无法添加账户。",
    "Recruiter_Groups_Add_Recruiter_Warning_Error_Unknown": "未知错误。请联系支持",
    "Recruiter_Groups_Failed_ApiGeneralError": "API调用错误",
    "Recruiter_Groups_Add_Recruiter_Failed_ApiError": "出现了问题，请稍后再试",
    "Recruiter_Groups_New_Recruiter_Register_result_0": "谢谢。您的注册成功！",
    "Recruiter_Groups_New_Recruiter_Register_result_1": "链接令牌已过期。请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_Register_result_2": "链接令牌无效。请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_Register_result_3": "该招聘者已注册。如果这是意外情况，请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_Register_result_4": "该链接已被主办用户取消。请联系您的小组管理员。",
    "Recruiter_Groups_New_Recruiter_Register_result_9": "出现了问题。请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_CallRegister_Error_0": "谢谢。您的注册成功！",
    "Recruiter_Groups_New_Recruiter_CallRegister_Error_1": "链接令牌已过期。请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_CallRegister_Error_2": "链接令牌无效。请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_CallRegister_Error_3": "链接令牌无效。请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_CallRegister_Error_4": "密码不符合政策。请联系您的组管理员。",
    "Recruiter_Groups_New_Recruiter_CallRegister_Error_9": "出现问题。请联系您的组管理员。",
    "Recruiter_Settings_Add_Title": "请选择部门",
    "Recruiter_Settings_Add_RecentDepartment": "请從近期部门选择",
    "Recruiter_Settings_Add_CreateNewDepartment": "创建新部门",
    "Recruiter_Settings_Add_JobName": "新职位名称",
    "Recruiter_Settings_Add_Copy_title": "从其他职位复制设定",
    "Recruiter_Settings_Add_Confirm": "确认",
    "Recruiter_Settings_Test": "测试 {number}",
    "Recruiter_Settings_Test_Video_Interview": "视频面试",
    "Recruiter_Settings_Test_Multiple_Choices": "多项选择题",
    "Recruiter_Settings_Test_Short_Question": "短答題",
    "Recruiter_Settings_Test_Test_Name": "测试名称",
    "Recruiter_Settings_Test_Add_Test": "添加测试",
    "Recruiter_Settings_Special_Character_Error": "含禁止使用符号 (;/?:@=&)",
    "Recruiter_Settings_Duplicate_Department": "重覆的部门名称",
    "Recruiter_Settings_SideMenu_InterviewLayout": "评核布局",
    "Recruiter_Settings_SideMenu_InterviewQuestion": "面试问题",
    "Recruiter_Settings_SideMenu_InterviewEmail": "电邮和短信",
    "Recruiter_Settings_SideMenu_Scoring": "自动评分准则",
    "Recruiter_Settings_SideMenu_Evaluation": "评核员评分准则",
    "Recruiter_Settings_SideMenu_TestSetting": "评核设定",
    "Recruiter_Settings_Addjob_disable": "由于你的配额已用完，你不能添加新的职位。请联系你的管理员以获取更多面试名额.",
    "Recruiter_Stat_Title": "统计",
    "Recruiter_Stat_Filter": "选项",
    "Recruiter_Stat_Filter_OverallScore": "总分",
    "Recruiter_Stat_Filter_ImpressionScore": "印象分",
    "Recruiter_Stat_Filter_Potential_Work_Performance": "潜在工作表现",
    "Recruiter_Stat_Filter_Pace": "口才",
    "Recruiter_Stat_Filter_Enthusiasm": "热情",
    "Recruiter_Stat_Filter_SelfConfidence": "自信",
    "Recruiter_Stat_Filter_Composure": "沉着",
    "Recruiter_Stat_Filter_Leadership": "领导力",
    "Recruiter_Stat_Filter_Learning_Agility": "学习敏锐度",
    "Recruiter_Stat_Filter_Creativity_And_Innovation": "创造与创新",
    "Recruiter_Stat_Filter_Emotional_Intelligence": "情商",
    "Recruiter_Stat_Filter_Communication": "沟通",
    "Recruiter_Stat_Filter_Interpersonal_Relationship": "人际关系",
    "Recruiter_Stat_Filter_Goal_And_Achievement_Striving": "目标与成就",
    "Recruiter_Stat_Filter_Impression": "印象分数",
    "Recruiter_Stat_Filter_TaskPerformance": "处事表现",
    "Recruiter_Stat_Filter_ContextualPerformance": "关系表现",
    "Recruiter_Stat_Filter_AdaptivePerformance": "适应性表现",
    "Recruiter_Stat_Action_Export": "输出",
    "Recruiter_Stat_Section_CompletedCandidates": "完整候选人",
    "Recruiter_Stat_Section_NoOfDaysLeft": "剩余天数",
    "Recruiter_Stat_Section_NoOfQuestion": "问题数量",
    "Recruiter_Stat_Section_NoOfCandidate": "候选人数量",
    "Recruiter_Stat_Section_Deadline": "截止日期",
    "Recruiter_Stat_Section_Trackers": "追踪器",
    "Recruiter_Stat_Section_Trackers_Invitation": "邀请",
    "Recruiter_Stat_Section_Trackers_Reminder": "提醒",
    "Recruiter_Stat_Section_Trackers_Confirmation": "确认",
    "Recruiter_Stat_Section_OverallScore": "总分",
    "Recruiter_Stat_Section_OverallScore_Average": "平均",
    "Recruiter_Stat_Section_OverallScore_StandardDeviation": "标准差",
    "Recruiter_Stat_Section_OverallScore_Skewness": "偏度",
    "Recruiter_Stat_Section_CandidateVideoScoreDist": "候选人视频分数分别",
    "Recruiter_Stat_Section_NormalizedScore": "标准化分数",
    "Recruiter_Stat_Deadline_Expired": "已过期",
    "Recruiter_JobSelection_Title": "请选择职位: ",
    "Recruiter_ProgrammeSelection_Title": "请选择部门: ",
    "Recruiter_ProgrammeSelection_Cancel": "取消",
    "Recruiter_ProgrammeSelection_Go_Back": "返回",
    "Recruiter_Dashboard_Title": "候选人",
    "Recruiter_Dashboard_CandidateCount": "{count} 候选人",
    "Recruiter_Dashboard_InterviewDeadline": "面试截止时间:",
    "Recruiter_Dashboard_Search": "搜索",
    "Recruiter_Dashboard_FilterByTop": "按顶部筛选",
    "Recruiter_Dashboard_Add_Candiadte": "新增候选人",
    "Recruiter_Dashboard_BulkInvite": "邀请",
    "Recruiter_Dashboard_BulkReport": "给求职者发送报告",
    "Recruiter_Dashboard_BulkExport": "输出",
    "Recruiter_Dashboard_BulkModify": "更改截止日",
    "Recruiter_Dashboard_BulkAction": "操作",
    "Recruiter_Dashboard_BulkDelete": "删除",
    "Recruiter_Dashboard_BulkRedo": "重设",
    "Recruiter_Dashboard_BulkDownloadPDF": "下载 PDF 报告",
    "Recruiter_Dashboard_Filter_Auto_Score": "自动评分",
    "Recruiter_Dashboard_Filter_Recruiter_Score": "我的评分",
    "Recruiter_Dashboard_Action_View": "浏览",
    "Recruiter_Dashboard_Action_Invite": "邀请",
    "Recruiter_Dashboard_Action_Redo": "重來",
    "Recruiter_Dashboard_TableColumn_Name": "姓名",
    "Recruiter_Dashboard_TableColumn_University": "学校",
    "Recruiter_Dashboard_TableColumn_Status": "状态",
    "Recruiter_Dashboard_TableColumn_Status_Pending": "待发邀请...",
    "Recruiter_Dashboard_TableColumn_Status_Application_Failed": "申请失败",
    "Recruiter_Dashboard_TableColumn_Status_Wait_Invite": "已发送邀请，待评核",
    "Recruiter_Dashboard_TableColumn_Status_Processing": "处理视频中...",
    "Recruiter_Dashboard_TableColumn_Status_Complete": "完成",
    "Recruiter_Dashboard_TableColumn_Status_Partial_Complete": "部分完成",
    "Recruiter_Dashboard_TableColumn_AutoScoring": "自动评分",
    "Recruiter_Dashboard_TableColumn_RecruiterScoring": "我的评分",
    "Recruiter_Dashboard_TableColumn_TestScores": "测试分数",
    "Recruiter_Dashboard_TableColumn_TotalScore": "总分",
    "Recruiter_Dashboard_TableColumn_Video": "视频",
    "Recruiter_Dashboard_TableColumn_AIReport": "AI 报告",
    "Recruiter_Dashboard_TableColumn_RecruiterEvaluation": "招聘人员评分",
    "Recruiter_Dashboard_TableColumn_Start_Date": "评核开始",
    "Recruiter_Dashboard_TableColumn_End_Date": "评核截止日期",
    "Recruiter_Dashboard_TableColumn_Action": "操作",
    "Recruiter_Dashboard_TableColumn_Delete": "删除",
    "Recruiter_Dashboard_TableColumn_Tooltip_Invite": "邀请评核",
    "Recruiter_Dashboard_TableColumn_Tooltip_Report": "发送报告",
    "Recruiter_Dashboard_TableColumn_Tooltip_Report_Sent": "求职者报告已发送",
    "Recruiter_Dashboard_TableColumn_Tooltip_Redo": "重设面试",
    "Recruiter_Dashboard_TableColumn_Tooltip_Delete": "删除候选人",
    "Recruiter_Dashboard_TableColumn_Pending": "待评核",
    "Recruiter_Dashboard_TableColumn_Tooltip_Shortlist": "入围",
    "Recruiter_Dashboard_TableColumn_Tooltip_Reject": "不录用",
    "Recruiter_Dashboard_TableColumn_Tooltip_WaitingList": "加入候补名单",
    "Recruiter_Dashboard_TableColumn_Tooltip_Edit": "更新候选人资料",
    "Recruiter_Dashboard_TableColumn_Tooltip_change_deadline": "更改截止日",
    "Recruiter_Dashboard_TableColumn_Tooltip_Share": "分享结果",
    "Recruiter_Dashboard_TableColumn_Tooltip_CV_Uploaded": "简历已上传",
    "Recruiter_Dashboard_TableColumn_Tooltip_Download": "下载候选人的视频",
    "Recruiter_Dashboard_Dialog_Invitation_Title": "邀请",
    "Recruiter_Dashboard_Dialog_Report_Title": "报告",
    "Recruiter_Dashboard_Dialog_Invitation": "你想向选定的求职者发送评核邀请吗？",
    "Recruiter_Dashboard_Dialog_Report": "你想将求职者报告发送给选定的求职者吗？",
    "Recruiter_Dashboard_Dialog_Wrong_CV_Filetype": "简历上传失败。请检查档案格式。",
    "Recruiter_ShareDialog_Title": "分享结果",
    "Recruiter_ShareDialog_Subtitle_1": "已选择的候选人",
    "Recruiter_ShareDialog_Caption_1": "这是你选择分享的候选人。你可以按电子邮件旁边的叉号将其删除。",
    "Recruiter_ShareDialog_ReviewerInfo": "评核员信息",
    "Recruiter_ShareDialog_Caption_2": "你可以通过按\"添加\"按钮将邀请电子邮件发送给多个评核员。",
    "Recruiter_ShareDialog_Add": "添加",
    "Recruiter_ShareDialog_Name": "姓名",
    "Recruiter_ShareDialog_Email": "电邮",
    "Recruiter_ShareDialog_Message": "邀请信息(非必填)",
    "Recruiter_ShareDialog_Caption_3": "此邀请信息将附加到电子邮件中。",
    "Recruiter_ShareDialog_Confirm": "确定",
    "Recruiter_ShareDialog_Cancel": "取消",
    "Recruiter_ShareDialog_Success": "已成功发送邀请电邮。",
    "Recruiter_ShareDialog_Fail": "发送邀请电邮失败。",
    "Recruiter_Dashboard_Msg_Invite_Duplicate_title": "重发电子邮件",
    "Recruiter_Dashboard_Msg_Report_Duplicate_title": "重新发送报告",
    "Recruiter_Dashboard_Msg_Invite_Duplicate_content": "你已经向该候选人发送了邀请。 你想再次发送吗？",
    "Recruiter_Dashboard_Msg_Report_Duplicate_content": "你已经向该求职者发送了求职者报告。你要再次发送吗？",
    "Recruiter_Dashboard_InviteDuplicate_No": "否",
    "Recruiter_Dashboard_InviteDuplicate_Yes": "是",
    "Recruiter_Dashboard_InviteSuccess": "已成功发送电邮.",
    "Recruiter_Dashboard_InviteFail": "电邮发送失败。请复核这职位的电邮设置。",
    "Recruiter_Dashboard_ReportSuccess": "报告已成功发送。",
    "Recruiter_Dashboard_ReportFail": "无法发送报告。请检查此职位的电邮设定。",
    "Recruiter_Dashboard_RedoFail": "发生了一些错误。 (重置)",
    "Recruiter_Dashboard_DeleteFail": "发生错误（删除）",
    "Recruiter_Dashboard_ExportSuccess": "已成功输出候选人的资料!",
    "Recruiter_Dashboard_ExportProcessing": "文件正在处理中。请检查“导出的文件”选项卡。",
    "Recruiter_Dashboard_ExportLimit": "导出失败！所选候选人超过每次导出的 10,000 名候选人限制。请选取更少的候选人进行导出。",
    "Recruiter_Dashboard_ExportFail": "导出失败！被选中的求职者尚未完成评核。",
    "Recruiter_Dashboard_BulkDuplicateInvite": "以下的候选人已被邀请过。你要重新邀请吗?",
    "Recruiter_Dashboard_Sending_Invitation": "正在发送邀请 ...",
    "Recruiter_Dashboard_Sending_Report": "发送报告...",
    "Recruiter_Dashboard_Msg_Redo_title": "重设候选人资料",
    "Recruiter_Dashboard_Msg_Redo_content": "此操作将重置你选择的求职者数据（包括视频和AI分数），并允许这些求职者重新进行在线评核。你确定这样做吗？",
    "Recruiter_Dashboard_Msg_Delete_title": "删除候选人",
    "Recruiter_Dashboard_Msg_Delete_content": "即将删除选定的后选人，并不能复原。你确认进行吗？",
    "Recruiter_Dashboard_Import_Dialog_Title": "新增候选人",
    "Recruiter_Dashboard_Import_Dialog_Form_Label": "表格输入",
    "Recruiter_Dashboard_Import_Dialog_Excel_Label": "Excel 输入",
    "Recruiter_Dashboard_Import_Dialog_CV_Label": "通过简历",
    "Recruiter_Dashboard_Import_Dialog_Field_Name": "全名",
    "Recruiter_Dashboard_Import_Dialog_Field_Email": "电邮",
    "Recruiter_Dashboard_Import_Dialog_Field_Country_Code": "国家代码",
    "Recruiter_Dashboard_Import_Dialog_Field_Phone_Number": "电话",
    "Recruiter_Dashboard_Import_Dialog_Field_Degree": "最高学历",
    "Recruiter_Dashboard_Import_Dialog_Field_University": "学校",
    "Recruiter_Dashboard_Import_Dialog_Instruction": "选择这些求职者的评核开始和截止日期",
    "Recruiter_Dashboard_Import_Dialog_Column_Name": "名字",
    "Recruiter_Dashboard_Import_Dialog_Column_Email": "电邮",
    "Recruiter_Dashboard_Import_Dialog_Column_Status": "状态",
    "Recruiter_Dashboard_Import_Duplicate_Dialog_Title": "发现重复电邮",
    "Recruiter_Dashboard_Import_Duplicate_Dialog_Content": "部分候选人的名字/电邮已在列表上。你确认要覆盖这些资料吗？",
    "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Title": "成功导入!",
    "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Content": "检测到一些电子邮件在 excel/csv 文件中重复出现。只有第一个出现的行将被导入，其他行将被放弃。",
    "Recruiter_Dashboard_Import_Duplicate_In_Excel_Dialog_Repeat_Tag": "重复出现",
    "Recruiter_Dashboard_Change_Deadline_Dialog_Title": "更改截止日",
    "Recruiter_Dashboard_Change_Deadline_Dialog_Subtitle": "更改面试截止日为:",
    "Recruiter_Dashboard_Change_Deadline_Dialog_SendEmail": "发电邮/短讯给候选人",
    "Recruiter_Dashboard_Change_Deadline_Dialog_Msg": "成功更新截止日",
    "Recruiter_Dashboard_Msg_Invite_After_Modify_title": "现在发出邀请吗?",
    "Recruiter_Dashboard_Msg_Invite_After_Modify_content": "我们注意到你还没有邀请一些候选人。你想立即向他们发送更新截止日期的邀请吗？",
    "Recruiter_Dashboard_Msg_Invite_After_Modify_Button_Yes": "现在发出",
    "Recruiter_Dashboard_Msg_Invite_After_Modify_Button_No": "不要发出",
    "Recruiter_Dashboard_Modify_Deadline_Msg": "成功更新截止日期",
    "Recruiter_Dashboard_Add_New_Candiadte": "新增候选人",
    "Recruiter_Dashboard_Status_Results": "查看面试结果",
    "Recruiter_Dashboard_Status_Pending": "等待面试结果",
    "Recruiter_Dashboard_TableColumn_Status_Shortlisted": "已入围",
    "Recruiter_Dashboard_TableColumn_Status_WaitingListed": "在候补名单",
    "Recruiter_Dashboard_TableColumn_Status_Rejected": "不录用",
    "Recruiter_Dashboard_Instruction_1": "这页列出当前职位的候选人名单",
    "Recruiter_Dashboard_Instruction_2": "按右上角的 [ +新增求职者 ] 按钮将求职者添加到评核并设置评核日期。",
    "Recruiter_Dashboard_Edit_Dialog_Failed": "候选人资料更新失败",
    "Recruiter_Dashboard_Edit_Dialog_Email_Change_Reminder": "你已更新求职者的电邮。如果你之前邀请过求职者进行评核，请注意重新邀请求职者。",
    "Recruiter_Dashboard_Status_Filter_Caption": "搜索:",
    "Recruiter_Dashboard_Status_Filter_Title": "搜索面试状态",
    "Recruiter_Dashboard_Status_Filter_All": "所有",
    "Recruiter_Dashboard_Addcandidate_disable": "因为你已经用完面试限额，你不能再增加新的候选人。请联系你的系统管理人以购买更多面试额度。",
    "Recruiter_Dashboard_Redo_Questions_Dialog_Title": "重做面试题目",
    "Recruiter_Dashboard_Redo_Questions_Dialog_Instruction": "请选择需要重做的题目",
    "Recruiter_Dashboard_Redo_Questions_Dialog_SendEmail": "发电邮给候选人",
    "Recruiter_Dashboard_TableColumn_Tooltip_RedoQuestions": "重做面试题目",
    "Recruiter_Dashboard_BulkSharing_Tooltip": "未入选求职者或部分入选求职者未完成评核无法审核",
    "Recruiter_Evaluation_Norating": "没有评核员评分",
    "Recruiter_ReportSideBar_VideoInterview": "视频面试",
    "Recruiter_ReportSideBar_FullInterview": "完整面试",
    "Recruiter_ReportSideBar_GeneralHR": "一般人力资源",
    "Recruiter_ReportSideBar_Competency": "胜任力",
    "Recruiter_ReportSideBar_Technical": "技能",
    "Recruiter_ReportSideBar_AutoScoring": "自动评分",
    "Recruiter_ReportSideBar_OverallScore": "总共得分",
    "Recruiter_ReportSideBar_AIReport": "AI 报告",
    "Recruiter_ReportSideBar_RecruiterEvaluation": "招聘人员评分",
    "Recruiter_VideoInterview_BackToDashboard": "返回候选人列表",
    "Recruiter_VideoInterview_Title": "视频面试",
    "Recruiter_VideoInterview_QuestionSet": "问题设置 {no}",
    "Recruiter_VideoInterview_Question": "问题 {no}: {question}",
    "Recruiter_VideoInterview_Back": "返回",
    "Recruiter_VideoInterview_Next": "继续",
    "Recruiter_VideoInterview_NoQuestion": "此类别中没有问题",
    "Recruiter_VideoInterview_NoVideoSubmitted": "候选人尚未完成此问题",
    "Recruiter_Multiple_Choices_QuestionSet": "问题集 {no}",
    "Recruiter_Short_Question_QuestionSet": "问题集 (no}",
    "Recruiter_CandidateResult_Title": "面试分析",
    "Recruiter_CandidateResult_Multiple_Choices_Title": "多项选择题分析",
    "Recruiter_CandidateResult_Short_Questions_Title": "短答题分析",
    "Recruiter_CandidateResult_AnswerList": "求职者答案列表",
    "Recruiter_CandidateResult_Name": "姓名:",
    "Recruiter_CandidateResult_Email": "电邮:",
    "Recruiter_Dashboard_Import_Dialog_Field_1st_Preference": "第一偏好",
    "Recruiter_Dashboard_Import_Dialog_Field_2nd_Preference": "第二偏好",
    "Recruiter_CandidateResult_University": "大学:",
    "Recruiter_CandidateResult_Degree": "学历:",
    "Recruiter_CandidateResult_1st_Preference": "第一偏好:",
    "Recruiter_CandidateResult_2nd_Preference": "第二偏好:",
    "Recruiter_CandidateResult_NextCandidate": "下一位候选人",
    "Recruiter_CandidateResult_LastCandidate": "上一位候选人",
    "Recruiter_CandidateResult_FacialExpression": "面部表情标签",
    "Recruiter_CandidateResult_MyComment": "我的评语:",
    "Recruiter_CandidateResult_MyScoring": "我的评分",
    "Recruiter_CandidateResult_Transcribe": "文本转换",
    "Recruiter_CandidateResult_AutoScoring": "自动评分",
    "Recruiter_CandidateResult_ReviewerScoring": "评核员评分",
    "Recruiter_CandidateResult_Resume": "简历",
    "Recruiter_CandidateResult_Report": "下载PDF报告",
    "Recruiter_CandidateResult_Save": "储存",
    "Recruiter_CandidateResult_Indicator": "感情指标",
    "Recruiter_CandidateResult_Emotion": "情绪比率",
    "Recruiter_CandidateResult_Time": "时间",
    "Recruiter_CandidateResult_PositiveEmotions": "积极情绪",
    "Recruiter_CandidateResult_NeutralEmotions": "中性情绪",
    "Recruiter_CandidateResult_NegativeEmotions": "消极情绪",
    "Recruiter_CandidateResult_Translation_title": "候选人的答案文本如下:",
    "Recruiter_CandidateResult_Tooltip_City": "城市",
    "Recruiter_CandidateResult_Tooltip_Country": "国家",
    "Recruiter_CandidateResult_Tooltip_IP": "IP 地址",
    "Recruiter_CandidateResult_Tooltip_Complete": "完成时日",
    "Recruiter_CandidateResult_Tooltip_Download_Resume": "下载简历",
    "Recruiter_CandidateResult_Total_Score": "总分: {score}",
    "Recruiter_CandidateResult_Correct": "{logo} 正确",
    "Recruiter_CandidateResult_Wrong": "{logo} 错误",
    "Recruiter_CandidateResult_Model_Answer": "标准答案:",
    "Recruiter_CandidateResult_Candidate_Answer": "求职者答案:",
    "Recruiter_CandidateResult_Action": "操作",
    "Recruiter_CandidateResult_ErrorViewingShortQuestions": "该求职者尚未完成短答题评核",
    "Recruiter_CandidateResult_ErrorViewingMultipleChoicesQuestions": "该求职者尚未完成短答题评核",
    "Recruiter_AIReport_BackToDashboard": "返回候选人列表",
    "Recruiter_AIReport_Title": "AI 报告",
    "Recruiter_AIReport_OverallScore": "总共得分",
    "Recruiter_AIReport_Percentile": "百分位",
    "Recruiter_AIReport_Passed": "通过",
    "Recruiter_AIReport_Failed": "失败",
    "Recruiter_AIReport_Impression": "印象",
    "Recruiter_AIReport_PotentialWorkPerformance": "潜在工作表现",
    "Recruiter_AIReport_TaskPerformance": "处事表现",
    "Recruiter_AIReport_ContextualPerformance": "关系表现",
    "Recruiter_AIReport_AdaptivePerformance": "适应性表现",
    "Recruiter_AIReport_Rating": "评分",
    "Recruiter_AIReport_Weighting": "权重",
    "Recruiter_AIReport_QualitativeAnalysis": "定性分析",
    "Recruiter_AIReport_NoReportAnnounce": "这候选人没有按指示完成面试，故此不能产生智能报告。",
    "Recruiter_AIReport_ReportInProgress": "面试分析仍在进行中， 请稍候…",
    "Recruiter_AIReport_task_performance_high": "表现出高度的计划、组织、管理日常工作的能力，并能履行大部分的职责",
    "Recruiter_AIReport_interpersonal_relationship_communication_high": "表现出与他人有效互动并与部门/组织建立积极关系的能力",
    "Recruiter_AIReport_adaptability_high": "表现出较强灵活应变能力和适应新环境的能力，能够立即调整常规，在与他人的互动中非常灵活地拥有自己的方法",
    "Recruiter_AIReport_task_performance_medium": "表现出计划、组织、管理日常工作的能力较低，并能履行部分工作职责",
    "Recruiter_AIReport_interpersonal_relationship_communication_medium": "表现出与他人有效互动并与部门/组织建立积极关系的中等能力",
    "Recruiter_AIReport_adaptability_medium": "表现出适度灵活性和适应变化，通常愿意在与他人互动时调整常规或自己的方法",
    "Recruiter_AIReport_task_performance_low": "表现出缺乏计划、组织、管理日常工作的能力，不能履行工作职责",
    "Recruiter_AIReport_interpersonal_relationship_communication_low": "表现出较差与他人有效互动和与部门/组织建立积极关系的能力",
    "Recruiter_AIReport_adaptability_low": "表现出相当不灵活或不适应变化，在与他人互动时很少尝试调整常规或自己的方法",
    "Recruiter_AIReport_task_performance_0": "这种能力无法确定。这通常是因为候选人没有回答相应的面试问题或提供面试视频。",
    "Recruiter_AIReport_interpersonal_relationship_communication_0": "这种能力无法确定。这通常是因为候选人没有回答相应的面试问题或提供面试视频。",
    "Recruiter_AIReport_adaptability_0": "这种能力无法确定。这通常是因为候选人没有回答相应的面试问题或提供面试视频。",
    "Recruiter_AIReport_pace_high": " 以接近理想的速度说话并在速度和节奏上能清晰表达自己，表现出较系统性的思想。",
    "Recruiter_AIReport_leadership_high": " 的分数较高，表示具备领导力质量，能自信地领导和指导他人，并致力于使他们表现出色。",
    "Recruiter_AIReport_learning_agility_high": " 的分数较高，表示持续的学习态度，渴望获得新技能和新知识，并运用它们带来改变。",
    "Recruiter_AIReport_creativity_innovation_high": " 的分数较高，表示对新思想的倾向，富有想像力和冒险精神去创造新思想，而不是墨守常规或传统。",
    "Recruiter_AIReport_interpersonal_relationship_high": " 的分数较高，表示与人交往时非常友好、开朗、善于交际，能有效地建立融洽和谐的人际关系。",
    "Recruiter_AIReport_goal_and_achievement_striving_high": " 的分数较高，表示着他/她努力工作和雄心勃勃，并有动力实现更高的目标和成就。",
    "Recruiter_AIReport_developing_people_high": "展现出强烈的基于能力用人的思维方式和主动性，以支持对方的个人和职业发展",
    "Recruiter_AIReport_responsibility_high": "表现出责任感，实现目标和成果的动力，知道如何最好地利用自己的能力来满足工作要求和独立完成工作",
    "Recruiter_AIReport_managing_execution_high": "在规划和管理资源、任务和/或项目方面有良好的组织和协调；以谨慎和认真的方式工作，知道如何根据交付的目标和时间安排任务的优先次序",
    "Recruiter_AIReport_analytical_and_logical_thinking_high": "善于探索思想和研究信息，系统地收集和综合信息和思想以进行分析，并从世代观察和特定事实中得出逻辑结论",
    "Recruiter_AIReport_complex_problem_solving_high": "能够阐明问题的性质，在评核替代方案，提出可行的解决方案以及做出合理的判断和决定时灵活而开放",
    "Recruiter_AIReport_communication_high": "能够以清晰、简洁的方式口头表达信息和想法，语气和声音平静、确定",
    "Recruiter_AIReport_caring_and_empathy_high": "表现出对他人的关怀、同情和关心，练习积极的倾听技巧，在人际关系工作中表现出耐心和正直",
    "Recruiter_AIReport_english_oral_communication_high": "讲得很流利，而且思想和观念也很清晰",
    "Recruiter_AIReport_cantonese_oral_communication_high": "讲得很流利，而且思想和观念也很清晰",
    "Recruiter_AIReport_mandarin_oral_communication_high": "讲得很流利，而且思想和观念也很清晰",
    "Recruiter_AIReport_team_collaboration_and_inclusion_high": "对他人和蔼可亲、体贴他人，具有团队合作精神和支持性，能够与不同背景的同事和同事一起工作，性格随和，文化敏感",
    "Recruiter_AIReport_building_relationships_and_network_high": "善于交际，具有良好的人际交往能力，能够与各种人成功互动，并且懂得如何解释和使用身体； 以力量为基础的思维方式，支持他人的个人发展",
    "Recruiter_AIReport_flexibility_and_adaptability_high": "灵活并愿意根据新情况适应行为；乐于调整做法或与他人互动的方法",
    "Recruiter_AIReport_creativity_and_innovation_high": "思想开明，善于探究，能够创造性地思考，产生新的甚至是颠覆性的想法；运用新方法解决问题，并推动新发明创造新事物或设计",
    "Recruiter_AIReport_emotional_intelligence_high": "在面对挑战时表现出冷静，和/或有耐心处理不同背景的客户（残疾人、老人或儿童）",
    "Recruiter_AIReport_enthusiasm_high": "表现出愉快，传达积极情绪和能量的感觉",
    "Recruiter_AIReport_composure_high": "表现出沉着冷静，在压力下不易受到压力的影响",
    "Recruiter_AIReport_self_confidence_high": "展现自己时表现出自信并与人相处时感到自在",
    "Recruiter_AIReport_vision_and_entrepreneurial_mindset_high": " 表现出发现问题和创造愿景的独特能力，并具有强大的企业家思维，积极抓住机遇并采取行动，以带来具有深思熟虑风险的创新和发明",
    "Recruiter_AIReport_technology_expertise_and_business_sense_high": " 展示技能和知识的专长，具有良好的商业意识，能够充分理解市场生态和需求",
    "Recruiter_AIReport_effective_communication_and_teambuilding_high": " 表现出很强的能力以清晰简洁的方式传达思想，并能够非常有效地影响和吸引他人，以建立一个成功的团队",
    "Recruiter_AIReport_grit_and_passion_high": " 在面对挑战和逆境时表现出强烈的勇气和成功的决心，并具有毅力和对实现长期目标的热情",
    "Recruiter_AIReport_pace_medium": " 说话既不会太快也不会太慢",
    "Recruiter_AIReport_leadership_medium": " 的分数中等，表示具有中等程度的领导才能，可以领导和影响他人，并在这些领域具有较高的绩效和改进余地",
    "Recruiter_AIReport_learning_agility_medium": " 的分数中等，表示对获取新知识和经验有中等程度的兴趣的态度，能够意识到他们能够带来改变",
    "Recruiter_AIReport_creativity_innovation_medium": " 的分数中等，表示对产生新的想法有中等程度的偏好，富有想像力，并且有可能打破推陈出新",
    "Recruiter_AIReport_interpersonal_relationship_medium": " 的分数中等，表示在与他人打交道，或能够与他人建立关系时，表现出适度的友好、热情和社交能力",
    "Recruiter_AIReport_goal_and_achievement_striving_medium": " 的分数中等，表示中等程度的努力工作、雄心勃勃或有动力达到更高的目标和成就。",
    "Recruiter_AIReport_developing_people_medium": " 表現出適度的基於能力用人的思維和主動性，以支持對方的個人和職業發展",
    "Recruiter_AIReport_responsibility_medium": " 适度可靠，专注于实现目标和结果，交付满足工作要求所需的事宜",
    "Recruiter_AIReport_managing_execution_medium": " 在资源、任务和/或项目的规划和协调方面有适度的组织和责任心，根据目标和交付时间安排任务的优先次序",
    "Recruiter_AIReport_analytical_and_logical_thinking_medium": " 适度地研究思想或主动研究信息，适度系统地收集和综合信息和思想以进行分析，得出合理的结论",
    "Recruiter_AIReport_complex_problem_solving_medium": " 能够适当地利用信息来尝试评核备选方案，使用合理的逻辑和判断力进行决策",
    "Recruiter_AIReport_communication_medium": " 能以清晰简洁的方式口头表达信息和想法，语气和声音适度冷静和确定",
    "Recruiter_AIReport_caring_and_empathy_medium": " 表现出适度的关心，对他人有同情心，有一定的耐心，通常愿意倾听他人的需求，在人际关系工作中保持足够的正直",
    "Recruiter_AIReport_english_oral_communication_medium": " 说话基本流利，或对思想和观念的表达基本清晰",
    "Recruiter_AIReport_cantonese_oral_communication_medium": " 说话基本流利，或对思想和观念的表达基本清晰",
    "Recruiter_AIReport_mandarin_oral_communication_medium": " 说话基本流利，或对思想和观念的表达基本清晰",
    "Recruiter_AIReport_team_collaboration_and_inclusion_medium": " 既不体贴也不冷漠，与他人合作时通常会合作并乐于助人，与不同背景的同事合作时会表现出适度的同意和文化敏感性",
    "Recruiter_AIReport_building_relationships_and_network_medium": " 与人相处融洽，偶尔也能享受私人时间，具备良好的人际交往能力，能够与不同类型的人成功互动或具有基于力量的思维方式，专注于他人的个人发展",
    "Recruiter_AIReport_flexibility_and_adaptability_medium": " 面对新情况时具有适度的灵活性和适应性，在可行情况下尝试调整做法或与他人互动的方法",
    "Recruiter_AIReport_creativity_and_innovation_medium": " 有一定的开放性或好奇心，能产生新的想法；通常采用临时解决方案来解决老问题，并能改变一些既定的做法，但可能不是独创性的设计或解决方案",
    "Recruiter_AIReport_emotional_intelligence_medium": " 在面对挑战时，有意识地控制自己的情绪；通常有耐心，能够容忍不同背景的客户（残疾人、老人或儿童）",
    "Recruiter_AIReport_enthusiasm_medium": " 表现出适度开朗，传达适度的积极情绪和能量",
    "Recruiter_AIReport_composure_medium": " 在压力下表现出适度的镇定和镇定的倾向，并容易受到压力",
    "Recruiter_AIReport_self_confidence_medium": " 表现出自我展示时的适度自信和与人相处的适度自在",
    "Recruiter_AIReport_vision_and_entrepreneurial_mindset_medium": " 具有适度的发现问题和创造远见的能力，并具有适度的企业家心态，可以抓住机遇并采取行动，以带来具有深思熟虑风险的创新和发明",
    "Recruiter_AIReport_technology_expertise_and_business_sense_medium": " 表现出中等水平的技能和知识，具有中等商业意识，能够理解市场生态及需求",
    "Recruiter_AIReport_effective_communication_and_teambuilding_medium": " 表现出适度的能力，能够以简洁明了的方式交流思想，并能够影响和吸引其他人来建立一个成功的团队",
    "Recruiter_AIReport_grit_and_passion_medium": " 在面对挑战和逆境时表现出适度的勇气和成功的决心，以及对实现长期目标的适度的毅力和热情",
    "Recruiter_AIReport_pace_low": " 说话的速度太快或太慢，无法为听众调整速度和节奏",
    "Recruiter_AIReport_leadership_low": " 的分数较低，表示不具备的领导才能，没有足够的自信来领导和指导他人，并使他们表现出色",
    "Recruiter_AIReport_learning_agility_low": " 的分数较低，表示对获取新知识和经验几乎没有兴趣，并且意识不到需要做出改变",
    "Recruiter_AIReport_creativity_innovation_low": " 的分数较低，表示不太倾向于偏离现行做法和传统，希望保持稳定感",
    "Recruiter_AIReport_interpersonal_relationship_low": " 的分数较低，意味着在与他人打交道时更加保守，不那么热情和善于交际，并且更加独立，而不是团队精神",
    "Recruiter_AIReport_goal_and_achievement_striving_low": " 的分数较低，表示他/她无忧无虑，没有野心，更容易满足于成就。",
    "Recruiter_AIReport_developing_people_low": " 较少表现出基于能力用人的思维和主动性，以支持对方的个人和职业发展",
    "Recruiter_AIReport_responsibility_low": " 感到没有义务或没有责任实现目标和结果；放松身心，轻松完成工作",
    "Recruiter_AIReport_managing_execution_low": " 缺乏系统性和谨慎性，不注重对资源、任务和项目进行详细的规划和协调，不按照交付的目标和时间表进行",
    "Recruiter_AIReport_analytical_and_logical_thinking_low": " 对探索想法不感兴趣或不好奇，不主动研究、收集或综合正确而充分的信息进行分析和作出逻辑结论",
    "Recruiter_AIReport_complex_problem_solving_low": " 无法阐明问题的性质以评核或提出选择方案，也无法基于合理的逻辑或判断做出决定",
    "Recruiter_AIReport_communication_low": " 表现出以清晰简洁的方式表达信息和想法的能力较弱，并且在语气和声音上表现出一些紧张和怀疑",
    "Recruiter_AIReport_caring_and_empathy_low": " 对他人表现出很少的同理心或同情心，缺乏耐心或意愿去听取他人的需求或在人际交往中坚持正直原则",
    "Recruiter_AIReport_english_oral_communication_low": " 说话不太流利，或对思想和观念的表达不够清晰",
    "Recruiter_AIReport_cantonese_oral_communication_low": " 说话不太流利，或对思想和观念的表达不够清晰",
    "Recruiter_AIReport_mandarin_oral_communication_low": " 说话不太流利，或对思想和观念的表达不够清晰",
    "Recruiter_AIReport_team_collaboration_and_inclusion_low": " 以自我为中心，不太关心他人，喜欢单独工作而不是团队合作，不太讨人喜欢，可能会与他人发生冲突，在与同事或同事合作时文化敏感度较低",
    "Recruiter_AIReport_building_relationships_and_network_low": " 内向且不积极寻求建立人际关系，缺乏良好的人际交往技能，无法成功地与他人互动；不接受支持他人个人发展的基于力量的心态",
    "Recruiter_AIReport_flexibility_and_adaptability_low": " 对处理变化比较死板并比难适应，很少尝试调整做法或与他人互动的方法",
    "Recruiter_AIReport_creativity_and_innovation_low": " 传统和墨守陈规的，对产生新想法的好奇心较小； 坚持解决问题的旧方法，并且不能偏离当前的实践来创造原创的设计或解决方案",
    "Recruiter_AIReport_emotional_intelligence_low": " 在面对挑战时表现出紧张和缺乏自信；在与不同背景的客户（残疾人、老人或儿童）打交道时，可能缺乏耐心和宽容",
    "Recruiter_AIReport_enthusiasm_low": " 表现出相当冷漠和超然的倾向，很少传达积极的情绪和能量",
    "Recruiter_AIReport_composure_low": " 表现出紧张或挫败感，在压力下容易受到压力",
    "Recruiter_AIReport_self_confidence_low": " 表现出自我介绍时缺乏自信，与人相处不太自在",
    "Recruiter_AIReport_vision_and_entrepreneurial_mindset_low": " 表现出发现问题和创造愿景的能力不足，并且缺乏企业家的心态。不能有效抓住机会并采取行动以带来创新和发明",
    "Recruiter_AIReport_technology_expertise_and_business_sense_low": " 表现出很少的技能或知识，并且缺乏认识市场生态和需求的商业意识",
    "Recruiter_AIReport_effective_communication_and_teambuilding_low": " 不能以清晰，简洁的方式传达思想，也无法影响和吸引他人来建立成功的团队",
    "Recruiter_AIReport_grit_and_passion_low": " 在面对挑战和逆境时，很少表现出成功的勇气或决心，也没有表现出实现长期目标的毅力或热情",
    "Recruiter_AIReport_0": "无法确定此能力。这通常是因为候选人未回答相应的面试问题或未提供面试视频。",
    "Recruiter_AIRating_Comment": "评论",
    "Recruiter_AIRating_BackToDashboard": "返回候选人列表",
    "Recruiter_AIRating_Title": "AI评分",
    "Recruiter_AIRating_OverallScore": "总共得分",
    "Recruiter_AIRating_Percentile": "百分位",
    "Recruiter_AIRating_Passed": "通过",
    "Recruiter_AIRating_Failed": "失败",
    "Recruiter_AIRating_ImpressionScore": "印象分数:",
    "Recruiter_AIRating_Impression": "印象分数:",
    "Recruiter_AIRating_PotentialWorkPerformanceScore": "潜在工作表现分数:",
    "Recruiter_AIRating_FullMark": "满分十分",
    "Recruiter_AIRating_HighScore": "高分: 7.0及以上",
    "Recruiter_AIRating_LowScore": "低分: 5.0及以下",
    "Recruiter_AIRating_RadarLabel": [
        "目标与成就",
        "领导力",
        "创造与创新",
        "学习敏锐度",
        "沟通",
        "人际关系",
        "情商"
    ],
    "Recruiter_AIRating_Big5Score": "Big 5 分数:",
    "Recruiter_AIRating_TotalScore": "总分:",
    "Recruiter_AIRating_TaskPerformance": "处事表现分数",
    "Recruiter_AIRating_ContextualPerformance": "关系表现分数",
    "Recruiter_AIRating_AdaptivePerformance": "适应性表现分数",
    "Recruiter_Comment_BackToDashboard": "返回候选人列表",
    "Recruiter_Comment_Title": "招聘人员评分",
    "Recruiter_Comment_Impression": "印象",
    "Recruiter_Comment_PotentialWorkPerformance": "潜在工作表现",
    "Recruiter_Comment_Rating": "评分",
    "Recruiter_Comment_Comments": "评论",
    "Recruiter_Comment_OverallScore": "总共得分:",
    "Recruiter_Comment_OverallComments": "总体评论",
    "Recruiter_Comment_Submit": "提交",
    "Recruiter_Comment_Submit_SuccessMsg": "保存成功",
    "Recruiter_Comment_Submit_FailedMsg": "保存失败",
    "Recruiter_Candidate_Result_No_Criteria": "评分准则及权重尚未设定，请先前往职位及面试设置页面的完成相关设定。",
    "Recruiter_Candidate_Result_Go_Setting": "前往设置页面",
    "Recruiter_Candidate_Result_Criteria_Setting": "编辑评分准则  ",
    "Recruiter_Guest_Review_No_Criteria": "尚未设置评分标准和权重，请与你正在查看的候选人的管理人员联系。",
    "Recruiter_CandidateProfile_Title": "候选人简介",
    "Recruiter_CandidateProfile_CV": "简历",
    "Recruiter_CandidateProfile_CV_Instruction": "将简历放在此处或选择",
    "Recruiter_CandidateProfile_CV_Extension": "推荐文=文件格式t: PDF, Doc or JPG",
    "Recruiter_CandidateProfile_BasicInformation_Title": "基本信息",
    "Recruiter_CandidateProfile_BasicInformation_FullName": "全名",
    "Recruiter_CandidateProfile_BasicInformation_PhoneNumber": "电话号码",
    "Recruiter_CandidateProfile_BasicInformation_Email": "电子邮件",
    "Recruiter_CandidateProfile_BasicInformation_Address": "地址",
    "Recruiter_CandidateProfile_WorkExp_Title": "工作经验",
    "Recruiter_CandidateProfile_WorkExp_Institute": "公司/ 机构.",
    "Recruiter_CandidateProfile_WorkExp_JobFunction": "工作职能",
    "Recruiter_CandidateProfile_WorkExp_JobTitle": "职位名称",
    "Recruiter_CandidateProfile_WorkExp_Location": "地点",
    "Recruiter_CandidateProfile_WorkExp_Active": "有效期",
    "Recruiter_CandidateProfile_WorkExp_StartDate_Year": "开始日期 - 年",
    "Recruiter_CandidateProfile_WorkExp_StartDate_Month": "开始日期 - 月",
    "Recruiter_CandidateProfile_WorkExp_EndDate_Year": "结束日期 - 年",
    "Recruiter_CandidateProfile_WorkExp_EndDate_Month": "结束日期 - 月",
    "Recruiter_CandidateProfile_Education_Title": "教育",
    "Recruiter_CandidateProfile_Education_Institute": "研究",
    "Recruiter_CandidateProfile_Education_Major": "专业",
    "Recruiter_CandidateProfile_Education_Award": "奖项",
    "Recruiter_CandidateProfile_Education_Location": "地点",
    "Recruiter_CandidateProfile_Education_Active": "有效期",
    "Recruiter_CandidateProfile_Education_StartDate_Year": "开始日期 - 年",
    "Recruiter_CandidateProfile_Education_StartDate_Month": "开始日期 - 月",
    "Recruiter_CandidateProfile_Education_EndDate_Year": "结束日期 - 年",
    "Recruiter_CandidateProfile_Education_EndDate_Month": "结束日期 - 月",
    "Recruiter_CandidateProfile_Cert_Title": "证书和奖项",
    "Recruiter_CandidateProfile_Cert_Cert": "证书/奖项",
    "Recruiter_CandidateProfile_Cert_Year": "年",
    "Recruiter_CandidateProfile_Skills_Title": "技能",
    "Recruiter_CandidateProfile_Skills_Skill": "特殊技能",
    "Recruiter_CandidateProfile_Action_Add": "增加",
    "Recruiter_CandidateProfile_Action_Remove": "移除",
    "Recruiter_CandidateProfile_Upload_MsgSuccess": "简历上传成功",
    "Recruiter_CandidateProfile_Upload_MsgFailed": "简历上传失败",
    "Recruiter_CandidateProfile_ReUpload_Msg": "重新上传简历",
    "Recruiter_Candidate_Invite_Result_Title": "邀请面试错误信息",
    "Recruiter_Candidate_Invite_Result_Content": "以下候选人在邀请时产生错误信息:",
    "Recruiter_Candidate_Invite_Result_Code0": "-",
    "Recruiter_Candidate_Invite_Result_Code1": "不能发送电邮",
    "Recruiter_Candidate_Invite_Result_Code2": "面试电邮已经发送。 \n但由于没提供电话号码因此短信发送失败",
    "Recruiter_Candidate_Invite_Result_Code3": "面试限额用完",
    "Recruiter_Candidate_Invite_Result_Code4": "面试已完成",
    "Recruiter_Candidate_Invite_Result_Table_Name": "名字",
    "Recruiter_Candidate_Invite_Result_Table_Email": "电邮",
    "Recruiter_Candidate_Invite_Result_Table_Result": "邀请状态",
    "Recruiter_Candidate_Invite_Result_Table_Message": "原因",
    "Recruiter_Candidate_Invite_Result_Success": "已发出邀请",
    "Recruiter_Candidate_Invite_Result_Fail": "发送邀请失败",
    "Recruiter_Skills_Attractiveness": "外观",
    "Recruiter_Skills_Wear_Glasses": "戴眼镜",
    "Recruiter_Skills_Wear_Glasses_yes": "是",
    "Recruiter_Skills_Wear_Glasses_no": "否",
    "Recruiter_Skills_Enthusiasm": "热情",
    "Recruiter_Skills_SelfConfidence": "自信",
    "Recruiter_Skills_Composure": "镇定",
    "Recruiter_Skills_Pace": "口才",
    "Recruiter_Skills_Leadership": "领导力",
    "Recruiter_Skills_LearningAgility": "学习能力",
    "Recruiter_Skills_CreativityAndInnovation": "创造与创新",
    "Recruiter_Skills_EmotionalIntelligence": "情商",
    "Recruiter_Skills_Communication": "有影响力的沟通",
    "Recruiter_Skills_InterpersonalRelationship": "人际交往关系",
    "Recruiter_Skills_GoalAndAchievementStriving": "目标和成就导向",
    "Recruiter_Skills_Pleasantness": "Pleasantness",
    "Recruiter_Skills_Patience": "Patience",
    "Recruiter_Skills_ComposureS4m": "Composure",
    "Recruiter_Skills_Independence": "Independence",
    "Recruiter_Skills_AdaptabilityAndSupporting": "Adaptability And Supporting",
    "Recruiter_Skills_CaringAndSensitivity": "Caring And Sensitivity",
    "Recruiter_Skills_ResponsibleWithOwnership": "Responsible With Ownership",
    "Recruiter_Skills_DevelopingPeople": "发展人才",
    "Recruiter_Skills_Responsibility": "责任心",
    "Recruiter_Skills_ManagingExecution": "管理执行",
    "Recruiter_Skills_AnalyticalAndLogicalThinking": "分析与逻辑思维",
    "Recruiter_Skills_ComplexProblemSolving": "复杂问题解决",
    "Recruiter_Skills_CaringAndEmpathy": "关怀与同理心",
    "Recruiter_Skills_EnglishOralCommunication": "英语口语交流",
    "Recruiter_Skills_CantoneseOralCommunication": "广东话口语交流",
    "Recruiter_Skills_MandarinOralCommunication": "普通话口语交流",
    "Recruiter_Skills_TeamCollaborationAndInclusion": "团队协作和包容",
    "Recruiter_Skills_BuildingRelationshipsAndNetwork": "建立人际关系和网络",
    "Recruiter_Skills_FlexibilityAndAdaptability": "灵活性和主动学习",
    "Recruiter_Skills_VisionAndEntrepreneurialMindset": "远见及创业精神",
    "Recruiter_Skills_TechnologyExpertiseAndBusinessSense": "科技专业及商业触角",
    "Recruiter_Skills_EffectiveCommunicationAndTeambuilding": "有效沟通及团体建立",
    "Recruiter_Skills_GritAndPassion": "坚毅及热情",
    "Recruiter_Skills_MalayOralCommunication": "马来语口语交流",
    "Recruiter_Skills_EnglishOralCommunicationOngrad": "English Oral Communication",
    "Recruiter_Skills_MotivationOngrad": "Concern of Health/Environment/Aesthetics/Technology (Job 1)",
    "Recruiter_Skills_MotivationOngradB": "Concern of Health/Environment/Aesthetics/Technology (Job 2)",
    "Recruiter_Skills_CommunicationWithImpactOngrad": "Communication with Impact",
    "Recruiter_Skills_TeamworkAndCollaborationOngrad": "Teamwork and collaboration",
    "Recruiter_Skills_CaringAndEmpathyOngrad": "Caring and Empathy",
    "Recruiter_Skills_BuildingRelationshipAndPeopleOngrad": "Building relationship and People",
    "Recruiter_Skills_ResponsibilityAndGoalAchievementOngrad": "Responsibility and Goal Achievement",
    "Recruiter_Skills_EmotionalIntelligenceOngrad": "Emotion Intelligence",
    "Recruiter_Skills_ManagingExecutionOngrad": "Managing execution",
    "Recruiter_Skills_FlexibilityAndActiveLearningOngrad": "Flexibility and Active Learning",
    "Recruiter_Skills_ComplexProblemSolvingOngrad": "Complex problem solving",
    "Recruiter_Skills_AnalyticalAndLogicalThinkingOngrad": "Analytical and logical thinking",
    "Recruiter_Skills_CreativityAndInnovationOngrad": "Creativity and Innovation",
    "Recruiter_Skills_ConfidenceOngrad": "Self-Confidence",
    "Recruiter_Skills_ComposureOngrad": "Composure",
    "Recruiter_Skills_EnthusiasmOngrad": "Enthusiasm",
    "Recruiter_Skills_TaskPerformance": "处事表现",
    "Recruiter_Skills_InterpersonalRelationshipCommunication": "人际关系与沟通",
    "Recruiter_Skills_Adaptability": "适应能力",
    "LayoutSettings_QuestionSubType_DevelopingPeople": "发展人才",
    "LayoutSettings_QuestionSubType_GoalAndAchievementStriving": "目标和成就导向",
    "LayoutSettings_QuestionSubType_TechnologyExpertiseAndBusiness Sense": "科技专业及商业意识",
    "LayoutSettings_QuestionSubType_Responsibility": "责任心",
    "LayoutSettings_QuestionSubType_ManagingExecution": "管理执行",
    "LayoutSettings_QuestionSubType_AnalyticalAndLogicalThinking": "分析与逻辑思维",
    "LayoutSettings_QuestionSubType_ComplexProblemSolving": "复杂问题解决",
    "LayoutSettings_QuestionSubType_VisionAndEntrepreneurialMindset": "远见及创业精神",
    "LayoutSettings_QuestionSubType_CommunicationWithImpact": "有影响力的沟通",
    "LayoutSettings_QuestionSubType_CaringAndEmpathy": "关怀与同理心",
    "LayoutSettings_QuestionSubType_InterpersonalRelationship": "人际交往关系",
    "LayoutSettings_QuestionSubType_Team CollaborationAndInclusion": "团队合作和包容",
    "LayoutSettings_QuestionSubType_Building RelationshipsAndNetwork": "建立人际关系和网络",
    "LayoutSettings_QuestionSubType_Effective CommunicationAndTeambuilding": "有效沟通及团体建立",
    "LayoutSettings_QuestionSubType_FlexibilityAndAdaptability": "灵活性和适应力",
    "LayoutSettings_QuestionSubType_LearningAgility": "学习能力",
    "LayoutSettings_QuestionSubType_CreativityAndInnovation": "创造与创新",
    "LayoutSettings_QuestionSubType_EmotionalIntelligence": "情商",
    "LayoutSettings_QuestionSubType_GritAndPassion": "坚毅及热情",
    "Recruiter_Email_Invitation_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p></p><p>感谢申请我们公司!</p><p>我们将邀请你参加迅维评核。 这是一个简单的三十分钟虚拟评核，你应使用登陆详细信息在开始日期和结束日期之间进行。</p><p></p><p> 登录详情： </p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>用户名: {{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>密码: {{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>开始: {{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>限期: {{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>时区: {{Timezone, don’t change}}</li></ul><span style=\"font-size: 14px;\"><p></p><p></p><ins>系统要求:</ins></span><p>座台电脑/手提电脑: 使用安装了新的 Chrome/Firefox/Safari(MacOS) 及连接互联网，安装了摄像头，话筒的座台电脑/手提电脑并有网络</p><p>手机: 使用已安装Chrome的安卓手机 / Safari的苹果手机 (SE2/XS or above)。建议使用良好的 Wi-Fi 连接。 </p><p style=\"margin-left:0px;\"></p><p>感谢你参与我们的评核。我们期待你的圆满完成，下一轮再见。 </p><p></p><p>祝好，</p><p>人才经理</p>",
    "Recruiter_Email_Invitation_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p></p><p>感谢申请我们公司!</p><p>我们将邀请你参加迅维视频面试。 这是一个简单的三十分钟虚拟面试，你应使用登陆详细信息在开始日期和结束日期之间进行面试。</p><p></p><p>登录详情：</p><ul><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>面试网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>用户名: {{Candidate’s login, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>密码: {{Candidate’s password, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>开始:  {{Start date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>限期: {{End date and time, don’t change}}</li><li style='font-size: 14px; line-height: 1.2; mso-line-height-alt: 17px;'>时区: {{Timezone, don’t change}}</li></ul><span style=\"font-size: 14px;\"><p></p><p></p><ins>系统要求:</ins></span><p>座台电脑/手提电脑: 使用安装了新的 Chrome/Firefox/Safari(MacOS) 及连接互联网，安装了摄像头，话筒的座台电脑/手提电脑并有网络</p><p>手机: 使用已安装Chrome的安卓手机 / Safari的苹果手机 (SE2/XS or above)。建议使用良好的 Wi-Fi 连接。</p><p style=\"margin-left:0px;\"></p><p>感谢你参与我们的视频面试。我们期待你的圆满完成，下一轮再见。 </p><p></p><p>祝好,</p><p>人才经理</p>",
    "Recruiter_Email_Reminder_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>关于你你申请{{Company’s name, don’t change}}之 {{Job Title, don’t change}} , 提醒你在此日期之前完成评核 {{End date and time, don’t change}}.  再次提供评核的登入信息:</p><ul> <li>网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用户名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密码: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>开始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>时区: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感谢参加我们的评核，我们期待你能圆满完成并在下一轮见。 </p><p></p><p>祝好，</p><p>人事经理</p>",
    "Recruiter_Email_Reminder_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>进一步为你申请 {{Company’s name, don’t change}}之 {{Job Title, don’t change}}, 提醒你在此日期之前面试 {{End date and time, don’t change}}.  再次提供面试的登入信息:</p><ul> <li>面试网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用户名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密码: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>开始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>时区: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感谢参加我们的面试，我们期待你能圆满完成并在下一轮见。 </p><p></p><p>祝好，</p><p>人事经理</p>",
    "Recruiter_Email_Confirmation_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感谢完成我们的评核. 你的答案正在审核中，若你成功进入下一轮，我们将立即与你联系.</p><p></p><p>祝好, </p><p>人事经理</p>",
    "Recruiter_Email_Confirmation_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感谢完成我们的视频面试. 你的面试正在审核中，若你成功进入下一轮，我们将立即与你联系.</p><p></p><p>祝好, </p><p>人事经理</p>",
    "Recruiter_Email_Extension_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>关于你申请 {{Company’s name, don’t change}}之 {{Job Title, don’t change}}, 评核的截止日改为 {{End date and time, don’t change}}. 再次提供评核的登入信息:</p><ul> <li>网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用户名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密码: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>开始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>时区: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感谢参加我们的评核，我们期待你能圆满完成并在下一轮见。 </p><p></p><p>祝好，</p><p>人事经理</p>",
    "Recruiter_Email_Extension_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>关于你申请 {{Company’s name, don’t change}}之 {{Job Title, don’t change}}, 视频面试的截止日改为 {{End date and time, don’t change}}. 再次提供面试的登入信息:</p><ul> <li>面试网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用户名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密码: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>面试开始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>时区: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>感谢参加我们的面试，我们期待你能圆满完成并在下一轮见。 </p><p></p><p>祝好，</p><p>人事经理</p>",
    "Recruiter_SMS_Invitation_Default": "请注意你申请 {{company name}} 之 {{job title}}职位需要进行评核. 详情请参看你的电邮 {{Candidate’s login, don’t change}}. 谢谢!!",
    "Recruiter_SMS_HighScoreContent_Default": "请注意你申请 {{company name}} 之 {{job title}}职位需要进行视频面试. 详情请参看你的电邮 {{Candidate’s login, don’t change}}. 谢谢!!",
    "Recruiter_SMS_MediumScoreContent_Default": "请注意你申请 {{company name}} 之 {{job title}}职位需要进行视频面试. 详情请参看你的电邮 {{Candidate’s login, don’t change}}. 谢谢!!",
    "Recruiter_SMS_LowScoreContent_Default": "请注意你申请 {{company name}} 之 {{job title}}职位需要进行视频面试. 详情请参看你的电邮 {{Candidate’s login, don’t change}}. 谢谢!!",
    "Recruiter_SMS_Reminder_Default": "请注意你申请 {{company name}} 之 {{job title}} 职位的评核将于24小时内截止，请尽快完成. 详情请参看你的电邮: {{Candidate’s login, don’t change}}. 谢谢!",
    "Recruiter_SMS_Extension_Default": "请注意你申请 {{company name}} 之 {{job title}} 职位的评核截止日将改为 {{End date and time, don’t change}}. 请尽快完成。详情请参看你的电邮: {{Candidate’s login, don’t change}}. 谢谢!",
    "Recruiter_SMS_Invitation_Default_old": "请注意你申请 {{company name}} 之 {{job title}}职位需要进行视频面试. 详情请参看你的电邮 {{Candidate’s login, don’t change}}. 谢谢!!",
    "Recruiter_SMS_Reminder_Default_old": "请注意你申请 {{company name}} 之 {{job title}} 职位的视频面试将于24小时内截止，请尽快完成. 详情请参看你的电邮: {{Candidate’s login, don’t change}}. 谢谢!",
    "Recruiter_SMS_Extension_Default_old": "请注意你申请 {{company name}} 之 {{job title}} 职位的视频面试截止日将改为 {{End date and time, don’t change}}. 请尽快完成。详情请参看你的电邮: {{Candidate’s login, don’t change}}. 谢谢!",
    "Recruiter_Email_Redo_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感谢你参与我们对 {{Company’s name, don’t change}}之 {{Job Title, don’t change}}职位的评核。不幸的是，我们发现 {{Number of retaking questions, don’t change}}题的视频没成功录影。请在结束日期之前使用下面的链接重新回答这些题目。 </p><p> </p><p>下面提供了登入信息。请在安装了网络摄像头的手机或手提电脑上使用更新的 Chrome/Firefox/Safari 浏览器进行评核。 </p><ul> <li>网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用户名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密码: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>开始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期:<strong>{{End date and time, don’t change}}</strong></li> <li>时区: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>我们期待你成功完成，下一轮再见。 </p><p></p><p>祝好,</p><p>人才经理</p>",
    "Recruiter_Email_Redo_Default_old": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感谢你参加我们对 {{Company’s name, don’t change}}之 {{Job Title, don’t change}}职位的视频面试。不幸的是，我们发现 {{Number of retaking questions, don’t change}} 题的视频没成功录影。请在结束日期之前使用下面的链接重新回答这些题目。 </p><p> </p><p>下面提供了登入信息。请在安装了网络摄像头的手机或手提电脑上使用更新的 Chrome/Firefox/Safari 浏览器进行面试。 </p><ul> <li>面试网站: <a href='apisit.neufast.com/candidate' rel='noopener' style='text-decoration: underline; color: #0068A5;' target='_blank'>apisit.neufast.com/candidate</a></li> <li>用户名: <strong>{{Candidate’s login, don’t change}}</strong></li><li>密码: <strong>{{Candidate’s password, don’t change}}</strong></li> <li>开始: <strong>{{Start date and time, don’t change}}</strong></li><li>限期: <strong>{{End date and time, don’t change}}</strong></li> <li>时区: <strong>{{Timezone, don’t change}}</strong></li></ul><p></p><p>我们期待你成功完成，下一轮再见。 </p><p></p><p>祝好,</p><p>人才经理</p>",
    "Recruiter_Email_Report_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感谢完成我们的视频面试。你的面试影片之分析已完成。以下是你的整体分数和评价:</p><p></p><p>分数: {{Score, don’t change}}/10</p><p>评价: {{Comment, don’t change}}</p><p></p><p>随邮件附上一份能力发展报告，协助你确认自身的发展需要。 </p><p></p><p>祝好,</p><p>人事经理</p>",
    "Recruiter_Email_WithoutScore_Report_Default": "<p>你好 {{Candidate’s name, don’t change}},</p><p>感谢完成我们的视频面试。你的面试影片之分析已完成。随邮件附上一份能力发展报告，协助你理解自己的发展需要。 </p><p></p><p>祝好,</p><p>人事经理</p>",
    "Recruiter_Upload_Large_File_Warning_Title": "侦测到有大型档案",
    "Recruiter_Upload_Large_File_Warning_Message": "上传的档案超过200MB. 这可能会造成面试时不流畅。",
    "Recruiter_AccountSetting_Title": "账户设置",
    "Recruiter_AccountSetting_RecruiterProfile_Title": "雇主资料",
    "Recruiter_AccountSetting_CompanyProfile_Title": "公司资料",
    "Recruiter_AccountSetting_Functionality_Title": "功能",
    "Recruiter_AccountSetting_UsageHistory_Title": "使用量",
    "Recruiter_AccountSetting_Password_Title": "密码",
    "Recruiter_AccountSetting_PasswordPolicy_Title": "密码政策",
    "Recruiter_AccountSetting_Add_Recruiter_Button": "Add Sub-recruiter",
    "Recruiter_AccountSetting_Register_Dialog_Title": "Sub-recruiter Registration",
    "Recruiter_AccountSetting_Register_Dialog_SubTitle_Login": "Login Information",
    "Recruiter_AccountSetting_Register_Dialog_SubTitle_Account": "Account Information",
    "Recruiter_AccountSetting_Register_Dialog_Email": "Email",
    "Recruiter_AccountSetting_Register_Dialog_Password": "Password",
    "Recruiter_AccountSetting_Register_Dialog_FirstName": "First Name",
    "Recruiter_AccountSetting_Register_Dialog_LastName": "Last Name",
    "Recruiter_AccountSetting_RecruiterProfile_Picture": "雇主照片:",
    "Recruiter_AccountSetting_RecruiterProfile_FirstName": "名字:",
    "Recruiter_AccountSetting_RecruiterProfile_LastName": "姓氏:",
    "Recruiter_AccountSetting_RecruiterProfile_Email": "电邮:",
    "Recruiter_AccountSetting_RecruiterProfile_JobTitle": "职位:",
    "Recruiter_AccountSetting_RecruiterProfile_Tel": "电话:",
    "Recruiter_AccountSetting_Functionality_RecruiterEvaluation": "招聘人员评核",
    "Recruiter_AccountSetting_Functionality_FacialAnnotation": "视像表情标注",
    "Recruiter_AccountSetting_UsageHistory_NumberInvitations": "面试数目",
    "Recruiter_AccountSetting_UsageHistory_NumberCompletedInterviews": "完成面试数目",
    "Recruiter_AccountSetting_UsageHistory_TimePeriod": "时期",
    "Recruiter_AccountSetting_UsageHistory_Number": "数目",
    "Recruiter_AccountSetting_Password_CurrentPassword": "现有密码",
    "Recruiter_AccountSetting_Password_NewPassword": "新密码",
    "Recruiter_AccountSetting_Password_PasswordConfirmation": "再输入新密码",
    "Recruiter_AccountSetting_PurchaseBalance_Title": "单据和余额",
    "Recruiter_AccountSetting_DateOfPurchase": "购买日期",
    "Recruiter_AccountSetting_ValidUntil": "有效日期",
    "Recruiter_AccountSetting_Reference": "编码",
    "Recruiter_AccountSetting_NumberOfInterviews": "面试数量",
    "Recruiter_AccountSetting_NumberOfExpiredInterviews": "过期数量",
    "Recruiter_AccountSetting_RecruiterAccount": "雇主帐户",
    "Recruiter_AccountSetting_InterviewUsage": "面试用量",
    "Recruiter_AccountSetting_PurchasedInterviews": "单据",
    "Recruiter_AccountSetting_Usage": "用量",
    "Recruiter_AccountSetting_Balance": "余额",
    "Recruiter_AccountSetting_AccountStatus": "帐户状态",
    "Recruiter_AccountSetting_TotalNumberOfInterviews": "面试总数量 (1)",
    "Recruiter_AccountSetting_TotalInterviewUsage": "面试总用量 (2)",
    "Recruiter_AccountSetting_TotalNumberOfExpiredInterviews": "过期总数量 (3)",
    "Recruiter_AccountSetting_TotalBalance": "余额 = (1) - (2) - (3)",
    "Recruiter_CV_Upload_Message": "履历上载",
    "Recruiter_CV_Extension": "文件格式: JPG, PDF, DOC, DOCX",
    "Candidate_Common_Next": "继续",
    "Candidate_Common_Start": "开始",
    "Candidate_Common_Step_Setting": "设备测试",
    "Candidate_Common_Step_Practice": "面试练习",
    "Candidate_Common_Step_Real": "正式面试",
    "Candidate_Common_Step_Finished": "结束",
    "Candidate_Common_HideCamera": "隐藏摄像头",
    "Candidate_Common_TimeRemaining": "剩余时间",
    "Candidate_Common_Video_Recording": "录制...",
    "Candidate_Common_Video_Stop": "结束",
    "Candidate_Common_Video_Uploading": "上传...",
    "Candidate_Interview_LoadingMessage": "请稍候，正在加载评核...",
    "Candidate_Interview_LoadingMessage_old": "请稍候，正在加载视频面试...",
    "Candidate_Interview_ValidationHandler_Title": "检测到重复的登录",
    "Candidate_Interview_ValidationHandler_Content": "登出中...",
    "Candidate_Browser_Msg": "<p> 不好意思，你的浏览器不支持视频面试。 </p> <p>请用最新版本的谷歌 Google Chrome 浏览器. 你能在以下网址下载:</p><p><a href=\"https://www.google.com/chrome/\">https://www.google.com/chrome/</a></p><p> 另一方法, 是用Android手机的谷歌 Google Chrome 浏览器。 谢谢! </p>",
    "Candidate_Browser_Warning_IOS": "苹果手机浏览器暂不支持视频面试。请使用App Store内的Neufast Interview App或 苹果桌面/安卓/微软视窗的Chrome浏览器",
    "Candidate_Browser_Warning_Edge": "你的Edge浏览器版本不支持视频面试。请更新使用最新版Edge浏览器",
    "Candidate_Browser_Warning_Generic": "你的浏览器不支持视频面试。请使用Chrome浏览器",
    "Candidate_Browser_Warning_CriOS": "iOS上的Chrome与我们的应用程序不兼容。请切换到野生动物园",
    "Candidate_Interview_WelcomeTitle": "欢迎你，{name}！\n请为以下职位完成一次评核。",
    "Candidate_Interview_WelcomeTitle_AIA": "欢迎参加AIA Elite Academy的视频面試",
    "Candidate_Interview_WelcomeTitle_old": "欢迎你，{name}！\n请为以下应聘职位完成一次性视频面试。",
    "Candidate_Interview_WelcomeTitle_ongrad": "欢迎, {name}!\n 请为以下计划进行一次视频面试.",
    "Candidate_Interview_WelcomeTitle_AutoLogin": "欢迎！\n我们很高兴能与您进行这次评估。",
    "Candidate_Interview_Error_AutoLogin": "哎呀 !! 该链接存在问题。",
    "Candidate_Interview_Error_AutoLogin_Error_1": "链接已过期...",
    "Candidate_Interview_Error_AutoLogin_Error_2": "链接已被篡改/修改...",
    "Candidate_Interview_Error_AutoLogin_Error_3": "链接无效，与面试无关",
    "Candidate_Interview_Error_AutoLogin_Error_4": "面试尚未启用二维码/链接登录",
    "Candidate_Interview_Error_AutoLogin_Error_5": "给定面试的 URL 链接缺失",
    "Candidate_Interview_Error_AutoLogin_Error_6": "与相关面试不匹配的链接",
    "Candidate_Interview_Error_AutoLogin_Error_7": "链接已过期，因为面试的截止日期已过。",
    "Candidate_Interview_Error_AutoLogin_Error_Remedial_Message": "请联系您指定的导师。",
    "Candidate_Interview_AutoLogin_SendOTP_Success": "验证码已发送至 {email}",
    "Candidate_Interview_AutoLogin_SendOTP_Fail": "发送 OTP 失败。请刷新并重试",
    "Candidate_Interview_AutoLogin_SendOTP_Fail_InvalidEmail": "电子邮件无效。请再检查一次",
    "Candidate_Interview_AutoLogin_VerifyOTP_Fail_apiError": "无法验证 OTP。请刷新并稍后重试",
    "Candidate_Interview_AutoLogin_VerifyOTP_Fail_expired": "OTP已过期。请刷新并重试",
    "Candidate_Interview_AutoLogin_Send_Captcha_Verification": "已验证验证码",
    "Candidate_Interview_AutoLogin_ImportByAccessKey_Success": "找到先前的条目。正在登录....",
    "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_starttime_not_reached": "访谈系列尚未开始。请在电子邮件中读取面试时间。",
    "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_incorrect_password": "密码 ／ 账号错误",
    "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_expired_bad": "登录令牌已过期。请检查您的网络连接，然后重试。",
    "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_deadline_passsed": "您的面试截止日期已经过去。",
    "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_interview_completed": "您的面试完成并进行了审查。",
    "Candidate_Interview_AutoLogin_ImportByAccessKey_Fail_frozen": "您的帐户已关闭/过期，请联系您的介绍人以进行进一步查询。",
    "Candidate_Interview_Welcome_Company": "<b>公司:</b> {companyName}",
    "Candidate_Interview_Welcome_JobTitle": "<b>职位:</b> {jobTitle}",
    "Candidate_Interview_Welcome_CompanyWebsite": "<b>网站:</b> {companyWebsite}",
    "Candidate_Interview_Welcome_Deadline": "<b>最后期限:</b> {deadline}",
    "Candidate_Interview_Language": "<b>评核语言：</b> {interviewLanguage}",
    "Candidate_Interview_Language_old": "<b>视频面试语言：</b> {interviewLanguage}",
    "Candidate_Introduction_Title": "公司简介",
    "Candidate_Instruction_Title": "说明",
    "Candidate_Instruction_SubHeading_1": "一般偏好",
    "Candidate_Instruction_SubHeading_2": "公平评估",
    "Candidate_Instruction_SubHeading_3": "成功着装",
    "Candidate_Instruction_Tips": "(<b>提示:</b> 观看此视频将帮助您了解公司的历史以及您所申请的职位的要求)",
    "Candidate_Instruction_Details": [
        "找一个安静的地方进行面试。 ",
        "将设备放在支架上或用手平稳的握住。 ",
        "请关闭其他网页和应用程式。 ",
        "始终保持专业得体的外表。",
        "请避免过于暴露的着装, 包括一些有破洞，或者有裂缝，或者睡衣类的穿着。不适当的穿着会影响您视频面试的分数。",
        "请在视频面试开始前，穿着长短合身的商务服装，并确保您已经装束得体。",
        "为了录制高质量的影像以进行公平的评核，请不要在视频面试进行期间配戴口罩。 "
    ],
    "Candidate_Instruction_Details_Video_Interview": [
        "确保从一个安静的位置良好的互联网访问互联网，并具有最小的背景噪音。",
        "用支架支撑您的设备，或用稳定的手握住牢固的牢固。",
        "请关闭其他网页和应用程序。",
        "始终保持专业得体的外表。",
        "请避免过于暴露的着装, 包括一些有破洞，或者有裂缝，或者睡衣类的穿着。不适当的穿着会影响您视频面试的分数",
        "请在视频面试开始前，穿着长短合身的商务服装，并确保您已经装束得体。",
        "为了录制高质量的影像以进行公平的评核，请不要在视频面试进行期间配戴口罩。 "
    ],
    "Candidate_Instruction_Details_old": [
        "找一个安静的地方进行面试。 ",
        "将设备放在支架上或用手平稳的握住。 ",
        "请关闭其他网页和应用程式。 ",
        "为了录制高质量的影像以进行公平的视频面试，请不要在视频面试进行期间配戴口罩。 "
    ],
    "Candidate_Instruction_Details2": [
        "请在带有网络摄像头和麦克风的座台电脑/手提电脑上使用更新了的 Chrome/Firefox 浏览器来执行评核。 ",
        "使用智能手机/移动设备进行视频面试是 <b>不建议。 </b>",
        "<b>视频面试不要戴口罩。 </b>",
        "一次完成视频面试。 ",
        "完成后，请等待你的视频完成上传，然后再关闭浏览器并注销。 ",
        "让你的背景设置不受干扰。 "
    ],
    "Candidate_Instruction_Details_Proctoring_Header": "<b>为了进行公正的评估， 请确保您不要进行如下行为。</b>",
    "Candidate_Instruction_Details_Proctoring_Details": "如在视频面试进行中您出现如下行为，您的视频面试将会被强制停止。您将无法继续面试，同时您的面试得分将会受到影响。",
    "Candidate_Instruction_Details_Proctoring_Rules": [
        "关闭您的摄像头",
        "关闭您的灯光",
        "面试期间更换面试者",
        "非候选人参加视频面试"
    ],
    "Candidate_Instruction_Details_Proctoring_Details_Continue": "如有以下行为，尽管您的视频面试仍可以正常进行，请注意 <b>您的行为会被标记并且会影响您的面试得分。</b>",
    "Candidate_Instruction_Details_Proctoring_Rules_Continue": [
        "对口型",
        "录屏中有其他人出现",
        "面试进行中同时出现多个声音"
    ],
    "Candidate_Instruction_Details_last": "准备好后请点击 \"继续\"。然后我们将检查网络摄像头和音频设置。",
    "Candidate_Instruction_RecordedInterview_Message": "这是一个自动评核，因此在这里您不会被真人面试！",
    "Candidate_Instruction_RecordedInterview_Message_old": "这是一个自动视频面试，因此在这里您不会被真人面试！",
    "Candidate_Settings_Title": "设备测试",
    "Record_introduction_Video_Heading": "录制介绍视频 ",
    "Candidate_Settings_Caption": "在进行评核之前，请确保你设备的网络摄像头、麦克风和扬声器已打开并正常运作。",
    "Candidate_Settings_Caption_old": "在进行视频面试之前，请确保您设备的网络摄像头、麦克风和扬声器已打开并正常运作。",
    "Candidate_Settings_Browser_Compatibility": "浏览器兼容性",
    "Candidate_Settings_Browser_Compatibility_Caption": "您的浏览器是 ",
    "Candidate_Settings_Browser_Compatibility_Text_True": "兼容的",
    "Candidate_Settings_Browser_Compatibility_Text_False": "不兼容",
    "Candidate_Settings_Browser_Compatibility_Text_Suggestion": "Android 设备的推荐浏览器为<b>Google Chrome</b>。",
    "Candidate_Settings_Browser_Compatibility_Warning": "警告：浏览器已过时和/或不受支持",
    "Candidate_Settings_Browser_Compatibility_Warning_Message": "没有检测到网络摄像头。请检查网络摄像头的设置或者更换成另一个浏览器。如果这个问题仍然出现，请使用另一个设备。",
    "Candidate_Settings_Browser_Compatibility_Warning_Message_Button": "确认",
    "Candidate_Settings_Browser_Compatibility_Browser": "支持的浏览器：",
    "Candidate_Settings_Browser_Compatibility_Handling": "如果问题仍然存在，请尝试使用不同的设备",
    "Candidate_Settings_Browser_Compatibility_Handling_iOS": "侦测到 iOS/MacOS 版本. {version}。请更新至ver.14.3或更新版本",
    "Candidate_Settings_Browser_Compatibility_Handling_CriOS": "您正在 iOS/iPad 上使用 Chrome。请改用Safari浏览器",
    "Candidate_Settings_Browser_Compatibility_Handling_Unknown": "iOS/iPadOS/MacOS 版本侦测到未知错误。 {version}。",
    "Candidate_Settings_Webcam": "摄像头",
    "Candidate_Settings_Webcam_Caption": "请授权使用您的摄像头，并确保您的脸显示在画面中间",
    "Candidate_Settings_Microphone": "麦克风",
    "Candidate_Settings_Microphone_Caption": "请授权使用麦克风并对着麦克风说话，以确保您的声量达到侦测器的“推荐“级别。",
    "Candidate_Switch_Off_Camera": "您的视频没有被检测到，您将会很快被转入设备测试页面。在您继续当前视频面试开始前，请您确保网络摄像头已经被开启。",
    "Candidate_Settings_MicrophoneVolume_TooLow": "太低",
    "Candidate_Settings_MicrophoneVolume_Low": "低",
    "Candidate_Settings_MicrophoneVolume_Recommended": "推荐",
    "Candidate_Settings_MicrophoneVolume_Loud": "大",
    "Candidate_Settings_MicrophoneVolume_TooLoud": "太大",
    "Candidate_Settings_Lighting": "照明和位置",
    "Candidate_Settings_Speaker": "扬声器声量",
    "Candidate_Settings_Speaker_Caption": "请测试音频并确保您听到音乐",
    "Candidate_Settings_TestAudio": "测试音频",
    "Candidate_Settings_PauseAudio": "停止音频",
    "Candidate_Settings_LightCheckPrefix": "按",
    "Candidate_Settings_LightCheckSuffix": "看照明和位置是否合适",
    "Candidate_Settings_LightCheckPrefixButton": "此处",
    "Candidate_Settings_NetworkCondition": "网络情况",
    "Candidate_Settings_NetworkCondition_UploadSpeed": "上传速度: {speed}",
    "Candidate_Settings_NetworkCondition_DownloadSpeed": "下载速度: {speed}",
    "Candidate_Settings_NetworkCondition_Estimating": "估计中...",
    "Candidate_Settings_NetworkCondition_Recommendation": "(推荐使用稳定的Wi-Fi网络)",
    "Candidate_Settings_NetworkCondition_NASpeed": "--- KB/秒",
    "Candidate_Settings_NetworkCondition_B": "{speed} B/秒",
    "Candidate_Settings_NetworkCondition_KB": "{speed} KB/秒",
    "Candidate_Settings_NetworkCondition_MB": "{speed} MB/秒",
    "Candidate_Settings_NetworkCondition_GB": "{speed} GB/秒",
    "Candidate_Settings_Error_Msg": "无法取用录像/录音设备。请确保已启用它们，并且没有其他应用程序正在使用它们。",
    "Candidate_Settings_Microphone_No_Voice_Error_Msg": "侦测不到麦克风的录音。请关掉此对话框并对着麦克风说话以作测试。如果情况持续，请检查你的麦克风以确保运作正常。",
    "Candidate_Detail_Greeting": "你好, {name}!",
    "Candidate_Detail_Greeting_In_Mobile_View": "你好, {name}",
    "Candidate_Detail_QuestionAndTimeLimit": "本次面试包含 <span style=\"font-size: 150%\">{totalQuestion}</span> 条问题以及需要 <span style=\"font-size: 150%\">{timeLimit}</span> 分钟",
    "Candidate_Detail_Deadline": "截止时间:",
    "Candidate_Detail_InterviewPractice": "面试练习",
    "Candidate_Detail_Multiple_Choices_Practice": "多项选择题练习",
    "Candidate_Detail_Short_Question_Practice": "短答题练习",
    "Candidate_Detail_Question": "题目",
    "Candidate_Detail_Interview": "面试",
    "Candidate_Detail_Duration": "总长度:",
    "Candidate_Detail_Format": "格式:",
    "Candidate_Detail_Interview_Reminder": "提醒",
    "Candidate_Detail_Language_Text_Suffix": "{language}",
    "Candidate_Detail_Paragraph_1": " 在进行正式视频面试之前，我们建议您进行面试练习以熟悉其格式。",
    "Candidate_Detail_Paragraph_2": "此面试包括 <span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}.",
    "Candidate_Detail_Paragraph_2_Retake": "重做的面试包括 <span style=\"font-weight: bold;font-size: 200%\">{noOfQuestion}</span> {measureWord}.",
    "Candidate_Detail_Language_Text_Suffix_2": "<span style=\"font-weight: bold;font-size: 200%;color: red\">{noOfQuestion}</span> {measureWord} {language}",
    "Candidate_Detail_Paragraph_3": "在录制每个问题之前，你有 <span style=\"background-color: #e3f2fd\">{preparationTime} 的时间思考。</span> 每个问题的录制时间只有 <span style=\"background-color: #e3f2fd\">{timeForEachQuestion}。</span>",
    "Candidate_Detail_Paragraph_3_No_Preparation_Time": "在录制每个问题之前，每个问题的录制时间只有 <span style=\"background-color: #e3f2fd\">{timeForEachQuestion} 。</span>",
    "Candidate_Detail_Paragraph_4": "<b>总共需时:</b> {totalTime}",
    "Candidate_Detail_Video_Interview": "视频面试",
    "Candidate_Detail_Short_Question": "短答题",
    "Candidate_Detail_Multiple_Choices": "多项选择题",
    "Candidate_Detail_Video_Interview_Paragraph_1_normal": "您的视频面试测试包括 {noOfQuestion} {measureWord}。",
    "Candidate_Detail_Video_Interview_Paragraph_1_normal_Retake": "你对面试的部分重拍包括 {noOfQuestion} {measureWord}：",
    "Candidate_Detail_Video_Interview_Paragraph_2_normal": "在录制每个问题之前，您有 {preparationTime} 的时间思考。每个问题的录制时间只有 {timeForEachQuestion} 。",
    "Candidate_Detail_Video_Interview_Paragraph_2_normal_No_Preparation_Time": "对于每个问题，你最多可以回答 {timeForEachQuestion} 。",
    "Candidate_Detail_Number_Of_Attempts_Each_Question": "您有高达 {numberofattempts} 次的机会录制您的回答。",
    "Candidate_Detail_Multiple_Choices_Paragraph_1_normal": "你的多项选择题测试包括 {noOfQuestion} {measureWord}。",
    "Candidate_Detail_Short_Question_Paragraph_1_normal": "你的短答题测试由 {noOfQuestion} {measureWord} 组成。",
    "Candidate_Detail_Multiple_Choices_Paragraph_1": "对于每个问题，你大约有 {timeForEachQuestion} 来回答。",
    "Candidate_Detail_Multiple_Choices_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
    "Candidate_Detail_Short_Question_Paragraph_1": "对于每个问题，你大约有 {timeForEachQuestion} 来回答。",
    "Candidate_Detail_Short_Question_Text_Suffix": "<span style=\"font-weight: bold;font-size: 200%;color: black\">{noOfQuestion}</span>",
    "Candidate_Detail_Start_Practice": "开始练习",
    "Candidate_Detail_Sec_to_Prepare": "分钟准备",
    "Candidate_Detail_Min_To_Answer": "分钟回答",
    "Candidate_Detail_Start_Interview": "开始面试",
    "Candidate_Detail_Start_Test": "开始测验",
    "Candidate_Detail_Interview_Info_Heading": "你的评核信息如下：",
    "Candidate_Detail_Compay": "公司",
    "Candidate_Detail_Position_Requested": "职位",
    "Candidate_Detail_Website": "网页",
    "Candidate_Detail_Interview_Date_And_Time": "评核日期和时间",
    "Candidate_Detail_Help_Center": "疑问回答",
    "Candidate_Detail_Video_Interview_Information": "视频面试信息",
    "Candidate_Detail_Multiple_Choices_Information": "多项选择题测试信息",
    "Candidate_Detail_Short_Question_Information": "短答题测试信息",
    "Candidate_Interview_Time_Remaining": "剩余时间 :",
    "Candidate_Interview_Question_Of": "{totalQuestion} 的问题 {question}",
    "Candidate_Practice_Title": "面试练习",
    "Candidate_Practice_PracticeAgain": "再次练习",
    "Candidate_Practice_Question": "问题",
    "Candidate_Practice_Placeholder": "请在这里填写答案",
    "Candidate_Practice_Answer_In": "回答语言 {language}",
    "Candidate_Practice_Answer_In_pu_en": "回答语言 普通话/英语",
    "Candidate_Practice_Answer_In_cn_en": "回答语言 广东话/英语",
    "Candidate_Practice_Answer_Time": "回答时间",
    "Candidate_Practice_You_have": "你有",
    "Candidate_Practice_To_Think": "去准备你的答案。",
    "Candidate_Practice_Skip_Message": "你可以略过此部分并点击\"录影\"按钮开始。",
    "Candidate_Practice_Web_Skip_Message": "你可以略过此部分并点击\"开始录制\"按钮开始。",
    "Candidate_Practice_Record": "录影",
    "Candidate_Practice_Start_Recording": "开始录制",
    "Candidate_Practice_Hide_Self_View": "隐藏自我视频",
    "Candidate_Practice_Tip": "提示",
    "Candidate_Practice_Tip_Message": "请利用准备时间想一个好的答案",
    "Candidate_Practice_Enable_Self_View": "隐藏自我视频",
    "Candidate_Practice_Done": "完成",
    "Candidate_Practice_Check_Title": "这是你的练习视频",
    "Candidate_Practice_Check_Content": "这视频的收音和影像是否清晰?",
    "Candidate_Practice_Check_YES": "是",
    "Candidate_Practice_Check_NO": "否",
    "Candidate_Practice_Check_FAIL": "请再复核你的麦克风和摄影机是否运作正常。你可能需要更换这些设备。",
    "Candidate_Practice_Check_Redirect": "设备测试",
    "Candidate_Practice_NextStagePopup_Title": "你好! 我是 {recruiterFirstname}, 今天我会为你进行面试",
    "Candidate_Practice_NextStagePopup_Start_Interview": "开始面试!",
    "Candidate_Practice_Welcome_Title": "欢迎练习面试",
    "Candidate_Practice_Welcome_Content": "每个题目将有 <span class=\"{spanClass}\">准备时间 {preparationTimeString}</span>, 你可以在录制答案前思考答案。",
    "Candidate_Practice_Welcome_Content_No_Preparation": "每个题目目前没有任何准备时间，倒计时3秒后开始录制。",
    "Candidate_Practice_Welcome_Checkbox_Label": "隐藏自我视频（您的视频会继续被录制）",
    "Candidate_Practice_Welcome_Confirm": "明白",
    "Candidate_Practice_Welcome_Start": "开始",
    "Candidate_Multiple_Choices_Practice_Welcome_Title": "欢迎来到 {testName} 练习",
    "Candidate_Multiple_Choices_Practice_Content": "此练习可帮助你熟悉测验格式。题目与正式测验不同。",
    "Candidate_Short_Question_Practice_Welcome_Title": "欢迎来到 {testName} 练习",
    "Candidate_Short_Question_Practice_Content": "此练习可帮助你熟悉测验格式。题目与正式测验不同。",
    "Candidate_Interview_Submit_Confirm": "提交",
    "Candidate_Interview_Submit_Not_Confirm": "返回",
    "Candidate_Interview_Submit_Content": "你确定要提交答案吗？",
    "Candidate_Interview_Face_Detection_Warning": "未检测到你的脸部。如果你的相机位于你面前，请检查你的设置。",
    "Candidate_Interview_Upload_Header_Progressing": "检测到错误！请稍等。上传视频....",
    "Candidate_Interview_Upload_Header_Completed": "上一题的视频录制失败。",
    "Candidate_Interview_Upload_Body_Progressing": "上一题的视频录制失败。这可能是浏览器或设备问题。请等待之前问题的视频上传完成。",
    "Candidate_Interview_Upload_Body_Completed": "这可能是浏览器或设备问题。请重新启动浏览器或使用其他设备继续测试。如果此问题仍然存在，请通过 'customer-service@neufast.com' 联系我们。对造成的不便深表歉意。",
    "Candidate_Practice_Finish_Title": "这是你的练习视频",
    "Candidate_Multiple_Choices_Practice_Finish_Title": "你已完成多项选择题练习",
    "Candidate_Short_Question_Practice_Finish_Title": "你已经完成了短答题练习",
    "Candidate_Practice_Finish_Content": "测验与练习的格式是一样的",
    "Candidate_Practice_Finish_Content_old": "面试与练习的格式是一样的",
    "Candidate_Practice_Finish_Button_Practice": "重新练习",
    "Candidate_Practice_Finish_Button_Back": "返回目录",
    "Candidate_Practice_Finish_Button_Start": "开始面试",
    "Candidate_Practice_Finish_Button_Start_old": "开始面试",
    "Candidate_Logout_Confirm": "你的评核尚未完成，但你可以在截止日期前再次登录。你现在要退出吗？",
    "Candidate_RealInterview_Welcome_Title": "欢迎来进行面试!",
    "Candidate_RealInterview_Welcome_Content": "<div>请注意你 <span style=\"font-weight: bold;font-size: 110%\">不能</span> 在整个面试完成前离开。你只有 <span style=\"font-weight: bold;font-size: 110%\">一次</span> 作答机会，请不要有任何打扰或中断。</div><br/><div>此外，请不要按\"返回\"，\"刷新页面\"等按钮，否则会流失你的视频。</div>",
    "Candidate_RealInterview_Welcome_Content_Number_Of_Attempt": "<div>除非您完全完成面试，否则请<span style=\"font-weight: bold;font-size: 110%\">不要</span>离开面试。您有<span style=\"font -weight: 粗体;font-size: 110%\">{numberofattempts}</span> 次机会尝试回答每个问题，应避免任何中断。</div><br/><div>此外，请不要按浏览器上的“后退”或“刷新”按钮，因为这会影响您的视频上传。</div>",
    "Candidate_RealInterview_Placeholder": "请在这里填写答案",
    "Candidate_RealInterview_Welcome_Checkbox_Label": "隐藏自我视频 (你的答案会继续被录影)",
    "Candidate_RealInterview_Welcome_Confirm": "明白",
    "Tips": "温馨提示",
    "Candidate_Multiple_Choices_Welcome_Title": "欢迎你来到选择题 {testName}！",
    "Candidate_Multiple_Choices_Welcome_Content": "<div>在完成所有题目前你<span style=\"font-weight: bold;font-size: 110%\">不</span>应离开测验。你<span style=\"font-weight: bold;font-size: 110%\">只有一次</span>机会进行多项选择测试，应避免任何中断。 </div><br/> <div>一旦开始测验，计时器就会开始计时，直到时间到或点击\"提交\"按钮。 </div>",
    "Candidate_Short_Question_Welcome_Title": "欢迎你来到短答题 {testName}！",
    "Candidate_Short_Question_Welcome_Content": "<div>在完成所有题目前你<span style=\"font-weight: bold;font-size: 110%\">不</span>应离开测验。你<span style=\"font-weight: bold;font-size: 110%\">只有一次</span>机会进行多项选择测试，应避免任何中断。 </div><br/> <div>一旦开始测验，计时器就会开始计时，直到时间到或点击\"提交\"按钮。 </div>",
    "Candidate_RealInterview_Finish_Title": "这是您录制的视频",
    "Candidate_RealInterview_Finish_Attempt_Question_Content": "您想再次回答这个问题吗？",
    "Candidate_RealInterview_Finish_Max_Number_Attempt_Question": "(你还有{numberOfAttempts}次机会回答）",
    "Candidate_SelfIntroduction_Finish_Attempt_Question_Content": "这是您录制的介绍视频。录制的声音是否清晰，视频是否清晰？请注意，一旦提交，您将无法再重新录制。",
    "Candidate_RealInterview_Title": "视频面试",
    "Candidate_RealInterview_Question": "问题",
    "Candidate_RealInterview_Video": "请观看上面的视频，然后回答问题",
    "Candidate_RealInterview_TotalQuestion": "面试题目:",
    "Candidate_RealInterview_NextQuestion": "下一条问题",
    "Candidate_RealInterview_Finish": "结束",
    "Candidate_RealInterview_Finish_Button_Answer_Again": "再次回答",
    "Candidate_RealInterview_Finish_Button_Record_Again": "再次录制",
    "Candidate_RealInterview_BackButton": "你按了退后键离开了面试.",
    "Candidate_RealInterview_Reject": "对不起，为了确保面试的公平性，我们不能重新开始面试。如果你遇上难题，请联系 customer-service@neufast.com",
    "Candidate_RealInterview_CheckWebcam_Message": "抱歉!你的摄录机在录影时发生错误。正在尝试解决此错误。",
    "Candidate_RealInterview_Warning": "警告",
    "Candidate_RealInterview_noVoiceWarning": "超过 10 秒未检测到您的声音。请提高声线或检查您的麦克风。",
    "Candidate_Interview_Part": "部分{number}",
    "Candidate_Interview_Proctoring": "监考",
    "Candidate_Interview_Question_List": "问题列表",
    "Candidate_Interview_Question": "问题{questionNo}: {question}",
    "Candidate_Interview_Question_Previous": "上一页",
    "Candidate_Interview_Question_Next": "继续",
    "Candidate_Interview_Question_Submit": "提交",
    "Candidate_Interview_Multiple_Choices_Reminder": "* 你可以选择多个答案",
    "Candidate_Multiple_Choices_Title": "多项选择题",
    "Candidate_Short_Question_Title": "短答题",
    "Candidate_Video_Interview_Title": "视频面试",
    "Candidate_A/V_Check_Title": "设备测试",
    "Candidate_Finished_Title": "结束",
    "Candidate_RealInterview_english_Section": "英语部分",
    "Candidate_RealInterview_cantonese_Section": "粤语部分",
    "Candidate_RealInterview_mandarin_Section": "中文部分",
    "Candidate_RealInterview_thai_Section": "泰文部分",
    "Candidate_RealInterview_japanese_Section": "日语部分",
    "Candidate_RealInterview_indonesian_Section": "印尼语部分",
    "Candidate_RealInterview_vietnamese_Section": "越南语部分",
    "Candidate_RealInterview_khmer_Section": "柬埔寨语部分",
    "Candidate_RealInterview_malay_Section": "马来语部分",
    "Candidate_RealInterview_german_Section": "德語部分",
    "Candidate_RealInterview_french_Section": "法語部分",
    "Candidate_RealInterview_korean_Section": "韩语部分",
    "Candidate_RealInterview_cn_en_Section": "广东话/英语 Section",
    "Candidate_RealInterview_pu_en_Section": "普通话/英语 Section",
    "Candidate_RealInterview_th_en_Section": "泰文/英语 Section",
    "Candidate_RealInterview_english": "英文",
    "Candidate_RealInterview_cantonese": "粤语",
    "Candidate_RealInterview_mandarin": "中文",
    "Candidate_RealInterview_thai": "泰文",
    "Candidate_RealInterview_putonghua": "普通话",
    "Candidate_RealInterview_japanese": "日语",
    "Candidate_RealInterview_indonesian": "印尼语",
    "Candidate_RealInterview_vietnamese": "越南语",
    "Candidate_RealInterview_khmer": "柬埔寨语",
    "Candidate_RealInterview_malay": "马来语",
    "Candidate_RealInterview_german": "德语",
    "Candidate_RealInterview_french": "法语",
    "Candidate_RealInterview_korean": "韩语",
    "Candidate_RealInterview_pu_en": "普通话/英语",
    "Candidate_RealInterview_cn_en": "广东话/英语",
    "Candidate_Language_Change_Dialog": "下 {noOfQuestion} 條問題用 {language}回答。",
    "Candidate_Language_Gotit": "明白!",
    "Candidate_Question_Upload_Fail_Answer_Again": "视频没有上传成功，请点击再次回答。",
    "Candidate_Question_Upload_Fail_Resubmit": "视频没有上传成功，请点击重新提交。",
    "Resubmit": "重新提交",
    "Candidate_Upload_Completed": "% 上载完成",
    "Candidate_Upload_Thankyou": "谢谢回答所有问题!",
    "Candidate_Upload_Wait": "请耐心等待视频上载. 请不要关闭浏览器。",
    "Candidate_upload_Complete_Wait": "请不要在上传达到100%前关闭浏览器。",
    "Candidate_Finish_Continue": "继续",
    "Candidate_Finish_Logout": "关闭窗口",
    "Candidate_Finish_Uploading": "正在上传已完成的视频，请稍为等候 ....",
    "Candidate_Finish_Redo": "抱歉!你其中{numberOfErrors}个答案未被正确录影。请按\"继续\"再次录影这{numberOfErrors}个答案,谢谢。",
    "Candidate_Support_Button": "候选人支援",
    "Candidate_Support_Title": "视频面试和评核的求职者支援",
    "Candidate_Support_Walkthrough": "视频面试和评核演练",
    "Candidate_Support_TroubleShooting": "故障排除",
    "Candidate_Support_Contact": "如果你有任何问题，请通过电子邮件<u>customer-service@neufast.com</u>与我们联系",
    "Candidate_Support_Back": "返回",
    "Candidate_Support_Login_Subtitle": "登录评核",
    "Candidate_Support_Login_Msg": "<p>第 1 步：访问应聘者的登录页面，网址为 apisit.neufast.com/candidate。可以通过最新的 Chrome/Firefox 网络浏览器进行面试和评核。请更新你的 chrome 或 firefox 浏览器为新版本。建议使用带 WI-FI 连接的手提电脑或座台电脑，以确保获得最佳录制性能。 </p> <p>第 2 步：输入电子邮件地址和面试邀请电子邮件中的访问代码。仅在指定的面试期间可登录。 </p>",
    "Candidate_Support_Check_Subtitle": "检查网络摄像头和音频",
    "Candidate_Support_Check_Msg": "系统将打开视频和设置页面并检查网络摄像头、互联网连接、照明、麦克风和扬声器设置。 请确保网络摄像头和麦克风已打开，而且互联网连接流畅快速。",
    "Candidate_Support_Practice_Subtitle": "视频面试和评核的练习",
    "Candidate_Support_Practice_Msg": "对于每种类型的评核（视频面试/多项选择题/短答题），在实际评核之前都会提供随机练习题。在练习中，为回答问题提供的布局和时间与实际评核相同。建议你利用这个机会练习和熟悉系统。这种练习评核可以根据需要进行多次。",
    "Candidate_Support_Record_Subtitle": "面试和评核进行中",
    "Candidate_Support_Record_Msg": "通过练习部分后，评核即将开始。具体回答时间由招聘人员规定。为确保对所有求职者的公平性，所有评核只能进行一次。因此，建议求职者在评核前多做练习测试。",
    "Candidate_Support_Tips_Subtitle": "获得更好视频录制效果的提示（仅适用于视频面试）",
    "Candidate_Support_Tips_Msg": "然后我们有一些提示可以给你提供高质素的影片招聘者。<ul><li>找一个安静的环境</li><li>在光线充足且没有背光的情况下录制视频，有正常拍摄的要求</li><li>把你的鏡頭水平調節到接近你視覺的水平,這做法有助於給面試官表現自信及接近於正常對話的感覺</li></ul>",
    "Candidate_Support_Help_Subtitle": "需要更多面試技巧方面的幫助",
    "Candidate_Support_Help_Msg": "你是否需要更多求职和面试的建议和实践？ 我们一直与世界各地的认证职业教练合作，帮助求职者准备面试和选择职业道路。 如果你需要帮助，请随时通过 customer-service@neufast.com 联系我们进行免费咨询或访问我们的职业发展网站 <a href='http://www.neucareers.com'> www.neucareers.com </a> 。",
    "Candidate_Support_SystemRequirement_Subtitle": "视频面试和评核的系统要求",
    "Candidate_Support_SystemRequirement_Msg": "<p>对于求职者，台式电脑/笔记本电脑支持最新的 Google Chrome（90 或更高版本）、Firefox（88 或更高版本）、Safari（14 或更高版本）和 Chromium Edge（76 或更高版本）。还支持 Android 上的 Google Chrome（92 或更高版本）以及 iOS 14 或更高版本上的 Safari 和 Chrome。其他浏览器推荐安装谷歌Chrome浏览器。 </p><p>为确保获得最佳视频面试效果，强烈建议使用装有 Windows 或 MacOS 的座台电脑/手提电脑，使用最新的 Google Chrome 或 Firefox 浏览器进行视频面试。只要建立了良好的互联网连接并且没有中断（例如来电），也可以使用手机。 </p>",
    "Candidate_Support_AllowAccess_Subtitle": "允許连接你的攝像頭、麥克風",
    "Candidate_Support_AllowAccess_Msg": "<p>该网站需要使用网络摄像头和麦克风才能进行面试和评核。在视频和音频设置页面，如果你使用预先正确设置的支持浏览器，系统将提示你授予对麦克风和摄像头的访问权限。两者都单击允许。 （你只需执行一次）。 </p><p>如果你不小心拒绝了对摄像头或麦克风的访问，你可以重新启动浏览器，一旦你重新访问，浏览器会再次提示你授予访问权限 视频和音频设置页面。 </p>",
    "Candidate_Support_Speaker_Subtitle": "打开扬声器",
    "Candidate_Support_Speaker_Msg": "虽然不是强制性的，但启用扬声器可以让系统读出面试问题，以创造更具吸引力的面试体验。 它可以在视频和音频设置期间进行测试。",
    "Candidate_Support_NetworkQuality_Subtitle": "解决网络质素",
    "Candidate_Support_NetworkQuality_Msg": "<p>为确保视频采访录音的最佳质量，请确保你的设备在开始前具有良好的互联网连接。</p><p>至少有 1Mbps 的稳定上传速度，可实现流畅的视频和音频上传，如果你使用固定电话或 WIFI 网络，通常可以实现。</p><p>请使用 SpeedTest.net 检查用户连接速度。</p><p>如果你在手机上使用蜂窝网络，我们会降低录制分辨率以提高数据传输的平滑度。但是你在录制时可能仍会遇到困难。强烈建议你尝试使用以下提示获得更高质量的连接：</p><ul><li>对于 WiFi 用户，请确保你的设备信号强且路由器已连接到互联网。尝试将你的设备重新放置在靠近 WiFi 路由器的位置，或尝试重新启动路由器。</li><li>对于手机用户，请尝试寻找信号较强的位置。</li><li>有关信号问题，请联系你的互联网服务提供商。</li></ul>",
    "Candidate_Support_CameraIssues_Subtitle": "解决摄像头问题",
    "Candidate_Support_CameraIssues_Msg": "<p>尝试以下方法来解决摄像头问题：</p><ul><li>确保你已允许访问摄像头。</li><li>确保你使用的是 Chrome 浏览器并且浏览器是最新的。</li><li>使用更新后的浏览器重新启动设备。</li><li>检查你的系统设置，确保摄像头安装正确并且可以访问。</li><li>如果按照上述步骤操作后问题仍然存在，请联系网络摄像头制造商。</li></ul>",
    "Candidate_Support_MicrophoneIssues_Subtitle": "解决麦克风问题",
    "Candidate_Support_MicrophoneIssues_Msg": "<p>如果你的麦克风无法正常，请尝试以下修复：</p><ul><li>检查你是否允许使用麦克风。</li><li>确保你的麦克风没有静音并检查开关（如果有）。</li><li>检查你的系统设置，确保你的麦克风是默认录音设备并且有正确的录音电平。</li><li>重启设备。</li><li>如果你在尝试上述修复后仍然遇到问题，请联系你的麦克风制造商。</li></ul>",
    "Candidate_Support_AboutNeufast_Subtitle": "关于Neufast",
    "Candidate_Support_AboutNeufast_Msg": "Neufast 是视频求职面试的领导者和专家，帮助招聘人员更快地找到合适的人选，并帮助人才更快地获得工作机会。 视频的面试还允许候选人展示他们的才能，基于文字或基于文本的评核所能表达的范围。 招聘人员还可以有效地全面评核候选人。",
    "Candidate_Support_FAQ_Subtitle": "常见问题",
    "Candidate_Support_FAQ_Msg": "<ul><li><p>什么是单向视频面试评核？</p><p>视频面试是一种单向在线面试。一旦招聘人员邀请你参加面试，你就可以在线访问系统并自动进行面试。面试被录音 这让更多的候选人有机会向潜在雇主展示他们的才能和抱负，而不是纯粹通过简历来评判。</p></li><br/><li><p>面试系统可以使用什么设备？</p><p>你需要带有网络摄像头、麦克风和良好的互联网连接的台式机或笔记本电脑。 也可以使用安卓手机。 系统支援最新的 Google Chrome（90 或以上）、Firefox（88 或以上）和 Chromium Edge（76 或以上）的笔记本电脑/桌上电脑。亦支援 Android 上的 Google Chrome（92 或更高版本）。建议使用 IE 或 Safari 等浏览器的用户安装 Google Chrome 浏览器。 iPhone/iPad 用户需要从 App Store 下载 Neufast 面试 App 进行面试。</p><p>为确保最佳视频面试效果，强烈建议使用装有 Windows 或 MacOS 的笔记本电脑/台式机，并使用最新的 Google Chrome 或 Firefox 浏览器进行视频面试。 使用安卓手机和Chrome浏览器也是可以的，但面试前请确保网络连接良好并没有打扰。</p></li><br/><li><p>我没有笔记本电脑。我可以用我的手机吗？</p><p>是的，但手机的互联网连接不太稳定。建议找一个WIFI连接好的地方。此外，仅支持安卓手机。通常建议 iOS 手机使用笔记本电脑。</p></li><br/><li><p>我的手机刚刚连接了 3G，会不会有问题？</p><p>我们建议使用良好的 WiFi/4G 服务。使用 3G 会导致更长的视频上传时间和更低的视频质量。如果这是唯一的选择，我们建议你尝试找到上传速度最高的位置，然后在视频和音频设置页面测试网络情况。</p></li><br/><li><p>这个面试我可以参加多少次？</p><p>你只能参加一次面试。话虽如此，你可以根据需要多次练习以适应系统。</p></li><br/><li><p>这个视频面试需要多长时间？</p><p>这取决于招聘人员为你设置的问题数量。通常在 30 分钟以下。</p></li></ul>",
    "Candidate_AppSupport_PP_Title": "个人隐私政策 (PPS)",
    "Candidate_AppSupport_TC_Title": "条款和条件 (T&C)",
    "Button_Yes": "确认",
    "Button_No": "取消",
    "Deparment": "部门",
    "Job": "职位",
    "Candidate": "候选人",
    "Understand": "了解",
    "Name": "名称",
    "Email": "电子邮件",
    "Current_Deadline": "当前截止日期",
    "Interview_Status": "面试状态",
    "Close": "关闭",
    "Minutes": "分钟",
    "Minute": "分钟",
    "Second": "秒",
    "Seconds": "秒",
    "Question": "个问题",
    "Questions": "个问题",
    "Or": "或",
    "Back": "后退",
    "Start": "开始",
    "Record_Control_Error_Msg": "无法访问相机/音频设备。请确保已启用它们，并且没有其他应用程序正在使用它们。",
    "Shortlisted": "入围",
    "Rejected": "不录用",
    "Waiting_Listed": "在候补名单",
    "Pending": "新候选人",
    "Waiting_Invitation": "未开始",
    "Processing": "处理视频中",
    "Completed": "完成",
    "Partially_Completed": "部分完成",
    "No_Quota": "面试限额用完",
    "in_progress": "面试进行中",
    "self_introduction_completed": "未开始",
    "Login_HiAdmin": "欢迎使用 Neufast CMS",
    "Recruiter_Review_Title": "需审核候选人",
    "Recruiter_Dashboard_TableColumn_ProgrammeName": "部门",
    "Recruiter_Dashboard_TableColumn_JobName": "职位名称",
    "Recruiter_Dashboard_TableColumn_InterviewLanguage": "面试语言",
    "Recruiter_Dashboard_TableColumn_Last_Video": "最后影片上传时间",
    "Recruiter_Dashboard_TableColumn_First_Video": "最初影片上传时间",
    "Recruiter_Dashboard_TableColumn_Num_Of_Video": "已上传影片数量",
    "Recruiter_Dashboard_TableColumn_Export": "输出",
    "Review_Evaluation_Title": "审核",
    "Recruiter_Skills_Openness": "经验开放性",
    "Recruiter_Skills_Conscientiousness": "尽责性",
    "Recruiter_Skills_Extraversion": "外向性",
    "Recruiter_Skills_Agreeableness": "亲和性",
    "Recruiter_Skills_Neuroticism": "情绪不稳定性",
    "Recruiter_Review_Instruction": "这页列出需审核候选人的名单",
    "Recruiter_Review_List_Files_Failure_Msg": "检索文件失败",
    "Recruiter_Review_Transfer_S3_Files_Dialog_Title": "从S3传输文件",
    "Recruiter_Review_Transfer_S3_Files_Dialog_LocalFiles": "本地文件存储库",
    "Recruiter_Review_Transfer_S3_Files_Dialog_S3Files": "S3",
    "Recruiter_Review_Transfer_S3_Files_Dialog_Success_Msg": "已成功复制所选文件",
    "Recruiter_Review_Transfer_S3_Files_Dialog_Failure_Msg": "复制所选文件失败",
    "Question_Number": "问题编号",
    "Filename": "文档名称",
    "Filesize": "文件大小",
    "Candidate_Interview_Finish_Message": "感谢你完成 {interview_name} ({interview_type})。",
    "Candidate_Continue_Message": "请继续进行 {interview_name} ({interview_type})。",
    "interview": "面试",
    "TextField_Required": "* 必须填写",
    "Happy": "高兴",
    "Sad": "悲伤",
    "Fear": "担忧",
    "Surprise": "惊讶",
    "Neutral": "中性",
    "Grimace": "厌恶",
    "Pouty": "不悦",
    "Recruiter_Interview_Monitor_Title": "正在进行的面试中的职位",
    "Recruiter_Interview_Monitor_Hintbox_Message": "此页面显示在面试截止日期之前有求职者处于\"待邀请\"和\"已邀请待面试\"的职位。",
    "Recruiter_Interview_Monitor_TableColumn_RecruiterName": "招聘人员姓名",
    "Recruiter_Interview_Monitor_TableColumn_RecruiterEmail": "招聘人员电邮",
    "Recruiter_Interview_Monitor_TableColumn_JobTitle": "职位Id",
    "Recruiter_Interview_Monitor_TableColumn_InterviewDeadline": "面试截止日期",
    "Recruiter_Interview_Monitor_TableColumn_Total_Num_Of_Candidates": "求职者总数",
    "Recruiter_Interview_Monitor_TableColumn_Completion_Rate": "完成率",
    "Recruiter_Interview_Monitor_TableColumn_Num_Of_Invited_Candidates": "获邀求职者人数",
    "Recruiter_Interview_Monitor_TableColumn_Num_Of_Pending_Invitations": "待邀请的求职者人数",
    "Recruiter_Interview_Monitor_Job": "{count} 职位",
    "TC_Header": "條款及細則",
    "TC_Top_Section": "Neufast Limited（\"公司\"）提供對 neufast.com 網站（\"網站\"）上內容的訪問和使用，並受以下條款和條件的約束。 你同意使用本網站構成你接受這些條款和條件，這些條款和條件自你首次使用本網站之日起生效。 本公司保留隨時通過在線發布更改來更改這些條款和條件的權利，建議你定期訪問此頁面以查看條款和條件，因為它們適用於你。 在發布更改後，你繼續使用本網站即構成接受本協議（由發布的更改修改）。 本文中的術語\"你\"，\"用戶\"和\"用戶\"是指出於任何原因或目的在任何時間訪問和/或使用本網站的所有個人和/或實體。",
    "TC_Content_1": "網站使用",
    "TC_Content_1.1": "你同意僅出於合法目的使用本網站，並且以不侵犯任何第三方的權利或限製或禁止任何第三方使用和享用本網站的方式，包括但不限於違法或 可能騷擾或給任何人造成困擾或不便，以及淫穢或令人反感的內容的傳輸或網站內正常對話流程的中斷。",
    "TC_Content_1.2": "你不得使用本網站侵犯他人的知識產權。",
    "TC_Content_1.3": "你不得使用本網站傳輸，發布，上傳，張貼，散佈或存儲任何威脅，騷擾，誹謗，非法，有害，淫穢，誹謗或其他令人反感或令人反感的材料。",
    "TC_Content_1.4": "你不得使用任何軟件，工具或程序或以其他方法干擾網站服務器的正常運行。",
    "TC_Content_1.5": "你不得有意或有意地使網站系統超載。",
    "TC_Content_1.6": "你不得將任何計算機病毒或任何破壞性程序傳播到網站及其成員。",
    "TC_Content_1.7_Title": "特定用戶-求職者",
    "TC_Content_1.7_a": "在網站上尋找工作的用戶（\"求職者\"）同意保留其登錄名和密碼，並且不會透露給其他任何人。 求職者應全權負責維護登錄名和密碼的機密性以及任何（授權或未經授權的）登錄名和密碼的使用。 求職者同意在未經授權的情況下立即將其通知公司。",
    "TC_Content_1.7_b": "求職者不得將任何不完整，虛假或不准確的簡歷資料發佈到網站或公司。",
    "TC_Content_1.7_c": "求職者向網站提交的所有資料必須合法，體面，非歧視和真實。 求職者應對提交給網站或公司的內容和材料負全部責任。",
    "TC_Content_1.7_d": "求職者不得以任何理由對任何就業機會作出回應，除非是為了申請廣告招聘的職位。",
    "TC_Content_1.7_e": "求職者提交的簡歷旨在為在尋找僱員時向用戶或廣告商（\"僱主\"）提供相關資料。",
    "TC_Content_1.7_f": "求職者提交的個人數據將用於協助求職者與網站或公司的僱主和招聘人員一起尋找合適的工作。 求職者在申請職位空缺或將其個人簡歷存儲在公司的簡歷數據庫中時，確實會將其個人數據披露給網站和公司的僱主和/或招聘人員。 對求職者的認可。",
    "TC_Content_1.7_g": "求職者提交給網站或公司的任何資料均應遵守公司的隱私政策聲明。",
    "TC_Content_1.7_h": "求職者接受向僱主提供的個人數據或資料完全由自己承擔風險。 如果任何僱主將求職者的個人數據用於除尋找僱員以外的任何用途，則公司在任何情況下均不承擔任何責任。",
    "TC_Content_1.7_i": "求職者可將其簡歷直接發送給在網站上或通過網站登廣告的任何僱主。或者，求職者可以通過網站將其簡歷發送給公司，以回復任何招聘廣告。在這種情況下，在遵守法律要求的情況下，求職者的履歷將在網站上保留預定的時間，即使在此停用了服務，除非求職者要求刪除或刪除它。此後，它將被存儲在公司的數據庫中，求職者自負風險。",
    "TC_Content_1.7_j": "求職者可以將自己的簡歷存儲在公司的數據庫中，但不允許僱主搜索。在這種情況下，求職者可以使用自己的簡歷在線申請工作，但是僱主和招聘者將無法通過公司的數據庫訪問它。",
    "TC_Content_1.7_k": "如果求職者加入\"候選人匹配\"功能並同意將其簡歷透露給潛在僱主，那麼所有在公司刊登廣告或訂閱公司服務的僱主和招聘者都可以訪問他/她的 她的簡歷。公司將不會向無法確定身份的僱主和招聘者透露有關求職者的信息。求職者提供的個人數據將嚴格按照公司的《個人信息收集聲明》和《隱私政策聲明》使用。",
    "TC_Content_1.7_l": "求職者提供的個人數據和簡歷是旨在為僱主提供相關資料，以尋找僱員。",
    "TC_Content_1.7_m": "求職者提交的個人數據將用於協助求職者與網站或公司的僱主和招聘人員一起尋找合適的工作。求職者在申請職位空缺或將其個人簡歷存儲在公司的簡歷數據庫中時，向網站和公司的招聘人員披露其個人數據，所有這些均由求職者確認 。",
    "TC_Content_1.7_n": "儘管公司將盡最大努力僅向公司的僱主，招聘經理，獵頭，人力資源專業人員和內部授權人員授予對數據庫的訪問權限，但公司不保證也不保證其他方不會在沒有授權的情況下公司的同意，獲得對數據庫的訪問。任何求職者都可以隨時禁止僱主查看自己的簡歷。但是，求職者承認，僱主和其他本來可以訪問數據庫的各方，可能已經在自己的​​文件或數據庫中保留了求職者簡歷的副本。在這些情況下，公司對簡歷的保留，使用或隱私，或將這些簡歷保存在數據庫中時，任何此類人士對簡歷的使用或隱私，本公司概不負責。",
    "TC_Content_1.7_o": "如果求職者加入\"候選人匹配\"功能並同意將其簡歷透露給潛在僱主，那麼所有在公司刊登廣告或訂閱公司服務的僱主和招聘者都可以訪問他/她的 她的簡歷。公司將不會向無法確定身份的僱主和招聘者透露有關求職者的信息。求職者提供的個人數據將嚴格按照公司的《個人信息收集聲明》和《隱私政策聲明》使用。",
    "TC_Content_1.7_p": "求職者可以將網站上的工作資料發送給他們認識的人，這些人在尋求工作時需要這些資料，但不得將這些資料用於其他目的，並且不得濫用此功能。",
    "TC_Content_1.7_q": "根據《個人資料（私隱）條例》，求職者有權訪問他/她在公司保存的個人資料（須事先獲得身份證明），他/她可隨時編輯或修改此類個人資料。任何訪問或更正的請求都可以通過將書面請求發送給公司來提出。有關詳細信息，請參閱個人信息收集聲明和隱私政策聲明。進一步地或替代地，求職者（取決於身份的事先確認）可以隨時在網站上直接編輯或修改他/她的個人數據。",
    "TC_Content_1.8": "具體用途-僱主",
    "TC_Content_1.8_a": "在向公司支付服務費和/或根據公司不時規定的其他條款和條件（如果有）後，僱主將有權使用該網站在特定時期內刊登廣告。僱主應對其廣告中包含的內容和材料承擔全部責任。本公司保留根據需要編輯任何廣告的權利。",
    "TC_Content_1.8_b": "根據公司不時規定的有關求職者資料訪問的條件或要求，僱主有權訪問公司維護的求職者數據庫，但同意所有資料僅用於未經相關求職者事先同意，不得將尋找潛在僱員的目的和此類資料透露給任何其他方。",
    "TC_Content_1.9": "具體用途-應屆畢業生",
    "TC_Content_1.9_a": "用戶將對發佈到網站的\"開放論壇\"的任何演講，消息和附件（如果適用）及其後果承擔任何責任。",
    "TC_Content_1.9_b": "用戶發佈到網站的\"開放論壇\"上的文章，評論和/或內容的主題必須具有討論，研究或表達自己觀點的性質。嚴禁誹謗，粗俗和淫穢的語言。任何文章的內容本質上都不可以是向他人索取商品和服務，廣告或誹謗。本公司保留編輯或刪除違反這些條款的\"開放論壇\"中任何材料和內容的權利，對於由此造成的任何損失或損害，本公司概不負責。",
    "TC_Content_2_Title": "未成年人",
    "TC_Content_2": "如果你未滿18歲，或者你被視為未成年人或無法承擔法律責任，則不允許你使用該網站。如果你希望查看和訪問本網站，則應就這些條款和條件的含義和後果向父母或監護人尋求建議。公司假定該網站的每個用戶都已達到法定年齡。公司沒有義務核實你的年齡，但是如果發現本網站的任何用戶都不合法，則本公司保留針對此類用戶或其父母或監護人的權利。 ，包括終止訪問網站的權利。",
    "TC_Content_3": "保證和責任",
    "TC_Content_3.1": "網站及其中提供的資料均按\"原樣\"提供，沒有法律允許的最大範圍的明示或暗示保證。",
    "TC_Content_3.2": "無論是針對任何特定目的的產品的適用性或服務的明示或免責聲明，包括對所有產品的適用性或非特定目的的免責聲明。",
    "TC_Content_3.3": "本公司對本網站上的資料，內容或資料的準確性，可靠性，完整性和及時性不做任何保證。",
    "TC_Content_3.4": "對於網站內容中的任何錯誤或遺漏，或刪除，傳送錯誤或未能存儲任何用戶通訊或個性化設置，本公司概不負責。",
    "TC_Content_3.5": "本公司不保證本網站在任何時間都不會出錯，該網站及其服務器在任何時間都不會電腦病毒或其他有害機制，不會糾正任何缺陷， 或網站的運行將不間斷，及時或安全。 如果你對網站，商品或材料的使用導致需要維修或更換設備或數據，則本公司不承擔這些費用。",
    "TC_Content_3.6": "所有用戶使用公司的網站和通過它訪問的任何其他網站，後果自負。 你應對自己的通信負責，並對其發布的後果負責。 本公司不代表或保證其他用戶發布的任何通信的真實性，準確性或可靠性，也不認可用戶表達的任何觀點。 用戶對其他用戶發布的材料的任何依賴將自擔風險。 本公司保留權利在任何時候違反本協議或違反法律驅逐任何用戶並阻止其進一步訪問該網站的權利，並且保留從其唯一的網站上刪除任何消息或材料的權利。 公司認為不可接受，有辱人格，違法或破壞性行為。",
    "TC_Content_3.7": "該網站可能包含指向第三方網站的鏈接。 提供這些資料僅是為了給用戶提供方便，而不是以任何方式由公司認可此類第三方網站上的內容。 如果任何用戶訪問任何鏈接的第三方網站，則完全由自己承擔風險。 本公司對鏈接到其網站的任何第三方網站的內容概不負責，也不對此類第三方網站上內容的準確性或準確性作任何陳述或保證。 此外，鏈接到該網站的其他網站的用戶可能會查看任何用戶在該網站上發布的任何材料或詳細信息，並且本公司對鏈接的第三方對任何用戶或第三方的任何不當使用不承擔任何責任。 網站上發布的任何數據或材料。",
    "TC_Content_3.8": "公司或網站上提及的任何第三方在任何情況下均不對任何損害或傷害（包括但不限於偶然的和間接的損害，利潤損失或任何損失）承擔責任（在法律允許的範圍內）。由於數據丟失或業務中斷而造成的損失）由於使用或無法使用網站，商品和材料或任何性能故障，錯誤，遺漏，中斷，刪除，缺陷，操作或傳輸延遲，計算機病毒，通信線路故障，在線通信被攔截，軟件或硬件問題（包括但不限於數據丟失或兼容性問題），網站的失竊，破壞或變更，無論是由於違反合同，違法行為，疏忽或任何由於使用本網站或任何上載，下載或發布數據，文本，圖像或內容而直接或間接導致的任何其他原因網站上的其他材料或信息，以及是否告知本公司可能造成此類損害。",
    "TC_Content_3.9_i": "本公司也不代表或保證，對於與你訪問和使用本網站有關的以下任何情況，本公司也不承擔任何責任。",
    "TC_Content_3.9_ii": "•無病毒、惡意軟件或其他有害成分",
    "TC_Content_3.9_iii": "•無科技缺陷",
    "TC_Content_3.9_iv": "•在香港以及其他任何地區和司法管轄區的可用性和訪問權限",
    "TC_Content_3.9_v": "你有責任在使用本網站，其內容和工具時遵守你所在轄區的任何適用法律。",
    "TC_Content_4_Title": "賠償",
    "TC_Content_4": "所有用戶均同意賠償因使用本網站或違反本條款而引起或引起的任何索賠，訴訟，要求，損失或損害，並使本公司，其管理人員，董事，僱員和代理商免受損害。 本協議。 公司應將有關此類索賠，訴訟或訴訟的及時通知相關用戶。",
    "TC_Content_5_Title": "與廣告商交易",
    "TC_Content_5": "你與在網站上或通過網站找到的廣告商的往來信件或業務往來，或參與促銷活動，包括相關商品或服務的付款和交付，以及與此類交易有關的任何其他條款，條件，保證或陳述，僅在 你和廣告客戶。 你同意，對於因此類交易或網站上廣告商的存在而引起的任何形式的任何損失或損害，公司概不負責。",
    "TC_Content_6": "與其他用戶交易",
    "TC_Content_6.1": "儘管公司盡最大努力提供公正的求職和招聘服務，並且代表了僱主和僱員之間交換資料的媒介，但公司不會參與求職者與僱主之間的交易，並且公司將 對招聘服務的質量，安全性和合法性不承擔任何責任。",
    "TC_Content_6.2": "本公司不保證或擔保求職者提供的資料和/或簡歷以及僱主提供的招聘廣告的準確性。",
    "TC_Content_6.3": "公司對僱主是否有能力支付相關工資或求職者勝任這項工作概不負責。",
    "TC_Content_6.4": "如果僱主和員工發生任何爭執，他們應該自行解決，本公司概不負責。",
    "TC_Content_7": "終止",
    "TC_Content_7.1": "如果用戶提供的任何資料不准確，違反法律或包含不正當因素，公司將立即取消用戶的帳戶，恕不另行通知，並且公司保留採取公司認為適當，可取或必要的行動的權利，包括但不限於： 不限於對此類用戶採取法律行動。",
    "TC_Content_7.2": "公司保留在任何時候立即終止或暫停用戶帳戶或用戶對網站或公司提供的服務的訪問權，恕不另行通知，如果公司認為用戶違反了本協議中包含的任何條款 同意或採取公司認為適當，可取或必要的進一步行動。",
    "TC_Content_7.3": "公司保留決定用戶和/或求職者和/或僱主是否違反本協議任何條款的最終權利和絕對酌處權。",
    "TC_Content_8": "知識產權",
    "TC_Content_8.1": "網站中包含的所有資料，圖形，文本，圖像內容和設計均為公司的財產，並受版權和/或其他知識產權的保護。 在訪問該網站時，用戶同意僅可以出於個人非商業目的下載內容。",
    "TC_Content_8.2": "未經事先書面許可，用戶不得以任何其他方式複制，抄襲，傳播，散佈，出售，分發，發布，廣播，散佈，存儲（以任何媒介），以任何其他方式修改或更改本網站下的內容 該公司的。",
    "TC_Content_9": "一般",
    "TC_Content_9.1": "如果由於任何原因使這些條款和條件中的任何一項或多項或其在任何情況下的應用被視為無效，非法或不可執行，則該條款或條件在任何其他方面的有效性，合法性和可執行性以及其餘 條款和條件不得以任何方式受到損害。",
    "TC_Content_9.2": "我方未能或延遲行使本條款和條件下的任何權利或救濟不得解釋為或被視為棄權，我方單獨或部分行使任何權利或救濟也不妨礙我方進一步行使該權利或救濟。",
    "TC_Content_9.3": "我們可以隨時將這些條款和條件中包含的任何或全部權利和義務轉讓給任何一方。",
    "TC_Content_9.4": "如果這些通用條款和條件與規則和/或本網站上出現的與特定材料有關的特定使用條款之間有任何衝突，則應以後者為準。",
    "TC_Content_9.5": "本條款和條件以及因你使用本公司網站而產生或附帶的任何爭議或事項應受香港特別行政區法律管轄，你和本公司均同意接受香港特別行政區法院的管轄。",
    "PPS_Header": "私隱條例說明",
    "PPS_Top_Section": "Neufast Limited（\"公司\"）尊重個人數據，並承諾遵守數據保護原則和《個人數據（隱私）條例》（\"條例\"）的所有相關規定。 數據由公司的網站服務Neucareers.com（以下簡稱\"網站\"）收集。 公司的PPS是有關數據用戶與其處理的個人數據有關的隱私政策和慣例的一般性聲明。",
    "PPS_Content_1_i": "政策聲明",
    "PPS_Content_1_ii": "公司在保護向公司提供個人資訊的個人隱私利益方面的總體承諾。",
    "PPS_Content_1_iii": "我們尊重個人資料私隱，並遵守個人資料私隱專員（PCPD）不時頒佈的個人資料（私隱）條例（PDPO）及相關實務守則。",
    "PPS_Content_2_i": "慣例聲明",
    "PPS_Content_2_ii": "在使用本網站的過程中，用戶可能會披露或被要求提供個人資料和/或數據。 為了受益於本網站並享受本網站提供的各種服務，用戶可能有必要向公司提供其個人信息和/或數據。 儘管用戶沒有義務按照網站上的要求提供信息和/或數據，但如果用戶未能提供服務，公司將無法在網站上提供某些服務。",
    "PPS_Content_2_iii": "用戶在此同意，用戶提供給公司的任何資料都是自願的，並且是準確，真實，最新和完整的。 如果不是這種情況，或者公司有合理的理由懷疑，則公司有權取消和/或拒絕向用戶提供服務。",
    "PPS_Content_2_iv": "公司收集和使用本網站上的資料和數據的目的包括但不限於以下目的：",
    "PPS_Content_2_v": "•提供給用戶的服務的日常運行；",
    "PPS_Content_2_vi": "•協助求職者在僱主找到適當的工作，並協助僱主評估候選人是否適合擔任各種工作和行業的空缺職位；",
    "PPS_Content_2_vii": "• to share with Affiliates so that they may provide Users with promotion and marketing materials;",
    "PPS_Content_2_ix": "•處理和跟進用戶的詢問、請求和投訴；",
    "PPS_Content_2_x": "•就與用戶使用本網站有關的行政通知和通訊聯繫用戶，並回應用戶的詢問或要求；",
    "PPS_Content_2_xi": "•協助公司發展以用於將來的營銷和促銷目的或其他內部目的；",
    "PPS_Content_2_xii": "•驗證已在網站上張貼廣告，材料，表示，消息，視圖或評論或其他資料（統稱為\"資料\"）的用戶的身份；",
    "PPS_Content_2_xiii": "•確定查看過網站上發布的資料的用戶；",
    "PPS_Content_2_xiv": "•通過註冊公司和/或其關聯公司和/或合作夥伴公司舉辦的特別活動和促銷活動，使用戶能夠享受作為網站成員的利益；",
    "PPS_Content_2_xv": "•通過接收和使用行銷文宣資料，確定作為網站成員享受其利益的用戶；",
    "PPS_Content_2_xvi": "•協助本公司和/或附屬公司將用戶的個人資料用於與本公司提供的服務以及本公司和/或其附屬公司的行銷服務和/或特別活動有關的目的；",
    "PPS_Content_2_xvii": "•獲取有關用戶的統計資料以分析網站的使用情況，以幫助其進一步開發以供內部使用； 和",
    "PPS_Content_2_xviii": "•除上述目的外，與附屬公司提供和/或行銷其產品和/或服務有關的目的，視公司認為合適。",
    "PPS_Content_2_xix": "•幫助改善網站為所述相關目的提供的服務。",
    "PPS_Content_2_xx": "如果用戶未滿13歲，則公司強烈建議他/她事先徵求對此有父母責任的人的同意。父母或監護人，他們可以聯繫負責的客戶支持主管，其聯繫方式在\"查詢\"部分列出，以將用戶註冊為網站成員。",
    "PPS_Content_2_xxi": "本公司力求只收集與上述目的相關的必要且充分但不過分的個人資料。",
    "PPS_Content_2_xxii": "如果公司要求出於上述目的以外的目的使用你的個人數據，我們將徵求你的同意。如果你未成年人，則應由你的父母或監護人給予規定的同意。",
    "PPS_Content_3_i": "安全",
    "PPS_Content_3_ii": "用戶個人資料和數據的安全性對於Neufast Group至關重要。我們將始終努力確保保護用戶的個人資料和數據免遭未經授權的訪問。我們已採取適當的電子和管理措施，以保護，保護和保護用戶的個人信息和數據。",
    "PPS_Content_3_iii": "用戶提供的所有個人信息和數據只能由公司或其授權的第三方的授權人員訪問，並且應指示這些人員在訪問此類個人資料和數據時遵守本隱私聲明的條款。用戶可以放心，他們的個人信息和數據將僅保留達到實現收集目的所必需的時間。註冊用戶應通過保密對其進行保密，以保護其唯一的用戶名和密碼，並且切勿與任何人共享這些詳細信息。",
    "PPS_Content_3_iv": "公司使用第三方服務提供商來促進網站上的電子支付交易。",
    "PPS_Content_3_v": "本公司遵循公認的行業標準，以保護用戶在傳輸過程中以及我們收到後向網站提交的個人資料和數據。但是，互聯網上的傳輸方法或電子存儲方法都不是100％安全的。因此，儘管我們努力保護用戶的個人信息和數據免遭未經授權的訪問，但公司不能保證其絕對安全。",
    "PPS_Content_4_i": "保存用戶的個人資料和簡歷",
    "PPS_Content_4_ii": "為了向僱主和廣告商提供有關用戶的最相關資料（並取決於用戶在網站上的個人資料隱私設置），該網站還將掃描與該用戶的個人資料相關的主要簡歷。內容可以在廣告商數據庫中顯示給廣告商。如果你不希望將簡歷中的內容顯示給廣告商，請不要附加簡歷。",
    "PPS_Content_5_i": "保留個人資料",
    "PPS_Content_5_ii": "一旦Neufast Limited 獲得用戶的個人資訊和/或數據，將在公司系統中安全保存一段時間，以實現\"實踐聲明\"一節中規定的收集數據的目的。注册後，用戶可通過聯系公司的數據隱私專員（其聯繫方式見\"査詢\"部分）終止其網站會員資格。本公司可保留用戶的個人資訊，即使用戶已關閉其帳戶，但前提是保留是為了遵守我們的法律義務、滿足監管要求、解决用戶之間的糾紛、防止欺詐和濫用、或執行本隱私權聲明和條款和條件而合理需要的。",
    "PPS_Content_6_i": "隱私聲明的變更",
    "PPS_Content_6_ii": "公司保留在公司認為必要時隨時更新，修訂，修改或修改本隱私聲明的權利，因此強烈建議用戶經常閱讀本隱私聲明。如果公司決定更新，修訂，修改或修改本隱私聲明，則公司會將這些更改發佈到本公司認為適當的網站和/或其他地方，以便用戶知道公司收集的信息，我們如何使用以及在什麼情況下（如有），公司會予以披露。",
    "PPS_Content_6_iii": "如果公司對本隱私聲明進行了重大更改，我們將通過電子郵件或網站首頁上的通知的方式在此網頁上通知用戶。本隱私聲明的此類更改應自公司在網站上發布之日起適用。用戶繼續使用本網站和本網站上的服務即構成接受本隱私聲明的更改。",
    "PPS_Content_7_i": "Cookies的使用",
    "PPS_Content_7_ii": "Cookies是網站在網站上傳輸到個人硬盤上以進行記錄保存的資料項。 Cookies可以通過保存密碼，購買交易和使用偏好來簡化網上沖浪。 Cookies的使用是行業標準，你可以在大多數主要網站上找到Cookies。",
    "PPS_Content_7_iii": "Cookie本身不包含任何個人識別資料，儘管它可以使公司將用戶對服務的使用與用戶先前已提交的個人識別資料（如果有）相關聯。",
    "PPS_Content_7_iv": "你可能偶爾會從我們的廣告客戶那裡獲得Cookie。這些Cookie是從第三方計算機發送的，並且受此類第三方政策的約束。該網站上已安裝了Google Analytics（分析），以進一步了解訪問者的行為。如果你希望退出分析性廣告功能，則可以訪問相關的Google服務頁面。",
    "PPS_Content_7_v": "大多數瀏覽器最初都設置為接受Cookie。如果你不希望透露以上資料，則應將其設置為拒絕cookie。但是，如果這樣做，站點的大多數區域可能無法正常運行。",
    "PPS_Content_8_i": "外包安排",
    "PPS_Content_8_ii": "該公司一直在使用其內部資源來開發和維護其IT系統。當公司聘請第三方供應商提供與其IT系統相關的某些服務時，在通常情況下，供應商將無權訪問IT系統中存儲的個人數據。",
    "PPS_Content_8_iii": "在此類供應商具有此類訪問權限的特殊情況下，公司將採取合理措施以確保：（i）此類供應商在合同上有義務對此類個人數據保密，並採取適當措施防止任何未經授權的訪問，使用，丟失，保留，修改，轉讓或其他方式。",
    "PPS_Content_9_i": "查詢，數據訪問請求和數據更正",
    "PPS_Content_9_ii": "根據PDPO，任何人都有權進行查詢，請求訪問並更正我們持有的其個人數據。根據POPO的條款，我們有權就處理任何數據訪問請求收取合理的費用。",
    "PPS_Content_9_iii": "如果你想查詢，訪問或更正我們持有的個人數據，請發送請求至：",
    "PPS_Content_9_iv": "數據隱私專員",
    "PPS_Content_9_v": "訊維有限公司",
    "PPS_Content_9_vi": "香港沙田香港科技園西區19號19W10樓1032室",
    "PPS_Content_9_vii": "電話：(+852)59876904",
    "PPS_Content_9_viii": "郵箱：customer-service@neufast.com",
    "PPS_Content_10_i": "無權利限制",
    "PPS_Content_10_ii": "本聲明中的任何內容均不會限制根據《個人數據（隱私）條例》（PDPO）對數據主體的任何權利",
    "Africa/Cote_d'Ivoire": "非洲/科特迪瓦",
    "Africa/Ghana": "非洲/加纳",
    "Africa/Addis_Ethiopia": "非洲/亚的斯埃塞俄比亚",
    "Africa/Algeria": "非洲/阿尔及利亚",
    "Africa/Eritrea": "非洲/厄立特里亚",
    "Africa/Mali": "非洲/马里",
    "Africa/Central_African_Republic": "非洲/中非共和国",
    "Africa/Gambia": "非洲/冈比亚",
    "Africa/Guinea-Bissau": "非洲/几内亚比绍",
    "Africa/Malawi": "非洲/马拉维",
    "Africa/Republic_of_Congo": "非洲/刚果共和国",
    "Africa/Democratic Republic of Congo/West Time": "非洲/刚果民主共和国/西部时间",
    "Africa/Democratic Republic of Congo/Eastern Time": "非洲/刚果民主共和国/东部时间",
    "Africa/Burundi": "非洲/布隆迪",
    "Africa/Egypt": "非洲/埃及",
    "Africa/Morocco": "非洲/摩洛哥",
    "Atlantic/Canary_Islands": "大西洋/加那利群岛",
    "Africa/Guinea": "非洲/几内亚",
    "Africa/Senegal": "非洲/塞内加尔",
    "Africa/United_Republic_of_Tanzania": "非洲/坦桑尼亚联合共和国",
    "Africa/Djibouti": "非洲/吉布提",
    "Africa/Cameroon": "非洲/喀麦隆",
    "Africa/Western_Sahara": "非洲/西撒哈拉",
    "Africa/Sierra_Leone": "非洲/塞拉利昂",
    "Africa/Botswana": "非洲/博茨瓦纳",
    "Africa/Zimbabwe": "非洲/津巴布韦",
    "Africa/South_Africa": "非洲/南非",
    "Africa/South_Sudan": "非洲/南苏丹",
    "Africa/Uganda": "非洲/乌干达",
    "Africa/Sudan": "非洲/苏丹",
    "Africa/Rwanda": "非洲/卢旺达",
    "Africa/Nigeria": "非洲/尼日利亚",
    "Africa/Gabon": "非洲/加蓬",
    "Africa/Togo": "非洲/多哥",
    "Africa/Angola": "非洲/安哥拉",
    "Africa/Zambia": "非洲/赞比亚",
    "Africa/Equatorial_Guinea": "非洲/赤道几内亚",
    "Africa/Mozambique": "非洲/莫桑比克",
    "Africa/Lesotho": "非洲/莱索托",
    "Africa/Swaziland": "非洲/斯威士兰",
    "Africa/Somalia": "非洲/索马里",
    "Africa/Liberia": "非洲/利比里亚",
    "Africa/Kenya": "非洲/肯尼亚",
    "Africa/Chad": "非洲/乍得",
    "Africa/Niger": "非洲/尼日尔",
    "Africa/Mauritania": "非洲/毛里塔尼亚",
    "Africa/Burkina_Faso": "非洲/布基纳法索",
    "Africa/Benin": "非洲/贝宁",
    "Africa/Sao_Tome_and_Principe": "非洲/圣多美和普林西比",
    "Africa/Libya": "非洲/利比亚",
    "Africa/Tunisia": "非洲/突尼斯",
    "Africa/Namibia": "非洲/纳米比亚",
    "America/Hawaii-Aleutian Standard Time": "美洲/夏威夷-阿留申标准时间",
    "America/Hawaii-Aleutian Daylight Time": "美洲/夏威夷-阿留申夏令时间",
    "America/Alaska Standard Time": "美国/阿拉斯加标准时间",
    "America/Alaska Daylight Time": "美洲/阿拉斯加夏令时间",
    "America/Mountain Standard Time": "美洲/山地标准时间",
    "America/Mountain Daylight Time": "美洲/山夏令时间",
    "America/Central Standard Time": "美洲/中部标准时间",
    "America/Central Daylight Time": "美洲/中部夏令时间",
    "America/Pacific Standard Time": "美洲/太平洋标准时间",
    "America/Pacific Daylight Time": "美洲/太平洋夏令时间",
    "America/Eastern Standard Time": "美洲/东部标准时间",
    "America/Eastern Daylight Time": "美洲/东部夏令时间",
    "America/Newfoundland Standard Time": "美洲/纽芬兰标准时间",
    "America/Newfoundland Daylight Time": "美洲/纽芬兰夏令时间",
    "America/Atlantic Standard Time": "美洲/大西洋标准时间",
    "America/Atlantic Daylight Time": "美洲/大西洋夏令时间",
    "America/Brazil/Acre Standard Time": "美洲/巴西/英亩标准时间",
    "America/Brazil/Amazon Standard Time": "美洲/巴西/亚马逊标准时间",
    "America/Brazil/Brasilia Standard Time": "美洲/巴西/巴西利亚标准时间",
    "America/Brazil/Fernando de Noronha Standard Time": "美洲/巴西/费尔南多·迪诺罗尼亚标准时间",
    "America/West Greenland Time": "美洲/西格陵兰时间",
    "America/East Greenland Time": "美洲/东部格陵兰时间",
    "America/Anguilla": "美洲/安圭拉",
    "America/Antigua_and_Barbuda": "美洲/安提瓜和巴布达",
    "America/Argentina": "美洲/阿根廷",
    "America/Aruba": "美洲/阿鲁巴",
    "America/Paraguay": "美洲/巴拉圭",
    "America/Barbados": "美洲/巴巴多斯",
    "America/Belize": "美洲/伯利兹",
    "America/Colombia": "美洲/哥伦比亚",
    "America/Bolivarian_Republic_of_Venezuela": "美洲/委内瑞拉",
    "America/French_Guiana": "美洲/法属圭亚那",
    "America/Cayman_Islands": "美洲/开曼群岛",
    "America/Costa_Rica": "美洲/哥斯达黎加",
    "America/Curacao": "美洲/库拉索岛",
    "America/Dominica": "美洲/多米尼加",
    "America/El_Salvador": "美洲/萨尔瓦多",
    "America/Turks_and_Caicos_Islands": "美洲/特克斯和凯科斯群岛",
    "America/Grenada": "美洲/格林纳达",
    "America/Guadeloupe": "美洲/瓜德罗普岛",
    "America/Guatemala": "美洲/危地马拉",
    "America/Ecuador/Galapagos Time": "美洲/厄瓜多尔/加拉帕戈斯时间",
    "America/Ecuador Time": "美洲/厄瓜多尔时间",
    "America/Guyana": "美洲/圭亚那",
    "America/Cuba": "美洲/古巴",
    "America/Jamaica": "美洲/牙买加",
    "America/Sint_Eustatius_and_Saba_Bonaire": "美洲/荷兰加勒比区",
    "America/Bolivia": "美洲/玻利维亚",
    "America/Peru": "美洲/秘鲁",
    "America/Sint_Maarten": "美洲/圣马丁",
    "America/Nicaragua": "美洲/尼加拉瓜",
    "America/Saint_Martin": "美洲/圣马丁",
    "America/Martinique": "美洲/马提尼克岛",
    "America/Saint_Pierre_and_Miquelon": "美洲/圣皮埃尔和密克隆群岛",
    "America/Uruguay": "美洲/乌拉圭",
    "America/Montserrat": "美洲/蒙特塞拉特",
    "America/Bahamas": "美洲/巴哈马",
    "America/Panama": "美洲/巴拿马",
    "America/Suriname": "美洲/苏里南",
    "America/Haiti": "美洲/海地",
    "America/Trinidad_and_Tobago": "美洲/特立尼达和多巴哥",
    "America/Puerto_Rico": "美洲/波多黎各",
    "America/Easter Island Standard Time": "美洲/复活节岛标准时间",
    "America/Chile Standard Time": "美洲/智利标准时间",
    "America/Chile Summer Time": "美洲/智利夏令时间",
    "America/Dominican_Republic": "美洲/多米尼加共和国",
    "America/St_Barthelemy": "美洲/圣巴托洛缪岛",
    "America/St_Kitts_and_Nevis": "美洲/圣基茨和尼维斯",
    "America/St_Lucia": "美洲/圣卢西亚",
    "America/US_Virgin_Islands": "美洲/美属维尔京群岛",
    "America/St_Vincent_and_Grenadines": "美洲/圣文森特和格林纳丁斯",
    "America/Honduras": "美洲/洪都拉斯",
    "America/British_Virgin_Islands": "美洲/英属维尔京群岛",
    "Asia/Yemen": "亚洲/也门",
    "Asia/Kazakhstan/East Time": "亚洲/哈萨克斯坦/东部时间",
    "Asia/Kazakhstan/West Time": "亚洲/哈萨克斯坦/西部时间",
    "Asia/Jordan": "亚洲/约旦",
    "Asia/Turkmenistan": "亚洲/土库曼斯坦",
    "Asia/Iraq": "亚洲/伊拉克",
    "Asia/Bahrain": "亚洲/巴林",
    "Asia/Azerbaijan": "亚洲/阿塞拜疆",
    "Asia/Thailand": "亚洲/泰国",
    "Asia/Lebanon": "亚洲/黎巴嫩",
    "Asia/Kyrgyzstan": "亚洲/吉尔吉斯斯坦",
    "Asia/Brunei_Darussalam": "亚洲/汶莱",
    "Asia/Mongolia/Choibalsan Time": "亚洲/蒙古/乔瓦山时间",
    "Asia/Mongolia/Ulaanbaatar Time": "亚洲/蒙古/乌兰巴托时间",
    "Asia/Mongolia/Hovd Time": "亚洲/蒙古/科布多城时间",
    "Asia/China Standard Time": "亚洲/中国标准时间",
    "Asia/Sri_Lanka": "亚洲/斯里兰卡",
    "Asia/Syrian_Arab_Republic": "亚洲/叙利亚",
    "Asia/Bangladesh": "亚洲/孟加拉国",
    "Asia/Timor-Leste": "亚洲/东帝汶",
    "Asia/UAE": "亚洲/阿联酋",
    "Asia/Tajikistan": "亚洲/塔吉克斯坦",
    "Asia/Cyprus": "亚洲/塞浦路斯",
    "Asia/Palestine": "亚洲/巴勒斯坦",
    "Asia/Vietnam": "亚洲/越南",
    "Asia/Hong_Kong": "亚洲/香港",
    "Asia/Russia/Irkutsk_Time": "亚洲/俄罗斯/伊尔库茨克时间",
    "Asia/Russia/Kamchatka_Time": "亚洲/俄罗斯/堪察加时间",
    "Asia/Russia/Krasnoyarsk_Time": "亚洲/俄罗斯/克拉斯诺亚尔斯克时间",
    "Asia/Russia/Magadan_Time": "亚洲/俄罗斯/马达加丹时间",
    "Asia/Russia/Omsk_Time": "亚洲/俄罗斯/鄂木斯克时间",
    "Asia/Russia/Vladivostok_Time": "亚洲/俄罗斯/符拉迪沃斯托克时间",
    "Asia/Russia/Yakutsk_Time": "亚洲/俄罗斯/雅库茨克时间",
    "Asia/Russia/Yekaterinburg_Time": "亚洲/俄罗斯/叶卡捷琳堡时间",
    "Asia/Turkey": "亚洲/土耳其",
    "Asia/Indonesian/Western Time": "亚洲/印尼/西方时间",
    "Asia/Indonesian/Central Time": "亚洲/印尼/中部时间",
    "Asia/Indonesian/Eastern Time": "亚洲/印尼/东部时间",
    "Asia/Israel": "亚洲/以色列",
    "Asia/Afghanistan": "亚洲/阿富汗",
    "Asia/Pakistan": "亚洲/巴基斯坦",
    "Asia/Nepal": "亚洲/尼泊尔",
    "Asia/India": "亚洲/印度",
    "Asia/Malaysia": "亚洲/马来西亚",
    "Asia/Kuwait": "亚洲/科威特",
    "Asia/Macau": "亚洲/澳门",
    "Asia/Philippines": "亚洲/菲律宾",
    "Asia/Oman": "亚洲/阿曼",
    "Asia/Cambodia": "亚洲/柬埔寨",
    "Asia/North_Korea": "亚洲/北朝鲜",
    "Asia/Qatar": "亚洲/卡塔尔",
    "Asia/Saudi_Arabia": "亚洲/沙特阿拉伯",
    "Asia/Uzbekistan": "亚洲/乌兹别克斯坦",
    "Asia/South_Korea": "亚洲/韩国",
    "Asia/Singapore": "亚洲/新加坡",
    "Asia/Taiwan": "亚洲/台湾",
    "Asia/Georgia": "亚洲/格鲁吉亚",
    "Asia/Iran": "亚洲/伊朗",
    "Asia/Bhutan": "亚洲/不丹",
    "Asia/Japan": "亚洲/日本",
    "Asia/Laos": "亚洲/老挝",
    "Asia/Myanmar": "亚洲/缅甸",
    "Asia/Armenia": "亚洲/亚美尼亚",
    "Europe/Netherlands": "欧洲/荷兰",
    "Europe/Andorra": "欧洲/安道尔",
    "Europe/Greece": "欧洲/希腊",
    "Europe/Serbia": "欧洲/塞尔维亚",
    "Europe/Germany": "欧洲/德国",
    "Europe/Slovakia": "欧洲/斯洛伐克",
    "Europe/Belgium": "欧洲/比利时",
    "Europe/Romania": "欧洲/罗马尼亚",
    "Europe/Hungary": "欧洲/匈牙利",
    "Europe/Moldova": "欧洲/摩尔多瓦",
    "Europe/Denmark": "欧洲/丹麦",
    "Europe/Ireland": "欧洲/爱尔兰",
    "Europe/Gibraltar": "欧洲/直布罗陀",
    "Europe/Guernsey": "欧洲/根西岛",
    "Europe/Finland": "欧洲/芬兰",
    "Europe/Isle_of_Man": "欧洲/马恩岛",
    "Europe/Turkey": "欧洲/土耳其",
    "Europe/Jersey": "欧洲/泽西岛",
    "Europe/Russia/Kaliningrad_Time": "欧洲/俄罗斯/加里宁格勒时间",
    "Europe/Russia/Moscow_Time": "欧洲/俄罗斯/莫斯科_时间",
    "Europe/Russia/Samara_Time": "欧洲/俄罗斯/萨马拉时间",
    "Europe/Ukraine": "欧洲/乌克兰",
    "Europe/Portugal": "欧洲/葡萄牙",
    "Atlantic/Portugal/Azores": "大西洋/葡萄牙/亚速尔群岛",
    "Europe/Slovenia": "欧洲/斯洛文尼亚",
    "Europe/United_Kingdom": "欧洲/英国",
    "Europe/Luxembourg": "欧洲/卢森堡",
    "Europe/Spain": "欧洲/西班牙",
    "Europe/Malta": "欧洲/马耳他",
    "Europe/Åland_Islands": "欧洲/奥兰群岛",
    "Europe/Belarus": "欧洲/白俄罗斯",
    "Europe/France": "欧洲/法国",
    "Europe/Cyprus": "欧洲/塞浦路斯",
    "Europe/Norway": "欧洲/挪威",
    "Europe/Montenegro": "欧洲/黑山",
    "Europe/Czech_Republic": "欧洲/捷克共和国",
    "Europe/Latvia": "欧洲/拉脱维亚",
    "Europe/Italy": "欧洲/意大利",
    "Europe/San_Marino": "欧洲/圣马力诺",
    "Europe/Bosnia_and_Herzegovina": "欧洲/波斯尼亚和黑塞哥维那",
    "Europe/Macedonia": "欧洲/马其顿",
    "Europe/Bulgaria": "欧洲/保加利亚",
    "Europe/Sweden": "欧洲/瑞典",
    "Europe/Estonia": "欧洲/爱沙尼亚",
    "Europe/Albania": "欧洲/阿尔巴尼亚",
    "Europe/Liechtenstein": "欧洲/列支敦士登",
    "Europe/Holy_See_Vatican": "欧洲/梵蒂冈",
    "Europe/Austria": "欧洲/奥地利",
    "Europe/Lithuania": "欧洲/立陶宛",
    "Europe/Poland": "欧洲/波兰",
    "Europe/Croatia": "欧洲/克罗地亚",
    "Europe/Switzerland": "欧洲/瑞士",
    "Europe/Iceland": "欧洲/冰岛",
    "Oceania/Australia/Western Standard Time": "大洋洲/澳大利亚/西部标准时间",
    "Oceania/Australia/Central Western Standard Time": "大洋洲/澳大利亚/中西部标准时间",
    "Oceania/Australia/Central Standard Time": "大洋洲/澳大利亚/中部标准时间",
    "Oceania/Australia/Eastern Standard Time": "大洋洲/澳大利亚/东部标准时间",
    "Oceania/Australia/Lord Howe Standard Time": "大洋洲/澳大利亚/豪勋爵标准时间",
    "Oceania/New_Zealand": "大洋洲/新西兰",
    "Oceania/New_Zealand/Chatham Island": "大洋洲/新西兰/查塔姆岛",
    "Admin_Auto_Email_opening_title": "迅维招聘人员账户开设",
    "Admin_Auto_Email_add_quota_title": "增加迅维面试配额",
    "Admin_Auto_Email_suspension_title": "迅维招聘人员帐户暂停",
    "Admin_Auto_Email_reactivation_title": "迅维招聘人员帐户重新激活",
    "Admin_Auto_Email_out_of_quota_title": "迅维招聘人员帐户 配额耗尽警告",
    "Admin_Auto_Email_low_quota_title": "迅维招聘人员帐户 - 配额不足警告",
    "Admin_Auto_Email_return_quota_title": "迅维面试配额归还",
    "Admin_Auto_Email_opening_content": "<p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">你好 {{Recruiter’s name, don’t change}},</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请在下方找到你的迅维招聘人员帐户的登录详细信息，如下所示：</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">网站:</span> <a href=\"https://apisit.neufast.com/\" target=\"_blank\"><span style=\"color: blue;font-size: medium;font-family: Times New Roman\", serif;\">apisit.neufast.com</span></a></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">用户名: {{Login email, don’t change}}</span>&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">密码: {{Login password, don’t change}}</span></p><p style=\"text-align:start;\"><span style=\"font -size: medium;font-family: Times New Roman\", serif;\">数量面试配额: {{Number of interview quota}}</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请使用最新的 Chrome 浏览器（89 或 90 版）或 Firefox 访问。此处附上用户指南供你参考。 </span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">如有任何疑问，请随时联系我们。非常感谢！</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">祝好，</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">迅维客户服务团队</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电邮: customer-service@neufast.com</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电话: (+852) 59876904</span></p>",
    "Admin_Auto_Email_add_quota_content": "<p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">你好 {{Recruiter’s name, don’t change}},</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请注意，以下数量的面试配额已添加到你的招聘人员帐户中。 </span>&nbsp;</p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">新增面试配额数量: {{Number of interview quota added}}</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">面试配额余额: {{Number of interview quota balance}}</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">如有任何疑问，请随时联系我们。 谢谢非常喜欢！</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">祝好,</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">迅维客户服务团队</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电邮: customer-service@neufast.com</span></p><p style=\"text-align:start;\"><span style=\"font-siz e: medium;font-family: Times New Roman\", serif;\">电话: (+852) 59876904</span></p>",
    "Admin_Auto_Email_suspension_content": "<p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">你好 {{Recruiter’s name, don’t change}},</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请注意，你的招聘人员帐户已被暂停。 </span>&nbsp;</p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">如果你有任何疑问，请随时与我们联系。非常感谢！</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">祝好,</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">迅维客户服务团队</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电邮: customer-service@neufast.com</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电话: (+852) 59876904</span></p>",
    "Admin_Auto_Email_reactivation_content": "<p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">你好 {{Recruiter’s name, don’t change}},</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请注意你的招聘人员帐户已重新激活。 </span>&nbsp;</p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">如果你有任何疑问，请随时与我们联系。非常感谢！</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">祝好,</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">迅维客户服务团队</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电邮: customer-service@neufast.com</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电话: (+852) 59876904</span></p>",
    "Admin_Auto_Email_out_of_quota_content": "<p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">你好 {{Recruiter’s name, don’t change}},</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请注意，你的招聘账户余额已降至零。请联系我们购买更多面试名额，以确保不间断的面试服务。 </span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">如有任何疑问，请随时联系我们。非常感谢！</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">祝好,</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">迅维客户服务团队</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电邮: customer-service@neufast.com</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电话: (+852) 59876904</span></p>",
    "Admin_Auto_Email_low_quota_content": "<p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">你好 {{Recruiter’s name, don’t change}},</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请注意，你的招聘账户余额已降至仅 5。请联系我们购买更多面试名额，以确保不间断的面试服务。 </span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">如有任何疑问，请随时联系我们。非常感谢！</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">祝好,</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">迅维客户服务团队</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电邮: customer-service@neufast.com</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电话: (+852) 59876904</span></p>",
    "Admin_Auto_Email_return_quota_content": "<p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">你好 {{Recruiter’s name, don’t change}},</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">请注意，以下数量的面试配额已添加到你的招聘人员帐户中。 </span>&nbsp;</p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">减少的面试配额数量: {{Number of interview quota added}}</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">面试配额余额: {{Number of interview quota balance}}</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">如有任何疑问，请随时联系我们。 谢谢你你非常喜欢！</span></p><p style=\"text-align:start;\">&nbsp;</p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">祝好,</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">迅维客户服务团队</span></p><p style=\"text-align:start;\"><span style=\"font-size: medium;font-family: Times New Roman\", serif;\">电邮: customer-service@neufast.com</span></p><p style=\"text-align:start;\"><span style=\"font- size: medium;font-family: Times New Roman\", serif;\">电话: (+852) 59876904</span></p>",
    "Sap_status_update_fail": "Success Factor连接失败",
    "Recruiter_Candidate_Result_Invalid_Identity": "招聘人员帐户无权查看此候选人的信息。请使用正确的帐户。",
    "Sap_videolink_welcome_message": "请输入你的登录详细信息以打开候选人之面试分析",
    "PDF_Bulk_download_title": "PDF批量下载状态",
    "PDF_Bulk_download_content": "以下候选人的报告无法下载",
    "PDF_Bulk_download_status": "状态",
    "PDF_Bulk_download_fail": "失败",
    "PDF_Bulk_download_reason": "报告未被准备好",
    "Recruiter_Layout_ShowConsent": "添加自定义用户协议",
    "Recruiter_Layout_ShowConsent_Tooltip": "这为候选人启用了定制的用户协议",
    "Recruiter_Layout_ShowConsent_Default_Message": "<p>这是一份用户协议</p>",
    "Recruiter_Layout_ShowConsent_Title": "协议内容",
    "Candidate_Consent_Form_Title": "用户协议",
    "Candidate_Consent_Form_Checkbox_Content": "我已阅读并同意用户协议",
    "Candidate_Consent_Form_Confirmation_Title": "确认",
    "Candidate_Consent_Form_Confirmation_Content": "点击确认后，您需要联系我们进行提现，请务必确认同意。",
    "Candidate_Consent_Form_Non_Latest_Message": "您正在检查旧版本的同意书，请刷新并重试。",
    "Candidate_Consent_Form_No_Consent_ID": "此同意不在数据库中，请刷新并重试。",
    "Candidate_Interview_WelcomeTitle_jc": "欢迎，{name}！\n 我们很高兴能与您进行这次面试。",
    "Candidate_Instruction_Details_jc": [
        "确保在一个安静的地方有良好的互联网连接，背景噪音最小。",
        "用支架支撑你的设备，或用稳固的手握住。",
        "请关闭其他网页和应用程序。",
        "为了录制高质量的视频以进行公平评估，建议在视频面试期间不要佩戴面罩。"
    ],
    "Candidate_Settings_Caption_jc": "请确保您的设备的摄像头、麦克风和扬声器已打开并正常工作，然后再进行面试。",
    "Candidate_Detail_Video_Interview_Paragraph_1_normal_jc": "您的面试包含 {noOfQuestion} {measureWord} 的问题。",
    "Candidate_Practice_Title_jc": "面试练习",
    "Candidate_Practice_Welcome_Title_jc": "欢迎参加模拟面试",
    "Candidate_RealInterview_Welcome_Title_jc": "欢迎来到您的视频面试！",
    "Candidate_RealInterview_Title_jc": "视频面试",
    "Candidate_Finish_Logout_jc": "返回到 JC PROcruit C",
    "Recruiter_Layout_ShowQRCode": "启用网址和二维码",
    "Recruiter_Layout_ShowQRCode_Tooltip": "生成二维码和URL以简化登录",
    "Recruiter_Layout_ShowQRCode_Default_Message": "此链接和二维码可以分享，以便候选人登录到面试界面，而无需手动添加候选人",
    "Recruiter_Layout_ShowQRCode_Title": "二维码",
    "Recruiter_Layout_QRCode_Download": "下载二维码图像",
    "Recruiter_Layout_QRCode_Open_Link": "在新标签中打开链接",
    "Recruiter_Layout_ORCode_Copy_Link": "复制链接",
    "Recruiter_Layout_QRCode_SetDeadline": "设置链接过期截止日期",
    "Recruiter_Layout_QRCode_EmailVerification": "电子邮件验证",
    "Candidate_CandidateProfile_With_CV_OPTION": "I have a resume",
    "Candidate_CandidateProfile_Without_CV_OPTION": "I don't have a resume",
    "Candidate_CandidateProfile_WorkExperience_SubTitle": "Work Experience",
    "Candidate_CandidateProfile_Education_SubTitle": "Education",
    "Candidate_CandidateProfile_Confirm_Title": "Resume Upload Confirmation",
    "Candidate_CandidateProfile_Confirm_Content": "Please make sure all filled information is correct, you will not be allowed to modify once you click the CONFIRM button below.",
    "Candidate_CandidateProfile_Validation_Error_Msg": "there are some errors in the filled fields, please check again.",
    "Recruiter_CandidateProfile_Languages_Title": "Languages",
    "Recruiter_CandidateProfile_Upload_Title": "Before the interview, please upload your resume",
    "Recruiter_CandidateProfile_Action_Upload": "上传",
    "Candidate_CandidateProfile_Action_Upload": "Submit",
    "First Name": "名字",
    "Last Name": "姓",
    "Register": "注册",
    "Candidate_Interview_LanguagePreference_Question": "您喜欢在这里使用什么语言？",
    "Candidate_InterviewLanguage_Button_ms": "马来语",
    "Candidate_InterviewLanguage_Button_en": "英语",
    "Candidate_InterviewLanguage_Button_sc": "中文",
    "Do_you_confirm_your_interview_language": "请确认您的面试语言",
    "You_selected": "您的选择：",
    "You_can_not_change_it_once_you_click_confirm": "*点击“确认”后无法更换语言",
    "Cancel": "取消",
    "Confirm": "确认",
    "SESSION_TIMEOUT_TITLE": "Session Timeout",
    "SESSION_TIMEOUT_CONTENT": "You're being timed out due to inactivity. Please choose to stay signed in or to logoff. Otherwise, you will be logged out automatically in {remaining} seconds.",
    "SESSION_STAY_LOGGED_IN": "Stay Logged In",
    "SESSION_LOGOUT": "Logout",
    "Session_Management_Title": "Session Management",
    "characters": "角色",
    "Password minimum length": "密码最小长度。",
    "Enforce a minimum length of characters": "强制最小字符长度。",
    "Needs to be betrween 6 and 128.": "需要在6到128之间。",
    "Password strength": "密码强度",
    "Require at least one uppercase letter from the Latin alphabet (A-Z)": "至少需要一个拉丁字母（A-Z）的 uppercase 字母",
    "Require at least one lowercase letter from the Latin alphabet (a-z)": "至少需要一个拉丁字母（a-z）的小写字母",
    "Require at least one number": "至少需要一个数字",
    "Require at least one non-alphanumeric character (! @ # $ % ^ & * ( ) _ + [ ] { } | ' )": "至少需要一个非字母数字字符 (! @ # $ % ^ & * ( ) _ + [ ] { } | ' )",
    "* Please Select at least one": "* 请至少选择一个",
    "Send Email Quota Exceed": "发送邮件配额超出",
    "Proceed": "继续",
    "Candidate_Default_Check_Title": "不好意思，视频侦测到以下问题： {error}。\n 请重新回答此题目。",
    "Candidate_Default_Check_Unknown_Error": "不明问题",
    "Candidate_Default_Check_No_Face": "没有面容",
    "Candidate_Default_Check_Multiple_Faces": "多于一人",
    "Candidate_Default_Check_Person_Changed": "不同求职者",
    "Candidate_Default_Check_Proxy_Person": "不同求职者",
    "Candidate_Default_Check_Possible_Lip_Sync": "声音与记录不配合",
    "Candidate_Default_Check_Multiple_Voices": "多过一个声音",
    "Candidate_Default_Check_No_Ground_Truth": "面容或者声音没有正确的录音。请确保视频最少有10秒",
    "Candidate_VAD_Check_Title": "糟糕。录制视频中缺少音频。\n 请重新进行音频视频检查。",
    "Candidate_VAD_Insufficient_Speech": "语音不足: {voiceDuration} 秒",
    "Candidate_VAD_Redirection_Button": "继续进行音频/视频检查",
    "Candidate_SelfIntroduction_Layout_InterviewStart": "开始",
    "Preview": "预览",
    "AIA_Self_Introduction_Video": "友邦保险自我介绍视频",
    "Record_Introduction_Video": "请录制 30-60秒 的自我介绍视频。",
    "Ensure_Microphone_Webcam_Speaker": "进行采访前，请确保您设备的网络摄像头、麦克风和扬声器已打开且工作正常。",
    "Authorize_Webcam_Access": "请授权访问您的网络摄像头，并确保您的脸部显示在下面的屏幕上。",
    "Micorphone": "麦克风",
    "Authorize_Microphone_Access": "请授权访问您的麦克风并与其交谈确保下面的指示器检测到您的声音。",
    "Question_1": "问题1：请介绍一下你自己。",
    "Answer_In_en": "用英语回答 |回答时间：1分钟",
    "Enusre_Internet_And_Background": "确保在背景噪音最小的安静位置良好地访问互联网。",
    "Pop_Up_Device_With_Stand": "用支架弹出您的设备，或用稳定的手握住设备。",
    "Once_Ready_Check_Webcam_Audio": "准备好后，按“开始”，我们将检查网络摄像头和音频设置。",
    "Minimum_Time": "最短时间：",
    "Duration": "长度：",
    "Completed_Assessment": [
        "您已成功完成面试 ",
        "结果将很快与您的转介人/主管分享。",
        " 您现在可以安全地关闭此浏览器选项卡。"
    ],
    "Proceed_Again": "重新进行",
    "Candidate_No_Face_detected": "无法清晰地检测到面部",
    "Candidate_Multiple_People_In_Background": "背景中有多个人",
    "Candidate_No_Audio_Detected": "未检测到音频",
    "Candidate_Default_Check_Self_Intro_Title": "糟糕，录制的视频中似乎检测到错误。请重新做这道题。",
    "Candidate_Default_Check_Self_Intro_No_Face": "未检测到面部",
    "Candidate_Default_Check_Self_Intro_Multiple_People": "背景中有多个人。",
    "Question_1_Self_Intro": "问题1：请介绍一下您自己的：",
    "Answer_In_Self_Intro": "中文回答 |回答时间： 30-60秒",
    "Question_1_List_Self_Intro": "1. 姓名 2. 年龄 3. 最高教育程度 4. 最后一份工作（如适用)",
    "Candidate_Already_Done_Self_Introduction": "您已经完成自我介绍视频",
    "Error Detected": "检测到错误",
    "Error": "错误信息",
    "Retry": "重试",
    "Retest": "重新测试",
    "Network_Check_Error_Msg": "您的网络不稳定。 请您尝试去到一个网络稳定的地方，然后点击“重试”",
    "Candidate_Interview_Network_Checking": "正在检查您的网络速度...",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_CHARACTERS": "字符",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_MINIMUM_LENGTH_TEXT": "密码最小长度。",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_MINIMUM_LENGTH_ENFORCEMENT": "强制要求最小字符长度。",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_MINIMUM_LENGTH_RECOMMENDED": "需要在6到128之间。",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_TEXT": "密码强度",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_LENGTH_REQUIRMENT_ERROR": "* 无效长度",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_REQUIREMENT_1": "至少需要一个拉丁字母的大写字母 (A-Z)",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_REQUIREMENT_2": "至少需要一个拉丁字母的小写字母（a-z）",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_REQUIREMENT_3": "至少需要一个数字",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_REQUIREMENT_4": "至少需要一个非字母数字字符 (! @ # $ % ^ & * ( ) _ + [ ] { } | ' )",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_REQUIREMENT_ERROR": "密码要求未通过。请查看以下内容。",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_OTHER_REQUIREMENT_1": "启用密码过期",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_OTHER_REQUIREMENT_2": "密码过期需要管理员重置",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_OTHER_REQUIREMENT_3": "允许用户更改他们自己的密码",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_STRENGTH_OTHER_REQUIREMENT_4": "防止密码重复使用",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_OTHER_REQUIREMENTS": "其他要求",
    "RECRUITER_PASSWORD_POLICY_SUBMENU_PASSWORD_VALIDATION": "* 请至少选择一个",
    "Recruiter_Skills_WorkingExperience": "工作经验",
    "Recruiter_Skills_EntrepreneurMindset": "企业家思维",
    "Recruiter_Skills_MotivatingGoals": "激励目标",
    "Recruiter_Skills_Resilience": "韧性",
    "Recruiter_Skills_IndependenceAndSelfReliance": "独立与自我依赖",
    "Recruiter_Skills_WillingnessToBeTrained": "愿意接受培训",
    "Recruiter_Skills_NetworkingAbility": "网络能力",
    "Recruiter_Skills_InterpersonalSkills": "人际交往能力",
    "Recruiter_Layout_Action_UploadLogo_MsgFailed_Scanning": "由于安全扫描，徽标上传失败。请尝试其他文件。",
    "Recruiter_Layout_Action_UploadVideo_MsgFailed_Scanning": "视频上传失败，原因是安全扫描。请尝试其他文件。",
    "Recruiter_AccountSetting_ProfilePicture_ScanFailed": "上传头像失败，原因是安全扫描未通过。请尝试使用其他文件。",
    "File_Scanning_In_Progress": "文件扫描中。请稍候...",
    "File_Not_Found": "未找到文件。请再试一次。",
    "Access denied: File quarantined": "访问被拒：文件已隔离",
    "Security check failed": "安全检查失败"
};